import React, { useState, useEffect, useRef } from "react";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import { getFunctions, httpsCallable } from 'firebase/functions';


import { createPortal } from "react-dom";

import {
  getDownloadURL,
  listAll,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getStorage,
  deleteObject,
} from "@firebase/storage";


import Students from "./Mapofstudentsdatabase/Mapofstudentsdatabase";
import Passes from "./Mapofpassesforteacher/Mapofpassesforteacher";




import axios from "axios";

// eslint-disable-next-line
import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
  redirect,
} from "react-router-dom";

import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";

import NavBar from "./Navbar";

import "./App.css";


pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;


const DEFAULT_CORRECTING_SCORING_SETTINGS = Object.freeze({
  allowUnsimplifiedEquivalentRadicals: false,
  decimalPrecisionRequirement: 'exact', // Defaults back to your rigid check structure
});


const DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS = Object.freeze({
  mode: 'raw-score',
  fixedTotalPoints: 100,
  curvedTopScorePercent: 100,
  curvedBottomScorePercent: 0,
});

const CORRECTING_GRADE_SCALE_OPTIONS = Object.freeze([
  {
    value: 'raw-score',
    label: 'Use raw score',
    description: 'Keep the score as correct items out of the detected total.',
  },
  {
    value: 'fixed-total-points',
    label: 'Scale to a fixed total',
    description: 'Reweight each correct item so the Google Classroom assignment total matches your chosen points.',
  },
  {
    value: 'curve-top-score',
    label: 'Curve so the top score hits a target percent',
    description: 'Scale everyone proportionally so the highest detected raw score becomes your chosen percent.',
  },
  {
    value: 'curve-bottom-score',
    label: 'Curve so the bottom score hits a target percent',
    description: 'Scale everyone proportionally so the lowest detected raw score, becomes your chosen percent.',
  },
]);

const CORRECTING_GRADING_NORMS = Object.freeze([
  {
    key: 'allowUnsimplifiedEquivalentRadicals',
    type: 'checkbox',
    label: 'Accept unsimplified equivalent radicals',
    description: 'Accept radical answers that are mathematically equivalent even if not fully simplified...',
    // Function that returns the rule only if checked (true)
    getPrompt: (isEnabled) => isEnabled
      ? `- RADICAL SIMPLIFICATION: Accept radical answers that are mathematically equivalent even if not fully simplified. For example, treat "n = √84" as correct even if the answer key states "n = 2√21".`
      : `- RADICAL SIMPLIFICATION: Radicals must be fully simplified. If the answer key reads "2√21", an unsimplified equivalent like "√84" must be marked INCORRECT.`
  },
  {
    key: 'decimalPrecisionRequirement',
    type: 'select',
    label: 'Decimal precision requirement',
    description: 'Specify the minimum match threshold rule required for evaluating supplied student decimal inputs.',
    options: [
      {
        value: 'exact',
        label: 'Exact matches only',
        AIprompt: '- DECIMAL PRECISION: Decimal answers must be exact matches to the answer key. Do not allow rounding discrepancies.'
      },
      {
        value: 'hundredths',
        label: 'Corrections will compare down to the nearest hundredth (.01)',
        AIprompt: '- DECIMAL PRECISION: Round both the student answer and the answer key to the nearest hundredth (2 decimal places) before comparing. Mark correct if they match at this precision.'
      },
      {
        value: 'tenths',
        label: 'Corrections will compare down to the nearest tenth (.1)',
        AIprompt: '- DECIMAL PRECISION: Round both the student answer and the answer key to the nearest tenth (1 decimal place) before comparing. Mark correct if they match at this precision.'
      },
      {
        value: 'whole',
        label: 'Corrections will compare down to the nearest whole number (1)',
        AIprompt: '- DECIMAL PRECISION: Round both the student answer and the answer key to the nearest whole number before comparing. Mark correct if they match at this precision.'
      }
    ]
  }
]);

// Dictionary of prompt fragments for quick lookups
const RADICAL_PROMPTS = {
  true: "- RADICAL SIMPLIFICATION: Accept radical answers that are mathematically equivalent even if not fully simplified. For example, treat 'n = √84' as correct even if the answer key states 'n = 2√21'.",
  false: "- RADICAL SIMPLIFICATION: Radicals must be fully simplified. If the answer key reads '2√21', an unsimplified equivalent like '√84' must be marked INCORRECT."
};

const DECIMAL_PROMPTS = {
  exact: "- DECIMAL PRECISION: Decimal answers must be exact matches to the answer key. Do not allow rounding discrepancies.",
  hundredths: "- DECIMAL PRECISION: Round both the student answer and the answer key to the nearest hundredth (2 decimal places) before comparing. Mark correct if they match at this precision.",
  tenths: "- DECIMAL PRECISION: Round both the student answer and the answer key to the nearest tenth (1 decimal place) before comparing. Mark correct if they match at this precision.",
  whole: "- DECIMAL PRECISION: Round both the student answer and the answer key to the nearest whole number before comparing. Mark correct if they match at this precision."
};

function normalizeCorrectingScoringSettings(rawSettings = {}) {
  const source = rawSettings && typeof rawSettings === 'object' ? rawSettings : {};

  // Determine raw values with fallbacks
  const radicalState = source.allowUnsimplifiedEquivalentRadicals === true;
  const precisionState = ['whole', 'tenths', 'hundredths', 'exact'].includes(source.decimalPrecisionRequirement)
    ? source.decimalPrecisionRequirement
    : 'exact';

  return {
    // Keep raw booleans/strings for your normal application logic if needed
    allowUnsimplifiedEquivalentRadicals: radicalState,
    decimalPrecisionRequirement: precisionState,

    // 🔥 Dynamic prompt fragments generated on the fly
    radicalPrompt: RADICAL_PROMPTS[radicalState],
    decimalPrompt: DECIMAL_PROMPTS[precisionState]
  };
}


function normalizeCorrectingGradeScaleSettings(rawSettings = {}) {
  const source = rawSettings && typeof rawSettings === 'object' ? rawSettings : {};
  const normalizedMode = String(source.mode || '').trim().toLowerCase();

  // --- FIXED TOTAL POINTS HANDLING ---
  let fixedTotalPoints = DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS.fixedTotalPoints;
  // If explicitly cleared by the user, preserve the empty string or null
  if (source.fixedTotalPoints === "" || source.fixedTotalPoints === null) {
    fixedTotalPoints = "";
  } else {
    const parsedFixedTotalPoints = Number(source.fixedTotalPoints);
    if (Number.isFinite(parsedFixedTotalPoints) && parsedFixedTotalPoints >= 0) {
      fixedTotalPoints = Number(parsedFixedTotalPoints.toFixed(2));
    }
  }

  let curvedTopScorePercent = DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS.curvedTopScorePercent;

  if (source.curvedTopScorePercent === "" || source.curvedTopScorePercent === null) {
    curvedTopScorePercent = "";
  } else {
    const parsedCurvedTopScorePercent = Number(source.curvedTopScorePercent);
    if (Number.isFinite(parsedCurvedTopScorePercent) && parsedCurvedTopScorePercent >= 0) {
      curvedTopScorePercent = Math.min(120, Number(parsedCurvedTopScorePercent.toFixed(2)));
    }
  }


  // --- CURVED BOTTOM SCORE PERCENT HANDLING ---
  let curvedBottomScorePercent = DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS.curvedBottomScorePercent;
  if (source.curvedBottomScorePercent === "" || source.curvedBottomScorePercent === null) {
    curvedBottomScorePercent = "";
  } else {
    const parsedCurvedBottomScorePercent = Number(source.curvedBottomScorePercent);
    if (Number.isFinite(parsedCurvedBottomScorePercent) && parsedCurvedBottomScorePercent >= 0) {
      curvedBottomScorePercent = Math.min(100, Number(parsedCurvedBottomScorePercent.toFixed(2)));
    }
  }


  return {
    mode: CORRECTING_GRADE_SCALE_OPTIONS.some((option) => option.value === normalizedMode)
      ? normalizedMode
      : DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS.mode,

    fixedTotalPoints, // Applied fix
    curvedBottomScorePercent,
    curvedTopScorePercent, // Applied fix to your first input as well
  };
}


function describeCorrectingGradeScaleSettings(rawSettings = {}) {
  const settings = normalizeCorrectingGradeScaleSettings(rawSettings);

  if (settings.mode === 'fixed-total-points') {
    return `Scaled to ${settings.fixedTotalPoints} total points`;
  }

  if (settings.mode === 'curve-top-score') {
    return `Curved so the highest score becomes ${settings.curvedTopScorePercent}%`;
  }

  if (settings.mode === 'curve-bottom-score') {
    return `Curved so the lowest score, becomes ${settings.curvedBottomScorePercent}%`;
  }

  return 'Raw score';
}

// Pure function — no side-effects. Takes the stored activeGradingSnapshot and
// the current (possibly local-draft) scale settings and returns an array of
// { label, scaledDisplay, rawPct } entries that can be rendered immediately.
function computeScaledGradesPreview(snapshot, settings) {
  if (!snapshot) return null;
  const students = Array.isArray(snapshot.students) ? snapshot.students : [];
  if (students.length === 0) return null;

  const normalized = normalizeCorrectingGradeScaleSettings(settings);

  const rawEntries = students.map((s, i) => {
    const label = String(s.student_name || s.studentLabel || s.name || s.firstName || `Student ${i + 1}`).trim();
    const rawScore = Number(s.rawScoreAdjusted ?? s.rawScore ?? s.correctCount ?? s.score ?? 0);
    const maxScore = Math.max(1, Number(s.rawScoreTotal ?? s.maxRawScore ?? s.totalQuestions ?? s.maxScore ?? s.maxPoints ?? 1));
    return { label, rawScore, maxScore };
  }).filter(s => s.label);

  if (rawEntries.length === 0) return null;

  const rawPercentages = rawEntries.map(s => s.rawScore / s.maxScore);
  const maxRawPct = Math.max(...rawPercentages, 0);
  const minRawPct = Math.min(...rawPercentages, 0);

  return rawEntries.map((s, i) => {
    const rawPct = rawPercentages[i];
    let scaledDisplay;

    if (normalized.mode === 'fixed-total-points') {
      const total = Number(normalized.fixedTotalPoints);
      if (!Number.isFinite(total) || total <= 0) {
        scaledDisplay = '—';
      } else {
        scaledDisplay = `${(rawPct * total).toFixed(1)} / ${total}`;
      }
    } else if (normalized.mode === 'curve-top-score') {
      const targetPct = Number(normalized.curvedTopScorePercent);
      if (!Number.isFinite(targetPct)) {
        scaledDisplay = '—';
      } else if (maxRawPct === 0) {
        scaledDisplay = `${targetPct.toFixed(1)}%`;
      } else {
        scaledDisplay = `${Math.min(120, (rawPct / maxRawPct) * targetPct).toFixed(1)}%`;
      }
    } else if (normalized.mode === 'curve-bottom-score') {
      const targetPct = Number(normalized.curvedBottomScorePercent);
      if (!Number.isFinite(targetPct)) {
        scaledDisplay = '—';
      } else if (maxRawPct === minRawPct) {
        scaledDisplay = `${targetPct.toFixed(1)}%`;
      } else {
        const scaled = targetPct + ((rawPct - minRawPct) / (maxRawPct - minRawPct)) * (100 - targetPct);
        scaledDisplay = `${Math.min(100, Math.max(0, scaled)).toFixed(1)}%`;
      }
    } else {
      scaledDisplay = `${s.rawScore} / ${s.maxScore}`;
    }

    return { label: s.label, scaledDisplay, rawPct };
  });
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      componentTrace: props.componentName || "Unknown component"
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }



  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error(`Error in ${this.state.componentTrace}:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-container" style={{
          padding: '15px',
          margin: '10px 0',
          border: '1px solid #f5c6cb',
          borderRadius: '4px',
          backgroundColor: '#f8d7da',
          color: '#721c24'
        }}>
          <h3>Something went wrong rendering this component.</h3>
          <details>
            <summary>Error Details</summary>
            <p>{this.state.error && this.state.error.toString()}</p>
            <p>Component: {this.state.componentTrace}</p>
          </details>
          {this.props.fallback ||
            <button
              onClick={() => this.setState({ hasError: false })}
              style={{ padding: '8px 12px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
            >
              Try Again
            </button>
          }
        </div>
      );
    }

    return this.props.children;
  }
}

const SimplifiedStudents = (props) => {
  return <div>Students component with {props.currentclass?.length} students</div>;
}

function App(props) {
  // eslint-disable-line no-unused-vars




  const location = useLocation();
  const functions = getFunctions();
  const [responseMessage, setResponseMessage] = useState('');




  const passedTemparray = location.state?.temparray || JSON.parse(localStorage.getItem("myclasses") || "[]");


  console.log(location);

  const { only2studentid, studentid, classid, language, role, id } =
    useParams();

  useEffect(() => {
    // Try to get ID from URL params first
    if (id) {
      console.log("ID from URL params:", id);
      setId2(id);
      setTeacherid(id);
      setTeacheridforreturn(id);

    }
    // Fall back to location state if available
    else if (location.state?.id) {
      console.log("ID from location state:", location.state.id);
      setId2(location.state.id);
      setTeacherid(location.state.id);
      setTeacheridforreturn(location.state.id);
    }
    // No ID available
    else {
      console.error("No ID found in URL params or location state");
      // Handle missing ID (show message, redirect, etc.)
    }
  }, [id, location.state]);




  console.log("MainMenu.js is loaded");

  const [id2, setId2] = useState();
  const [donotshow, setDonotshow] = useState();
  const [temparray, setTemparray] = useState();
  const [selectedclass, setSelectedclass] = useState("");

  const [activeid, setActiveid] = useState("123");
  const activeidRef = useRef("123");
  const [activestudentlist, setActivestudentlist] = useState();

  const [activestudentlist2, setActivestudentlist2] = useState([]);

  const [activename, setActivename] = useState("");
  const [activeperiod, setActiveperiod] = useState("");
  const [gclassroomid, setGclassroomid] = useState("");
  const [gclassroomname, setGclassroomname] = useState("");

  const [currentclass, setCurrentclass] = useState();

  const [currentstudent, setCurrentstudent] = useState();
  const [studentidd, setStudentidd] = useState();

  const [parentlanguagecode, setParentlanguagecode] = useState();

  const [isMobile, setIsMobile] = useState(false);

  const [additionallinklevel, setAdditionallinklevel] = useState();

  const [showcurrentroster, setShowcurrentroster] = useState(false);

  const [showcurrentpasses, setShowcurrentpasses] = useState(false);

  useEffect(() => {
    activeidRef.current = activeid;
  }, [activeid]);
  const [school, setSchool] = useState("");
  const [town, setTown] = useState("");
  const [state, setState] = useState("");

  const [getschoolid, setGetschoolid] = useState();
  const [userdatabefore, setUserdatabefore] = useState();
  const [empty, setEmpty] = useState(false);
  const [userdata2, setUserdata2] = useState([]);
  const [passlist, setPasslist] = useState("");

  const [currentpass, setCurrentpass] = useState();

  const [currentpassid, setCurrentpassid] = useState();

  const [editparentcontactinfo, setEditparentcontactinfo] = useState(false);

  const [drinkwater, setDrinkwater] = useState();
  const [broom, setBroom] = useState();
  const [otherpass, setOtherpass] = useState();

  const [coursename, setCoursename] = useState();
  const [activeid2, setActiveid2] = useState();
  const [linkedclass, setLinkedclass] = useState();
  const [teacherid, setTeacherid] = useState();
  const [teacheridforreturn, setTeacheridforreturn] = useState();
  const [teacher, setTeacher] = useState();
  const [currentlocation, setCurrentlocation] = useState("From Class");

  const [location2, setLocation2] = useState();


  const [accesstoken, setAccesstoken] = useState();
  const [refreshtoken, setRefreshtoken] = useState();
  const [expiryDate, setExpiryDate] = useState();

  const [pdfFileUrl, setPdfFileUrl] = useState(null); // for Viewer
  const [pdfText, setPdfText] = useState(null);
  const [createaclass, setCreateaclass] = useState(false);

  const [coursename2, setCoursename2] = useState();
  const [period2, setPeriod2] = useState();
  const [location5, setLocation5] = useState();

  const [drinkpasslocal, setDrinkpasslocal] = useState();
  const [bathroompasslocaal, setBathroompasslocal] = useState();
  const [nonbathroompasslocal, setNonbathroompasslocal] = useState();

  const [teacheriscalled, setTeacheriscalled] = useState();

  const [townlocal, setTownlocal] = useState();
  const [statelocal, setStatelocal] = useState();
  const [schoollocal, setSchoollocal] = useState();

  const [email, setEmail] = useState("");

  const [showpdfgetter, setShowpdfgetter] = useState(false);
  const [showCourseDocsButtons, setShowCourseDocsButtons] = useState(false);
  const pdfPickerRef = useRef(null);
  const courseDocsButtonsRef = useRef(null);
  const [showCorrectAssignmentModal, setShowCorrectAssignmentModal] = useState(false);
  const [showStudentCodeHelperModal, setShowStudentCodeHelperModal] = useState(false);
  const [correctAssignmentTooltip, setCorrectAssignmentTooltip] = useState(null);
  const [answerSheetPdf, setAnswerSheetPdf] = useState([]);
  const [testsToSolvePdf, setTestsToSolvePdf] = useState([]);
  const [studentWorkPdf, setStudentWorkPdf] = useState([]);
  // Bumping this key remounts the correcting file inputs so that when we clear
  // the selected-file state programmatically (e.g. after a successful save) the
  // uncontrolled <input type="file"> elements also drop their displayed
  // filenames, keeping the UI in sync with state.
  const [correctingFileInputResetKey, setCorrectingFileInputResetKey] = useState(0);
  // True while a title-change reset of the active answer-key record is being
  // written to Firestore. The file inputs stay locked until this completes so a
  // subsequent answer-key submission cannot race ahead of (and be overwritten
  // by) the reset write.
  const [correctingTitleResetPending, setCorrectingTitleResetPending] = useState(false);
  const [correctingGenerating, setCorrectingGenerating] = useState(false);
  const [correctingProgressMessage, setCorrectingProgressMessage] = useState("");
  // Smooth, time-based progress estimate for the correcting workflow (answer-key
  // processing and student-file grading). The backend runs as a single long request
  // with no streamed progress, so this eases toward ~92% while work is in flight and
  // snaps to 100% on completion. 0 means idle (the bar is hidden but still reserves space).
  const [correctingProgress, setCorrectingProgress] = useState(0);
  const correctingProgressTimersRef = useRef({ interval: null, resetTimeout: null });
  const correctingProgressDebugRef = useRef({ runId: 0, source: "idle", lastBucket: -1 });
  const [correctingModalError, setCorrectingModalError] = useState(null);
  const [correctingOrientationIssue, setCorrectingOrientationIssue] = useState(null);
  const [correctingReport, setCorrectingReport] = useState(null);
  const [correctingPrimaryActionFeedback, setCorrectingPrimaryActionFeedback] = useState("");
  const [pendingHandwritingReviews, setPendingHandwritingReviews] = useState([]);
  const [handwritingReviewChoices, setHandwritingReviewChoices] = useState({});
  const [resolvingHandwritingReviewId, setResolvingHandwritingReviewId] = useState(null);
  const [handwritingReviewError, setHandwritingReviewError] = useState(null);
  const [selectedAnswerVersionPreviewId, setSelectedAnswerVersionPreviewId] = useState("");
  const [correctingAnswerSourceMode, setCorrectingAnswerSourceMode] = useState(() => {
    const storedMode = localStorage.getItem("correctingAnswerSourceMode");
    return storedMode === "solve-test" ? "solve-test" : "answer-key";
  });


  const handleCorrectingNormChange = (key, value) => {
    const previousSettings = normalizeCorrectingScoringSettings(correctingScoringSettings);

    // 2. Determine the new value (handle boolean toggle vs dropdown value)
    const updatedValue = value !== undefined ? value : !previousSettings?.[key];

    const nextSettings = normalizeCorrectingScoringSettings({
      ...previousSettings,
      [key]: updatedValue,
    });

    // 3. Update local state immediately so UI changes
    setCorrectingScoringSettings(nextSettings);
    setCorrectingModalError(null);
    setCorrectingNormsStatus({ type: "saving", message: "Saving grading norms for this class..." });

    // 4. Persist to Firebase
    try {
      persistCorrectingScoringSettings(nextSettings);
      setCorrectingNormsStatus({
        type: "saved",
        message: activeid && activeid !== "123"
          ? "Saved to this class. Future correcting runs will use these norms."
          : "These defaults are ready to use.",
      });
    } catch (error) {
      console.error("[Correcting] Failed to save grading norms:", error);
      // Rollback to previous state if Firebase fails
      setCorrectingScoringSettings(previousSettings);
      setCorrectingNormsStatus({ type: "error", message: "Could not save grading norms for this class." });
      setCorrectingModalError("Could not save grading norms for this class. Please try again.");
    }
  };

  const startProgressDebugRun = (source, metadata = {}) => {
    correctingProgressDebugRef.current.runId += 1;
    correctingProgressDebugRef.current.source = source;
    correctingProgressDebugRef.current.lastBucket = -1;
    const runId = correctingProgressDebugRef.current.runId;
    console.log(`[ProgressDebug][run ${runId}][${source}] started`, {
      ...metadata,
      correctingGenerating,
      correctingProgress,
    });
    return runId;
  };

  const logProgressDebug = (message, metadata = {}) => {
    const { runId, source } = correctingProgressDebugRef.current;
    const payload = {
      ...metadata,
      correctingGenerating,
      correctingProgress,
      timestamp: new Date().toISOString(),
    };

    if (typeof window !== "undefined") {
      const existingLogs = Array.isArray(window.__progressDebugEvents)
        ? window.__progressDebugEvents
        : [];
      const nextLogs = [
        ...existingLogs,
        { runId, source, message, ...payload },
      ].slice(-200);
      window.__progressDebugEvents = nextLogs;
    }

    console.log(`[ProgressDebug][run ${runId}][${source}] ${message}`, payload);
  };

  // Drives the correcting progress bar. While a run is generating, ease the estimate
  // toward a ceiling (~92%) so it always feels like it is moving without ever claiming
  // completion early. On finish, snap to 100% briefly, then reset to 0 (idle/hidden).
  useEffect(() => {
    const timers = correctingProgressTimersRef.current;
    const clearTimers = () => {
      if (timers.interval) {
        clearInterval(timers.interval);
        timers.interval = null;
      }
      if (timers.resetTimeout) {
        clearTimeout(timers.resetTimeout);
        timers.resetTimeout = null;
      }
    };

    logProgressDebug("correctingGenerating changed", { nextGenerating: correctingGenerating });

    if (correctingGenerating) {
      clearTimers();
      logProgressDebug("starting progress interval", { ceiling: 92, tickMs: 450 });
      setCorrectingProgress((current) => (current > 0 && current < 100 ? current : 6));
      const ceiling = 92;
      timers.interval = setInterval(() => {
        setCorrectingProgress((current) => {
          if (current >= ceiling) {
            return current;
          }
          // Approach the ceiling asymptotically: larger steps early, smaller near the top.
          const next = current + Math.max(0.4, (ceiling - current) * 0.045);
          return next >= ceiling ? ceiling : next;
        });
      }, 450);
    } else {
      clearTimers();
      logProgressDebug("stopping progress interval");
      // Only animate to 100% if a run was actually in progress (bar already showing).
      setCorrectingProgress((current) => {
        if (current <= 0) {
          return 0;
        }
        timers.resetTimeout = setTimeout(() => setCorrectingProgress(0), 650);
        return 100;
      });
    }

    return clearTimers;
  }, [correctingGenerating]);

  useEffect(() => {
    const bucket = Math.floor(correctingProgress / 10);
    const wasBucket = correctingProgressDebugRef.current.lastBucket;
    const shouldLog =
      correctingProgress === 0
      || correctingProgress >= 100
      || bucket !== wasBucket;

    if (shouldLog) {
      correctingProgressDebugRef.current.lastBucket = bucket;
      logProgressDebug("progress changed", { value: correctingProgress, bucket });
    }
  }, [correctingProgress]);

  const [selectedStudents, setSelectedStudents] = useState([]);

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [notFoundStudents, setNotFoundStudents] = useState([]);
  const [updateSummary, setUpdateSummary] = useState("");

  const [needtoslect, setNeedtoslect] = useState(true);
  const [localemailaddress, setLocalemailaddress] = useState("");

  const [processingtrue, setProcessingtrue] = useState(false);
  const [assignmentname1, setAssignmentname1] = useState("");
  const [assignmentid1, setAssignmentid1] = useState("")

  const [minutespromptingemail, setMinutespromptingemail] = useState(100);
  const [whowillbeemailed, setWhowillemailed] = useState(0);
  const [newgreeting, setNewgreeting] = useState("");
  const [newgreetinga, setNewgreetinga] = useState("");

  const [totaltimegone, setTotaltimegone] = useState(0);

  const [emailll, setEmailll] = useState();
  const [parentemailll, setParentemailll] = useState();

  const [returnedzero, setReturnedzero] = useState();
  const [leftclassonpass, setLeftclassonpass] = useState();

  const [parentlangcode, setParentlangcode] = useState();
  const [locallanguagecode, setLocallanguagecode] = useState();

  const [sendEmail, setSendEmail] = useState(false);
  const [studentfirstname, setStudentfirstname] = useState();

  const [classid2, setClassid2] = useState();
  const [studentid2, setStudentid2] = useState();
  const [bathroompasslimit, setBathroompasslimit] = useState();

  const [last10updated, setLast10updated] = useState();

  const [parentorstudentnote, setParentorstudentnote] = useState();
  const [emailReportModalVisible, setEmailReportModalVisible] = useState(false);
  const [emailSenderAccount, setEmailSenderAccount] = useState("");
  const [emailRequestedCount, setEmailRequestedCount] = useState(0);
  const [emailSentCount, setEmailSentCount] = useState(0);
  const [emailFailedCount, setEmailFailedCount] = useState(0);
  const [emailSentFolderConfirmedCount, setEmailSentFolderConfirmedCount] = useState(0);
  const [emailSentFolderUnverifiedCount, setEmailSentFolderUnverifiedCount] = useState(0);
  const [emailFailedRecipients, setEmailFailedRecipients] = useState([]);
  const [emailModalMessage, setEmailModalMessage] = useState("");
  const [emailSendStatus, setEmailSendStatus] = useState("success");
  const [emailCountsNotReported, setEmailCountsNotReported] = useState({
    requested: false,
    sent: false,
    failed: false,
    sentFolderConfirmed: false,
    sentFolderUnverified: false,
  });

  const [showSyllabusModal, setShowSyllabusModal] = useState(false);
  const [syllabusInfo, setSyllabusInfo] = useState(null);
  const [syllabusModalLoading, setSyllabusModalLoading] = useState(false);
  const [syllabusModalError, setSyllabusModalError] = useState(null);
  const [syllabusGenerating, setSyllabusGenerating] = useState(false);

  const [showCurriculumMapModal, setShowCurriculumMapModal] = useState(false);
  const [curriculumMapInfo, setCurriculumMapInfo] = useState(null);
  const [curriculumMapModalLoading, setCurriculumMapModalLoading] = useState(false);
  const [curriculumMapModalError, setCurriculumMapModalError] = useState(null);
  const [curriculumMapGenerating, setCurriculumMapGenerating] = useState(false);
  const [showAnswerSheetModal, setShowAnswerSheetModal] = useState(false);
  const [answerSheetInfo, setAnswerSheetInfo] = useState(null);
  const [activeAnswerKeyInfo, setActiveAnswerKeyInfo] = useState(null);

  const [activegradesfromscaling, setActivegradesfromscaling] = useState(null);
  const [activeAnswerKeyInfoVersionsArray, setActiveAnswerKeyInfoVersionsArray] = useState([]);
  const [correctingLastGradingRun, setCorrectingLastGradingRun] = useState(null);
  const [answerSheetModalLoading, setAnswerSheetModalLoading] = useState(false);
  const [answerSheetModalError, setAnswerSheetModalError] = useState(null);
  const [answerSheetGenerating, setAnswerSheetGenerating] = useState(false);
  const [answerSheetTeacherKeyFiles, setAnswerSheetTeacherKeyFiles] = useState([]);
  const [linkToStateStandards, setLinkToStateStandards] = useState("");
  const [standardsInputVisible, setStandardsInputVisible] = useState(false);
  const [standardsUrlDraft, setStandardsUrlDraft] = useState("");

  const [newassignmentname, setNewassignmentname] = useState("");
  const [correctingSpecialInstructions, setCorrectingSpecialInstructions] = useState("");
  const [correctingScoringSettings, setCorrectingScoringSettings] = useState(() => normalizeCorrectingScoringSettings(DEFAULT_CORRECTING_SCORING_SETTINGS));
  const [correctingGradeScaleSettings, setCorrectingGradeScaleSettings] = useState(() => normalizeCorrectingGradeScaleSettings(DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS));
  const [correctingNormsStatus, setCorrectingNormsStatus] = useState(null);
  const [correctingGradeScaleStatus, setCorrectingGradeScaleStatus] = useState(null);
  // Draft copy of grade scale settings used for local preview only.
  // Nothing is saved to Firestore/Classroom until the teacher clicks Save Scores.
  const [localGradeScaleSettings, setLocalGradeScaleSettings] = useState(null);
  const [correctingSavingScaledScores, setCorrectingSavingScaledScores] = useState(false);
  const [showCorrectingSpecialInstructions, setShowCorrectingSpecialInstructions] = useState(false);
  const [showCorrectingGradingNorms, setShowCorrectingGradingNorms] = useState(false);
  const [showCorrectingGradeScale, setShowCorrectingGradeScale] = useState(false);
  const [showCorrectingActiveAnswerSheets, setShowCorrectingActiveAnswerSheets] = useState(false);
  const [answerSheetAssignmentTitle, setAnswerSheetAssignmentTitle] = useState("");
  const [answerSheetVersionCount, setAnswerSheetVersionCount] = useState("1");

  const [googleclassroomassignmentid, setGoogleclassroomassignmentid] = useState("");
  const hasUserEditedCorrectingAssignmentTitleRef = useRef(false);
  // Guards against re-entrant/duplicate title-reset writes while a previous
  // reset of the active answer-key record is still in flight.
  const correctingTitleResetInFlightRef = useRef(false);

  const [answerKeyNameForRemoval, setAnswerKeyNameForRemoval] = useState("");

  // Locks the height of the correcting-modal content region to the height of the
  // three primary inputs, so the show/hide buttons below never shift when a panel
  // opens. Taller panels scroll inside the locked area; shorter panels are
  // vertically centered.


  const fileInputRef = useRef(null);
  const pendingCorrectingModalSnapshotSyncRef = useRef(false);


  const handleFileChangeaddanswerkeys = (event) => {

    setAnswerSheetPdf(Array.from(event.target.files || []));
    setCorrectingModalError(null);
    setCorrectingOrientationIssue(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");
  };

  const clearFileInput = () => {
    // 1. Reset the underlying DOM value to clear the UI string
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    // 2. Clear your React state
    resetCorrectingModalToStoredState();
  };




  const correctingInputsMeasureRef = useRef(null);
  const [correctingInputsHeight, setCorrectingInputsHeight] = useState(null);

  // Measure the three primary inputs whenever they are visible and keep the
  // measured height in state so panels can reuse it as a fixed content height.

  // 🔍 DIAGNOSTIC LOGS
  console.log("------------------ FIREBASE CHECK ------------------");
  console.log("1. Web App Project ID:", firebase?.app?.options?.projectId || "Missing Config!");
  console.log("2. Web App Database URL:", firebase?.app?.options?.databaseURL || "Default/Cloud");
  try {
    const testRef = collection(firebase, "classesbeingtaught");
    console.log("3. Target Collection Path:", testRef?.path);
  } catch (e) {
    console.log("3. Target Collection Path Error:", e.message);
  }
  console.log("----------------------------------------------------");

  useEffect(() => {
    if (!temparray || temparray.length === 0) {
      console.log("⚠️ Waiting for temparray to load initial classes before listening...");
      return undefined;
    }

    // 1. SAFETY FILTER: Only listen to items that actually possess a valid string ID
    const validItems = temparray.filter(item => item && typeof item.id === 'string' && item.id.trim() !== '');

    if (validItems.length === 0) {
      console.log("⚠️ temparray has items, but NONE of them contain a valid 'id' property. Skipping listener setup.");
      return undefined;
    }

    console.log(`🟢 MainMenu: Safely initializing background sync for ${validItems.length} valid documents...`);

    // 2. Map through only the valid items
    const unsubscribers = validItems.map((item) => {
      const classDocRef = doc(firebase, "classesbeingtaught", item.id);

      return onSnapshot(
        classDocRef,
        (docSnap) => {
          if (!docSnap.exists()) return;

          const freshData = docSnap.data() || {};
          const documentId = docSnap.id;

          const currentActiveId = activeidRef.current;
          console.log(`🎯 Background Sync triggered for class: ${documentId} ${currentActiveId} ${freshData} Background Sync triggered for class:`);

          // Update item inside state and localStorage seamlessly


          // Keep active view states synced if this happens to be the active class
          if (currentActiveId && documentId === currentActiveId) {
            setSelectedclass(freshData);
            setActiveAnswerKeyInfo(freshData.activeAnswerKeyAssignment || null);
            setActivegradesfromscaling(freshData.activeGradingSnapshot || null);

            const latestVersions = freshData.activeAnswerKeyAssignment?.versions;
            setActiveAnswerKeyInfoVersionsArray(
              latestVersions && typeof latestVersions === "object" ? latestVersions : {},
            );
            setGoogleclassroomassignmentid(freshData.activeAnswerKeyAssignment?.gcassignmentId || "");
            logProgressDebug("active class snapshot set progress to 100", { documentId });
            setCorrectingProgress(100);

            pendingCorrectingModalSnapshotSyncRef.current = true;
          }

          setTemparray((prevArray) => {
            const updatedArray = prevArray.map((classItem) =>
              classItem.id === documentId ? { ...freshData, id: documentId } : classItem
            );
            localStorage.setItem("myclasses", JSON.stringify(updatedArray));
            return updatedArray;
          });



        },
        (error) => {
          console.error(`🔴 Rule/Network error on document ${item.id}:`, error.message);
        }
      );
    });

    // 3. CLEANUP
    return () => {
      console.log("❌ MainMenu: Cleared background listeners.");
      unsubscribers.forEach((unsubscribe) => unsubscribe());
    };

  }, [temparray?.length]);

  useEffect(() => {
    if (!showCorrectAssignmentModal) {
      return;
    }

    if (!pendingCorrectingModalSnapshotSyncRef.current) {
      return;
    }

    pendingCorrectingModalSnapshotSyncRef.current = false;

    if (Array.isArray(answerSheetPdf) && answerSheetPdf.length > 0) {
      logProgressDebug("post-snapshot correcting modal sync", {
        answerSheetCount: answerSheetPdf.length,
      });
      clearFileInput();
    }
  }, [
    showCorrectAssignmentModal,
    answerSheetPdf.length,
    selectedclass,
    activeAnswerKeyInfo,
    activegradesfromscaling,
    activeAnswerKeyInfoVersionsArray,
    googleclassroomassignmentid,
  ]);

  async function saveanswerkeys() {
    startProgressDebugRun("saveanswerkeys", {
      activeid,
      assignmentTitle: newassignmentname,
      answerSheetCount: Array.isArray(answerSheetPdf) ? answerSheetPdf.length : 0,
    });
    logProgressDebug("setCorrectingGenerating(true)");

    setCorrectingGenerating(true);
    console.log("newassignmentname:", newassignmentname, "activeid:", activeid);

    try {
      // Check if the user actually uploaded any student files
      if (!answerSheetPdf || answerSheetPdf.length === 0) {
        logProgressDebug("early return: no answer sheet file selected");
        setResponseMessage("Please select a student PDF file first.");
        return;
      }

      setResponseMessage('Uploading PDF sheets to cloud secure storage...');
      const storage = getStorage();
      const targetFile = answerSheetPdf[0]; // Grabbing the first selected file

      // 1. Create a unique path pointer inside your Firebase Cloud Storage bucket
      const fileStoragePath = `answerKeys/_${Date.now()}_${newassignmentname}_${targetFile.name}`;

      setAnswerKeyNameForRemoval(fileStoragePath);

      const storageRef = ref(storage, fileStoragePath);



      // 2. Upload the raw PDF file directly to Firebase Storage
      await uploadBytes(storageRef, targetFile);

      setResponseMessage('Processing handwriting recognition via Python (this may take a few moments)...');

      // 3. Establish the secure connection to your Node backend
      const functions = getFunctions();

      // FIXED: Changed from 'trigger_log_from_frontend' to your new live backend function name
      const runOcrAnalysis = httpsCallable(functions, 'answerKeys');

      // 4. Send the file path pointer over to Node
      const result = await runOcrAnalysis({
        classId: activeid,
        storagePath: fileStoragePath,
        fileName: targetFile.name,
        assignmentName: newassignmentname,
        assignmentTitle: newassignmentname,
        courseId: gclassroomid || null,
        id,
        teacherId: id,
        databasecourseId: activeid,
        email: localemailaddress || null,
        scoringSettings: normalizeCorrectingScoringSettings(correctingScoringSettings),
        gradeScaleSettings: normalizeCorrectingGradeScaleSettings(correctingGradeScaleSettings),
        googleclassroomassignmentid: googleclassroomassignmentid,
      });


      // Log the final array output returned from the live Pix2TeX container
      console.log("Handwriting Output Object Structure:", result.data);
      logProgressDebug("answerKeys callable completed", {
        resultKeys: result?.data ? Object.keys(result.data) : [],
      });
      setResponseMessage('Analysis complete! Check console for full page extractions.');

    } catch (error) {
      console.error("Communication error:", error);
      logProgressDebug("saveanswerkeys failed", { errorMessage: error?.message || String(error) });
      setResponseMessage('Failed to execute handwriting pipeline.');
    }

  }



  async function callnodefinal() {
    if (typeof window !== "undefined") {
      window.__lastCallNodeHandlerRanAt = new Date().toISOString();
    }
    startProgressDebugRun("callnodefinal", {
      activeid,
      assignmentTitle: newassignmentname,
      studentWorkCount: Array.isArray(studentWorkPdf) ? studentWorkPdf.length : 0,
    });
    try {
      // Check if the user actually uploaded any student files
      if (!studentWorkPdf || studentWorkPdf.length === 0) {
        logProgressDebug("early return: no student work file selected");
        setResponseMessage("Please select a student PDF file first.");
        return;
      }

      logProgressDebug("setCorrectingGenerating(true)");
      setCorrectingGenerating(true);

      setResponseMessage('Uploading PDF sheets to cloud secure storage...');
      const storage = getStorage();
      const targetFile = studentWorkPdf[0]; // Grabbing the first selected file

      // 1. Create a unique path pointer inside your Firebase Cloud Storage bucket
      const fileStoragePath = `student_scans/${activeid}/${Date.now()}_${targetFile.name}`;
      const storageRef = ref(storage, fileStoragePath);

      // 2. Upload the raw PDF file directly to Firebase Storage
      await uploadBytes(storageRef, targetFile);

      setResponseMessage('Processing handwriting recognition via Python (this may take a few moments)...');

      // 3. Establish the secure connection to your Node backend
      const functions = getFunctions();

      const getProfile = httpsCallable(functions, 'analyzeStudentAnswers2');

      // 4. Send the file path pointer over to Node
      const result = await getProfile({
        storagePath: fileStoragePath,
        fileName: targetFile.name,
        assignmentTitle: newassignmentname,
        gradeScaleSettings: normalizeCorrectingGradeScaleSettings(correctingGradeScaleSettings),

        // added additional parameters for the backend to process the request
        answerKeys: activeAnswerKeyInfo,
        allowImmediateTaskResult: true,
        preferJsonResponse: true,
        rosterStudents: buildRosterStudentsWithStudentIdentifier(selectedclass?.studentIds || []),
        courseId: gclassroomid || null,
        id,
        teacherId: id,
        databasecourseId: activeid,
        currentUrl: window.location.href,
        redirectUrl: window.location.href,
        email: localemailaddress || null,

        // specialGradingInstructions: trimmedSpecialInstructions || null,

        scoringSettings: normalizeCorrectingScoringSettings(correctingScoringSettings),

        maxPoints: null,
        googleclassroomassignmentid: googleclassroomassignmentid,
        // rosterMatchingMode: "google-classroom-name",
        // ...(answerKeyPdfUrl ? { answerKeyPdfUrl } : {}),
        // ...(answerKeyPdfUrls.length > 0 ? { answerKeyPdfUrls } : {}),
        // ...(testToSolvePdfUrl ? { testToSolvePdfUrl } : {}),
        // ...(testsToSolvePdfUrls.length > 0 ? { testToSolvePdfUrls: testsToSolvePdfUrls } : {}),
        // ...(studentWorkPdfUrl ? { studentWorkPdfUrl } : {}),
        // ...(studentWorkPdfUrls.length > 0 ? { studentWorkPdfUrls } : {}),
      });

      // Log the final array output returned from the live Pix2TeX container
      console.log("Handwriting Output Object Structure:", result.data);
      logProgressDebug("analyzeStudentAnswers2 callable completed", {
        resultKeys: result?.data ? Object.keys(result.data) : [],
      });
      setResponseMessage('Analysis complete! Check console for full page extractions.');

    } catch (error) {
      console.error("Communication error:", error);
      logProgressDebug("callnodefinal failed", { errorMessage: error?.message || String(error) });
      setResponseMessage('Failed to execute handwriting pipeline.');
    } finally {
      logProgressDebug("setCorrectingGenerating(false) in finally");
      setCorrectingGenerating(false);
    }

  }


  //partofoldcorrectingcode
  useEffect(() => {
    const node = correctingInputsMeasureRef.current;
    if (!node) return undefined;
    const updateHeight = () => setCorrectingInputsHeight(node.offsetHeight);
    updateHeight();
    let observer;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(updateHeight);
      observer.observe(node);
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, [
    showCorrectAssignmentModal,
    showCorrectingGradeScale,
    showCorrectingSpecialInstructions,
    showCorrectingGradingNorms,
    showCorrectingActiveAnswerSheets,
  ]);


  useEffect(() => {
    if (correctingProgress >= 100) {
      logProgressDebug("progress >= 100 effect triggered; scheduling reset", { delayMs: 1000 });
      setTimeout(() => {
        logProgressDebug("progress reset timeout fired");
        setCorrectingGenerating(false);
        setCorrectingProgress(0);
      }, 1000);
    }
  }, [correctingProgress, activeAnswerKeyInfo]);

  // Seed the local draft whenever the grade scale panel opens so the preview
  // always starts from the last-saved Firebase value.
  useEffect(() => {
    if (showCorrectingGradeScale) {
      setLocalGradeScaleSettings(normalizeCorrectingGradeScaleSettings(correctingGradeScaleSettings));
    }
  }, [showCorrectingGradeScale]);

  //partofoldcorrectingcode

  async function loadStoredAnswerKeyInfo(resolvedClassId = activeid) {
    if (!resolvedClassId || resolvedClassId === "123") {
      setAnswerSheetInfo(null);
      setActiveAnswerKeyInfo(null);
      setActiveAnswerKeyInfoVersionsArray([]);
      setCorrectingLastGradingRun(null);
      setActivegradesfromscaling(null);
      setCorrectingSpecialInstructions("");
      setCorrectingScoringSettings(normalizeCorrectingScoringSettings(DEFAULT_CORRECTING_SCORING_SETTINGS));
      setCorrectingGradeScaleSettings(normalizeCorrectingGradeScaleSettings(DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS));
      return null;
    }

    const classSnap = await getDoc(doc(firebase, "classesbeingtaught", resolvedClassId));
    console.log("classesbeingtaught get1. loadStoredAnswerKeyInfo");
    if (!classSnap.exists()) {
      setAnswerSheetInfo(null);
      setActiveAnswerKeyInfo(null);
      setActiveAnswerKeyInfoVersionsArray([]);
      setCorrectingLastGradingRun(null);
      setActivegradesfromscaling(null);
      setCorrectingSpecialInstructions("");
      setCorrectingScoringSettings(normalizeCorrectingScoringSettings(DEFAULT_CORRECTING_SCORING_SETTINGS));
      setCorrectingGradeScaleSettings(normalizeCorrectingGradeScaleSettings(DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS));
      return null;
    }

    const data = classSnap.data() || {};
    const sheet = data.answerSheet || null;
    const activeAnswerKey = data.activeAnswerKeyAssignment || null;
    const storedScoringSettings = normalizeCorrectingScoringSettings(
      data.correctAndSendAssignmentsScoringSettings || activeAnswerKey?.scoringSettings || DEFAULT_CORRECTING_SCORING_SETTINGS,
    );
    const storedGradeScaleSettings = normalizeCorrectingGradeScaleSettings(
      data.correctAndSendAssignmentsGradeScaleSettings || DEFAULT_CORRECTING_GRADE_SCALE_SETTINGS,
    );
    const storedSpecialInstructions = typeof data.correctAndSendAssignmentsSpecialInstructions === "string"
      ? data.correctAndSendAssignmentsSpecialInstructions
      : (typeof activeAnswerKey?.specialGradingInstructions === "string" ? activeAnswerKey.specialGradingInstructions : "");
    const storedLastGradingRun = data.correctAndSendAssignmentsLastGradingRun || null;
    const storedActiveGradingSnapshot = data.activeGradingSnapshot || null;

    setActivegradesfromscaling(storedActiveGradingSnapshot);

    setAnswerSheetInfo(sheet);
    setActiveAnswerKeyInfo(activeAnswerKey);
    setActiveAnswerKeyInfoVersionsArray(activeAnswerKey?.versions || []);
    setCorrectingLastGradingRun(storedLastGradingRun);
    setNewassignmentname(activeAnswerKey?.assignmentTitle || "");
    setGoogleclassroomassignmentid(activeAnswerKey?.gcassignmentId || "");
    setCorrectingSpecialInstructions(storedSpecialInstructions || "");
    setCorrectingScoringSettings(storedScoringSettings);
    setCorrectingGradeScaleSettings(storedGradeScaleSettings);
    setCorrectingNormsStatus(null);
    setCorrectingGradeScaleStatus(null);

    return { sheet, activeAnswerKey, storedLastGradingRun, storedSpecialInstructions, storedScoringSettings, storedGradeScaleSettings };
  }


  //partofoldcorrectingcode
  async function persistCorrectingScoringSettings(nextSettings) {
    if (!activeid || activeid === "123") {
      setCorrectingNormsStatus({ type: "idle", message: "These defaults will be used once a class is selected." });
      return;
    }
    const classDocRef = doc(firebase, "classesbeingtaught", activeid);
    console.log("classesbeingtaught get - will need to update state");

    await updateDoc(classDocRef, {
      correctAndSendAssignmentsScoringSettings: normalizeCorrectingScoringSettings(nextSettings),
    });

  }


  //partofoldcorrectingcode
  async function persistCorrectingGradeScaleSettings(nextSettings) {
    if (!activeid || activeid === "123") {
      setCorrectingGradeScaleStatus({ type: "idle", message: "These defaults will be used once a class is selected." });
      return;
    }
    console.log("classesbeingtaught get - will need to update state");
    const classDocRef = doc(firebase, "classesbeingtaught", activeid);
    await updateDoc(classDocRef, {
      correctAndSendAssignmentsGradeScaleSettings: normalizeCorrectingGradeScaleSettings(nextSettings),
    });
  }


  async function handleCorrectingGradeScaleChange(partialSettings) {
    const previousSettings = normalizeCorrectingGradeScaleSettings(correctingGradeScaleSettings);
    const nextSettings = normalizeCorrectingGradeScaleSettings({
      ...previousSettings,
      ...partialSettings,
    });

    if (JSON.stringify(previousSettings) === JSON.stringify(nextSettings)) {
      return;
    }

    setCorrectingGradeScaleSettings(nextSettings);
    setCorrectingModalError(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");
    setCorrectingGradeScaleStatus({ type: "saving", message: "Saving Google Classroom score scaling for this class..." });

    try {
      await persistCorrectingGradeScaleSettings(nextSettings);
      setCorrectingGradeScaleStatus({
        type: "saved",
        message: activeid && activeid !== "123"
          ? "Saved to this class. Future correcting runs will use this Google Classroom scoring scale."
          : "These scoring defaults are ready to use.",
      });
    } catch (error) {
      console.error("[Correcting] Failed to save grade scaling:", error);
      setCorrectingGradeScaleSettings(previousSettings);
      setCorrectingGradeScaleStatus({ type: "error", message: "Could not save Google Classroom score scaling for this class." });
      setCorrectingModalError("Could not save Google Classroom score scaling for this class. Please try again.");
    }
  }

  async function saveScaledScoresToGoogleClassroom() {
    if (!activeid || activeid === "123") {
      setCorrectingGradeScaleStatus({ type: "error", message: "Select a class before saving scaled scores." });
      return;
    }

    if (!activegradesfromscaling || !Array.isArray(activegradesfromscaling.students) || activegradesfromscaling.students.length === 0) {
      setCorrectingGradeScaleStatus({ type: "error", message: "No graded snapshot is available yet for this class." });
      return;
    }

    const draftSettings = normalizeCorrectingGradeScaleSettings(localGradeScaleSettings ?? correctingGradeScaleSettings);

    setCorrectingSavingScaledScores(true);
    setCorrectingGradeScaleStatus({ type: "saving", message: "Saving revised scores to Google Classroom and rebuilding reports..." });
    setCorrectingModalError(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");

    try {
      const saveScaledScoresCallable = httpsCallable(functions, "saveScaledScores");
      const response = await saveScaledScoresCallable({
        databaseCourseId: activeid,
        classId: activeid,
        courseId: gclassroomid || null,
        teacherId: id || null,
        googleclassroomassignmentid: googleclassroomassignmentid || activeAnswerKeyInfo?.gcassignmentId || null,
        assignmentTitle: (newassignmentname || activegradesfromscaling?.fileName || "").trim() || null,
        gradeScaleSettings: draftSettings,
        rosterStudents: buildRosterStudentsWithStudentIdentifier(selectedclass?.studentIds || []),
      });

      const payload = response?.data || {};
      const gradePosting = payload?.gradePosting || {};
      const reportPosting = payload?.reportPosting || {};

      if (payload?.activeGradingSnapshot && typeof payload.activeGradingSnapshot === "object") {
        setActivegradesfromscaling(payload.activeGradingSnapshot);
      }

      setCorrectingGradeScaleSettings(draftSettings);
      setLocalGradeScaleSettings(draftSettings);

      if (payload?.success) {
        setCorrectingGradeScaleStatus({
          type: "saved",
          message: "Saved revised scores to Google Classroom and attached updated reports.",
        });
      } else {
        const gradeReason = gradePosting?.reason || gradePosting?.message || "grade post issue";
        const reportReason = reportPosting?.reason || reportPosting?.message || "report attachment issue";
        setCorrectingGradeScaleStatus({
          type: "error",
          message: `Saved scale locally, but Classroom reported issues (${gradeReason}; ${reportReason}).`,
        });
      }
    } catch (error) {
      console.error("[Correcting] saveScaledScoresToGoogleClassroom failed:", error);
      setCorrectingGradeScaleStatus({ type: "error", message: "Could not save revised scores to Google Classroom." });
      setCorrectingModalError("Could not save revised scores to Google Classroom. Please try again.");
    } finally {
      setCorrectingSavingScaledScores(false);
    }
  }


  //partofoldcorrectingcode

  function openCorrectAssignmentModal() {
    hasUserEditedCorrectingAssignmentTitleRef.current = false;
    setShowCorrectAssignmentModal(true);
    setCorrectingModalError(null);
    setCorrectingOrientationIssue(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");
    setCorrectingNormsStatus(null);
    setCorrectingGradeScaleStatus(null);
    setShowCorrectingSpecialInstructions(false);
    setShowCorrectingGradingNorms(false);
    loadStoredAnswerKeyInfo().catch((error) => {
      console.error("[Correcting] Failed to load stored answer-key info:", error);
    });
  }

  // After the backend confirms a submission, return the modal to the same clean
  // state it would have if the teacher closed and reopened it now that the
  // assignment is saved: drop the already-uploaded files (they are persisted on
  // the backend), clear any orientation prompt, and let the stored assignment
  // title re-sync. With the uploaded answer-source files cleared, the modal is
  // no longer "supplying a new answer source," so the now-stored answer key
  // drives the UI and the student-work step becomes available. The backend
  // report is intentionally preserved so the teacher still sees what happened.

  //partofoldcorrectingcode
  async function resetCorrectingModalToStoredState() {
    setAnswerSheetPdf([]);
    setTestsToSolvePdf([]);
    setStudentWorkPdf([]);
    setCorrectingOrientationIssue(null);
    // Remount the file inputs so their displayed filenames clear along with the
    // selected-file state above.
    setCorrectingFileInputResetKey((previousKey) => previousKey + 1);
    hasUserEditedCorrectingAssignmentTitleRef.current = false;
    await loadStoredAnswerKeyInfo(activeid).catch((error) => {
      console.error("[Correcting] Failed to refresh stored answer-key info after success:", error);
    });
  }

  // Editing the assignment title starts a brand-new assignment. Per the product
  // rule, changing the title clears the stored active answer key for this class
  // so the teacher must establish a fresh key before grading anything. This
  // resets the activeAnswerKeyAssignment map on the class document (versions
  // emptied, counts zeroed, timestamps refreshed) with a direct updateDoc and
  // mirrors the reset into local state immediately so the modal shows the new
  // title with no stored answers — without waiting for the Firestore round trip.

  //partofoldcorrectingcode
  async function commitCorrectingAssignmentTitleChange() {

    console.log("commitCorrectingAssignmentTitleChange called with newassignmentname:", newassignmentname, "activeid:", activeid);
    const trimmedTitle = typeof newassignmentname === "string" ? newassignmentname.trim() : "";
    if (!trimmedTitle || !activeid || activeid === "123") {
      return;
    }

    const storedNormalizedTitle = typeof activeAnswerKeyInfo?.normalizedAssignmentTitle === "string"
      ? activeAnswerKeyInfo.normalizedAssignmentTitle
      : (typeof activeAnswerKeyInfo?.assignmentTitle === "string"
        ? activeAnswerKeyInfo.assignmentTitle.trim().toLowerCase()
        : "");
    const nextNormalizedTitle = trimmedTitle.toLowerCase();

    // Nothing to reset when the title is unchanged, or when there is no stored
    // assignment yet (a brand-new class establishes its first key normally).


    // if (!storedNormalizedTitle || storedNormalizedTitle === nextNormalizedTitle) {
    //   return;
    // }

    // if (correctingTitleResetInFlightRef.current) {
    //   return;
    // }
    correctingTitleResetInFlightRef.current = true;
    setCorrectingTitleResetPending(true);

    const nowIso = new Date().toISOString();
    const resetAnswerKeyRecord = {
      assignmentTitle: trimmedTitle,
      normalizedAssignmentTitle: nextNormalizedTitle,
      gcassignmentId: "",
      versions: [],
      versionCount: 0,
      questionCount: 0,
      range: null,
      sourceAssetCount: 0,
      createdAt: nowIso,
      lastUpdated: nowIso,
    };

    const ActiveGradingSnapshot = {
      allAdjustedScores: [],
      courseId: gclassroomid || null,
      databaseCourseId: activeid,
      fileName: trimmedTitle,
      googleclassroomassignmentid: "",
      gradeScaleSettings: normalizeCorrectingGradeScaleSettings(correctingGradeScaleSettings),
      lastRescaledAt: "",
      maxScore: 0,
      minScore: 0,
      savedAt: "",
      students: [],
    }

    // Clear any previously-selected files immediately, but DO NOT optimistically
    // unlock the inputs: the file inputs remain disabled via
    // correctingTitleResetPending until the Firestore write below resolves. This
    // prevents the teacher from uploading and submitting a new answer key before
    // the reset has committed — which would let the late reset write overwrite
    // the backend's freshly-stored answer-key versions.
    setAnswerSheetPdf([]);
    setTestsToSolvePdf([]);
    setStudentWorkPdf([]);
    setCorrectingOrientationIssue(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");
    setCorrectingFileInputResetKey((previousKey) => previousKey + 1);

     setActivegradesfromscaling(ActiveGradingSnapshot || null);

    try {
      await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
        activeAnswerKeyAssignment: resetAnswerKeyRecord,
        activeGradingSnapshot: ActiveGradingSnapshot,
      });
      // Only after the reset is durably committed do we reflect it locally and
      // unlock the inputs (via the cleared pending flag below).
      setActiveAnswerKeyInfo(resetAnswerKeyRecord);
      setActiveAnswerKeyInfoVersionsArray(resetAnswerKeyRecord.versions || []);
    } catch (error) {
      console.error("[Correcting] Failed to reset active answer-key assignment for the new title:", error);
      setCorrectingModalError("Could not start the new assignment title. Please try again.");
    } finally {
      correctingTitleResetInFlightRef.current = false;
      setCorrectingTitleResetPending(false);
    }
  }

  const parseJsonOrRaw = (value, fallback = "") => {
    if (typeof value === "undefined" || value === null || value === "") {
      return fallback;
    }
    if (typeof value !== "string") {
      return value;
    }
    let decoded = value;
    try {
      decoded = decodeURIComponent(value);
    } catch (e) {
      decoded = value;
    }
    try {
      return JSON.parse(decoded);
    } catch (e) {
      return decoded;
    }
  };

  //partofoldcorrectingcode
  useEffect(() => {
    loadStoredAnswerKeyInfo().catch((error) => {
      console.error("[AnswerKey] Failed to refresh stored answer-key info:", error);
    });
  }, [activeid]);


  const answerKeyDeletionInFlightRef = useRef(false);

  //partofoldcorrectingcode
  useEffect(() => {
    if (!showCorrectAssignmentModal) {
      return;
    }

    if (activeAnswerKeyInfo?.versionCount > 0 && answerKeyNameForRemoval !== "" && !answerKeyDeletionInFlightRef.current) {
      answerKeyDeletionInFlightRef.current = true;  // synchronous — blocks re-entry immediately
      const pathToDelete = answerKeyNameForRemoval;
      setAnswerKeyNameForRemoval("");               // async state clear for future renders

      deleteObject(ref(getStorage(), pathToDelete))
        .then(() => {
          answerKeyDeletionInFlightRef.current = false;
          console.log("Staging file deleted from storage.");
        })
        .catch((error) => {
          answerKeyDeletionInFlightRef.current = false;
          if (error?.code !== "storage/object-not-found") {
            console.error("Error deleting staging file:", error);
          }
        });
    }

    const reportVersions = Array.isArray(correctingReport?.processing?.answerKeyVersionDetails)
      ? correctingReport.processing.answerKeyVersionDetails
      : [];
    const storedVersions = Array.isArray(activeAnswerKeyInfo?.versions)
      ? activeAnswerKeyInfo.versions
      : [];
    const availableVersions = reportVersions.length > 0 ? reportVersions : storedVersions;

    // if (availableVersions.length === 0) {
    //   if (selectedAnswerVersionPreviewId) {
    //     setSelectedAnswerVersionPreviewId("");
    //   }
    //   return;
    // }



    const hasSelectedVersion = availableVersions.some((versionEntry, index) => {
      const versionValue = String(versionEntry?.versionId || `version-${index + 1}`);
      return versionValue === selectedAnswerVersionPreviewId;
    });

    // if (!hasSelectedVersion) {
    //   setSelectedAnswerVersionPreviewId(String(availableVersions[0]?.versionId || "version-1"));
    // }
  }, [showCorrectAssignmentModal, activeAnswerKeyInfo, correctingReport, selectedAnswerVersionPreviewId]);

  const toSafeNumber = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const collectCallbackParams = (url) => {
    const qp = {};

    const addParamsFromString = (paramString) => {
      if (typeof paramString !== "string" || paramString.length === 0) {
        return;
      }
      const search = paramString.startsWith("?") ? paramString.slice(1) : paramString;
      const sp = new URLSearchParams(search);
      for (const [k, v] of sp.entries()) {
        if (typeof qp[k] === "undefined") {
          qp[k] = v;
        }
      }
    };

    try {
      const parsedUrl = new URL(url, window.location.origin);
      addParamsFromString(parsedUrl.search);
      if (parsedUrl.hash.includes("?")) {
        addParamsFromString(parsedUrl.hash.split("?")[1]);
      }
    } catch (e) {
      const qIndex = url.indexOf("?");
      if (qIndex >= 0) {
        addParamsFromString(url.substring(qIndex + 1).split("#")[0]);
      }
      const hIndex = url.indexOf("#");
      if (hIndex >= 0) {
        addParamsFromString(url.substring(hIndex + 1));
      }
    }

    if (typeof qp.url === "string" && qp.url.includes("?")) {
      const nestedQuery = qp.url.split("?")[1].split("#")[0];
      addParamsFromString(nestedQuery);
    }

    return { params: qp };
  };

  const parseEmailResultFromUrl = (url) => {
    try {
      const { params: qp } = collectCallbackParams(url);
      const emailSentPayload = parseJsonOrRaw(qp.emailSent, null);
      const flowCompleted =
        String(parseJsonOrRaw(qp.emailSendFlowCompleted, "false")).toLowerCase() === "true";

      const statusFromUrl = parseJsonOrRaw(qp.emailSendStatus, null);
      const statusFromPayload =
        typeof emailSentPayload?.success === "boolean"
          ? emailSentPayload.success
            ? "success"
            : "failure"
          : null;

      const statusRaw = String(statusFromUrl || statusFromPayload || "unknown").toLowerCase();
      const status =
        statusRaw === "failure"
          ? "failure"
          : statusRaw === "success"
            ? "success"
            : "unknown";

      const failedRaw = parseJsonOrRaw(qp.failedRecipients, []);
      const failedRecipients = Array.isArray(failedRaw)
        ? failedRaw
        : Array.isArray(emailSentPayload?.failedRecipients)
          ? emailSentPayload.failedRecipients
          : typeof failedRaw === "string" && failedRaw.length > 0
            ? [failedRaw]
            : [];

      const getCountOrUnreported = (urlParam, fallbackParam, payloadField) => {
        const urlValue = parseJsonOrRaw(urlParam, null);
        if (urlValue !== null) return toSafeNumber(urlValue, 0);
        const fallbackValue = parseJsonOrRaw(fallbackParam, null);
        if (fallbackValue !== null) return toSafeNumber(fallbackValue, 0);
        const payloadValue = payloadField !== null ? payloadField : null;
        if (payloadValue !== null) return toSafeNumber(payloadValue, 0);
        return "Not reported";
      };

      return {
        flowCompleted,
        status,
        success: status === "success",
        senderEmail: String(
          parseJsonOrRaw(
            qp.emailSendSender,
            parseJsonOrRaw(qp.senderEmail, emailSentPayload?.senderEmail || "")
          )
        ),
        requestedCount: getCountOrUnreported(
          qp.emailSendRequested,
          qp.requestedCount,
          emailSentPayload?.requestedCount
        ),
        sentCount: getCountOrUnreported(
          qp.emailSendSucceeded,
          qp.sentCount,
          emailSentPayload?.sentCount
        ),
        failedCount: getCountOrUnreported(
          qp.emailSendFailed,
          qp.failedCount,
          emailSentPayload?.failedCount
        ),
        sentFolderConfirmedCount: getCountOrUnreported(
          qp.emailSendSentFolderConfirmed,
          qp.sentFolderConfirmedCount,
          emailSentPayload?.sentFolderConfirmedCount
        ),
        sentFolderUnverifiedCount: getCountOrUnreported(
          qp.emailSendSentFolderUnverified,
          qp.sentFolderUnverifiedCount,
          emailSentPayload?.sentFolderUnverifiedCount
        ),
        failedRecipients,
        modalMessage: String(
          parseJsonOrRaw(
            qp.emailSendAlert,
            parseJsonOrRaw(qp.modalMessage, emailSentPayload?.modalMessage || "")
          )
        ),
        alert: String(parseJsonOrRaw(qp.alert, emailSentPayload?.alert || "")),
      };
    } catch (error) {
      console.error("Failed parsing email result URL:", error);
      return null;
    }
  };

  const hydrateEmailSendResultFromFirestore = async (parsedResult) => {
    let hydratedResult = parsedResult && typeof parsedResult === "object" ? parsedResult : {};

    if (!id) {
      return hydratedResult;
    }

    try {
      const userSnap = await getDoc(doc(firebase, "users", id));
      if (!userSnap.exists()) {
        return hydratedResult;
      }

      const userData = userSnap.data() || {};
      const report =
        userData?.emailSendReportPayload && typeof userData.emailSendReportPayload === "object"
          ? userData.emailSendReportPayload
          : {};
      const failedRecipients = Array.isArray(userData?.failedRecipients)
        ? userData.failedRecipients
        : Array.isArray(report?.failedRecipients)
          ? report.failedRecipients
          : [];
      const base = parsedResult && typeof parsedResult === "object" ? parsedResult : {};
      const normalizeStatus = (value) => {
        const normalized = String(value || "unknown").toLowerCase();
        return normalized === "success" || normalized === "failure" ? normalized : "unknown";
      };
      const pickCount = (currentValue, reportValue) => {
        if (currentValue !== "Not reported") return currentValue;
        if (typeof reportValue === "undefined" || reportValue === null) return "Not reported";
        return toSafeNumber(reportValue, 0);
      };
      const mergedStatus =
        base?.status && base.status !== "unknown"
          ? base.status
          : normalizeStatus(report?.emailSendStatus);

      hydratedResult = {
        ...base,
        flowCompleted:
          base?.flowCompleted === true ||
          String(report?.emailSendFlowCompleted || "false").toLowerCase() === "true",
        status: mergedStatus,
        success: mergedStatus === "success",
        senderEmail: base?.senderEmail || String(report?.emailSendSender || ""),
        requestedCount: pickCount(base?.requestedCount, report?.emailSendRequested),
        sentCount: pickCount(base?.sentCount, report?.emailSendSucceeded),
        failedCount: pickCount(base?.failedCount, report?.emailSendFailed),
        sentFolderConfirmedCount: pickCount(
          base?.sentFolderConfirmedCount,
          report?.emailSendSentFolderConfirmed
        ),
        sentFolderUnverifiedCount: pickCount(
          base?.sentFolderUnverifiedCount,
          report?.emailSendSentFolderUnverified
        ),
        failedRecipients:
          Array.isArray(base?.failedRecipients) && base.failedRecipients.length > 0
            ? base.failedRecipients
            : failedRecipients,
        modalMessage: base?.modalMessage || String(report?.emailSendAlert || ""),
        alert: base?.alert || String(report?.emailSendAlert || ""),
      };
    } catch (error) {
      console.warn("Failed to hydrate email result from Firestore:", error);
    }

    return hydratedResult;
  };

  const openEmailReportModal = (payload) => {
    const statusDisplay =
      payload?.status === "failure"
        ? "failure"
        : payload?.status === "unknown"
          ? "unknown"
          : "success";

    setEmailSendStatus(statusDisplay);
    setEmailSenderAccount(payload?.senderEmail || "");
    setEmailCountsNotReported({
      requested: payload?.requestedCount === "Not reported",
      sent: payload?.sentCount === "Not reported",
      failed: payload?.failedCount === "Not reported",
      sentFolderConfirmed: payload?.sentFolderConfirmedCount === "Not reported",
      sentFolderUnverified: payload?.sentFolderUnverifiedCount === "Not reported",
    });
    setEmailRequestedCount(
      payload?.requestedCount === "Not reported" ? 0 : toSafeNumber(payload?.requestedCount, 0)
    );
    setEmailSentCount(
      payload?.sentCount === "Not reported" ? 0 : toSafeNumber(payload?.sentCount, 0)
    );
    setEmailFailedCount(
      payload?.failedCount === "Not reported" ? 0 : toSafeNumber(payload?.failedCount, 0)
    );
    setEmailSentFolderConfirmedCount(
      payload?.sentFolderConfirmedCount === "Not reported"
        ? 0
        : toSafeNumber(payload?.sentFolderConfirmedCount, 0)
    );
    setEmailSentFolderUnverifiedCount(
      payload?.sentFolderUnverifiedCount === "Not reported"
        ? 0
        : toSafeNumber(payload?.sentFolderUnverifiedCount, 0)
    );
    setEmailFailedRecipients(Array.isArray(payload?.failedRecipients) ? payload.failedRecipients : []);
    setEmailModalMessage(payload?.modalMessage || payload?.alert || "");
    setEmailReportModalVisible(true);
  };

  const showNoEmailsSentReport = (requestedCount = 0, reason = "") => {
    const cleanReason = typeof reason === "string" && reason.trim().length > 0 ? reason.trim() : "";

    openEmailReportModal({
      status: "failure",
      senderEmail: "",
      requestedCount: toSafeNumber(requestedCount, 0),
      sentCount: 0,
      failedCount: 0,
      sentFolderConfirmedCount: 0,
      sentFolderUnverifiedCount: 0,
      failedRecipients: [],
      modalMessage: cleanReason ? `No emails sent. ${cleanReason}` : "No emails sent.",
      alert: "No emails sent.",
    });
  };

  const renderEmailReportModal = () => {
    if (!emailReportModalVisible) {
      return null;
    }

    return (
      <div style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}>
        <div style={{
          backgroundColor: "#000",
          border: "2px solid #0F0",
          borderRadius: "10px",
          padding: "24px",
          width: "min(520px, 90vw)",
          textAlign: "center",
          color: "#FFF",
        }}>
          <div style={{ color: "#0F0", fontSize: "22px", fontWeight: "bold", marginBottom: "14px" }}>
            Email Delivery Report
          </div>

          {emailModalMessage ? (
            <div style={{ marginBottom: "12px", lineHeight: 1.5 }}>{emailModalMessage}</div>
          ) : null}

          <div style={{ marginBottom: "10px" }}>
            Status: {emailSendStatus === "failure" ? "Failure" : emailSendStatus === "unknown" ? "Unknown" : "Success"}
          </div>
          <div style={{ marginBottom: "10px" }}>
            Requested: {emailCountsNotReported.requested ? "Not reported" : emailRequestedCount}
          </div>
          <div style={{ marginBottom: "10px" }}>
            Sent: {emailCountsNotReported.sent ? "Not reported" : emailSentCount}
          </div>
          <div style={{ marginBottom: "10px" }}>
            Failed: {emailCountsNotReported.failed ? "Not reported" : emailFailedCount}
          </div>
          <div style={{ marginBottom: "10px" }}>
            Sent folder confirmed: {emailCountsNotReported.sentFolderConfirmed ? "Not reported" : emailSentFolderConfirmedCount}
          </div>
          <div style={{ marginBottom: "10px" }}>
            Sent folder unverified: {emailCountsNotReported.sentFolderUnverified ? "Not reported" : emailSentFolderUnverifiedCount}
          </div>
          <div style={{ marginBottom: "10px" }}>
            Sent from: {emailSenderAccount || "Unknown account"}
          </div>
          {Array.isArray(emailFailedRecipients) && emailFailedRecipients.length > 0 ? (
            <div style={{ marginBottom: "14px", lineHeight: 1.5 }}>
              Failed recipients: {emailFailedRecipients.join(", ")}
            </div>
          ) : null}

          <button
            style={{
              backgroundColor: "#333",
              color: "#0F0",
              border: "1px solid #0F0",
              borderRadius: "5px",
              padding: "10px 18px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={() => setEmailReportModalVisible(false)}
          >
            Close
          </button>
        </div>
      </div>
    );
  };

  async function fetchUserDocAndSetState(userId) {
    if (!userId) {
      console.warn("No user ID provided to fetchUserDocAndSetState");
      return;
    }
    try {
      const docRef = doc(firebase, "users", userId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const userDoc = docSnap.data();

        setDrinkpasslocal(userDoc.drinkpass || "");
        setBathroompasslocal(userDoc.bathroompass || "");
        setNonbathroompasslocal(userDoc.nonbathroompass || "");
        setTeacheriscalled(userDoc.teacheriscalled || "");
        setTownlocal(userDoc.town || "");
        setStatelocal(userDoc.state || "");
        setSchoollocal(userDoc.school || "");
        setLocalemailaddress(userDoc.email || "");

        setAccesstoken(userDoc.access_token || "");
        setRefreshtoken(userDoc.refresh_token || "");
        setExpiryDate(userDoc.expiry_date || "");
        setMinutespromptingemail(userDoc.minutespromptingemail);
        setWhowillemailed(userDoc.whowillbeemailed);
        setNewgreeting(userDoc.studentpassmessage);
        setNewgreetinga(userDoc.parentpassmessage);

        if (userDoc.activeclassid) {
          setActiveid(userDoc.activeclassid);
          console.log("✅ Active class ID set:", userDoc.activeclassid);
        } else {
          console.warn("⚠️ No active class ID found for user");
        }

        if (userDoc.activeclassname) {
          setActivename(userDoc.activeclassname);
          console.log("✅ Active class name set:", userDoc.activeclassname);
        } else {
          console.warn("⚠️ No active class name found for user");
        }
      } else {
        console.warn("⚠️ No document found in Firestore for user id:", userId);
      }
    } catch (error) {
      console.error("❌ Error fetching user data from Firestore:", error);
    }
  }


  useEffect(() => {
    if (sendEmail == true) {
      sendpremadeemail()
    }
  }, [sendEmail]);

  useEffect(() => {
    if (!id) {
      return;
    }

    const { params } = collectCallbackParams(window.location.href);
    const hasEmailResult =
      typeof params.emailSendFlowCompleted !== "undefined" ||
      typeof params.emailSendStatus !== "undefined" ||
      typeof params.emailSendAlert !== "undefined" ||
      typeof params.emailSent !== "undefined" ||
      (typeof params.success !== "undefined" && String(params.task || "") === "sendEmail");

    if (!hasEmailResult) {
      return;
    }

    let cancelled = false;

    const finalizeCallback = async () => {
      const parsedResult = parseEmailResultFromUrl(window.location.href);
      const hydratedResult = await hydrateEmailSendResultFromFirestore(parsedResult);

      if (cancelled) {
        return;
      }

      const legacySuccess = String(parseJsonOrRaw(params.success, "false")) === "true";

      if (hydratedResult?.flowCompleted || hydratedResult?.status === "success" || legacySuccess) {
        openEmailReportModal(hydratedResult);
      } else if (hydratedResult) {
        showNoEmailsSentReport(
          hydratedResult?.requestedCount === "Not reported"
            ? 0
            : toSafeNumber(hydratedResult?.requestedCount, 0),
          hydratedResult?.modalMessage || hydratedResult?.alert || "Email send flow returned an incomplete result."
        );
      } else {
        showNoEmailsSentReport(0, "Email send flow returned no result.");
      }

      try {
        const cleanedUrl = new URL(window.location.href);
        [
          "task",
          "success",
          "emailSendFlowCompleted",
          "emailSendStatus",
          "emailSendAlert",
          "emailSendSender",
          "emailSendRequested",
          "emailSendSucceeded",
          "emailSendFailed",
          "emailSendSentFolderConfirmed",
          "emailSendSentFolderUnverified",
          "emailSent",
          "failedRecipients",
          "requestedCount",
          "sentCount",
          "failedCount",
          "sentFolderConfirmedCount",
          "sentFolderUnverifiedCount",
          "senderEmail",
          "modalMessage",
          "alert",
        ].forEach((key) => cleanedUrl.searchParams.delete(key));
        window.history.replaceState({}, document.title, `${cleanedUrl.pathname}${cleanedUrl.search}${cleanedUrl.hash}`);
      } catch (error) {
        console.warn("Failed to clean email callback params from URL:", error);
      }
    };

    finalizeCallback();

    return () => {
      cancelled = true;
    };
  }, [id, location.search]);

  useEffect(() => {
    setSelectedStudents([]);
  }, [activeid]);

  useEffect(() => {
    if (id) {
      fetchUserDocAndSetState(id);
    }
  }, [id]);

  useEffect(() => {
    if (selectedclass) {
      console.log(selectedclass.studentIds, "selectedclass studentIds in mainmenu useeffect");
    }
  }, [selectedclass]);

  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isPhoneOrTablet =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

      const isSmallScreen = window.innerWidth <= 768; // Adjust breakpoint as needed

      setIsMobile(isPhoneOrTablet || isSmallScreen);
    };

    checkDevice();

    // Optional: Add a resize listener to handle screen size changes
    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);


  useEffect(() => {
    if (typeof studentidd != "undefined") {
      console.log(studentidd, "studentidd in mainmenu useeffect");
    }
  }, [studentidd]);

  useEffect(() => {
    if (typeof selectedclass == "undefined" || typeof selectedclass.studentIds) {
      setActiveid("123");
      localStorage.setItem("activeid", "123");
      setActivename("");
      localStorage.setItem("activename", "");
    }
  }, []);

  async function gogetstudents() {
    navigate("/Getstudents");
  }

  useEffect(() => {
    if (typeof selectedclass != "undefined" && editparentcontactinfo != true) {
      console.log("2this was run right here", studentidd, showcurrentroster, selectedclass, "2this was run right here");
      setStudentidd("");
      setShowcurrentroster(false);
    }
  }, [selectedclass]);

  useEffect(() => {
    console.log("5this was run right here", studentidd, showcurrentroster, "5this was run right here");
    if (showcurrentroster == true) {
      console.log(showcurrentroster, "showcurrentroster is true currentpasses should be false now");
      setShowcurrentpasses(false);

    }

    setCurrentstudent(undefined);
    console.log("3this was run right here", studentidd, showcurrentroster, "3this was run right here");
    setStudentidd(undefined);
    setParentlanguagecode(undefined);
  }, [showcurrentroster]);

  useEffect(() => {
    if (typeof currentpass != "undefined") {
      setCurrentpassid(currentpass.id);
      setParentlangcode(currentpass.parentlanguagecode);
      setLocallanguagecode(currentpass.languagecode);

      setStudentfirstname(currentpass.firstname)

      setClassid2(currentpass.classid);
      setStudentid2(currentpass.studentid);

      let email = currentpass.studentemail;
      let parentemail = currentpass.parentemail;
      let returned = currentpass.returned;
      let left = currentpass.leftclass;


      setLeftclassonpass(left);
      setReturnedzero(returned);



      setEmailll(email);
      setParentemailll(parentemail);

      setBathroompasslimit(currentpass.timeallowedonpass);

    }
  }, [currentpass]);


  useEffect(() => {
    if (showcurrentpasses == true) {
      console.log(showcurrentpasses, "showcurrentpasses is true currentroster should be false now");
      setShowcurrentroster(false);
    }
  }, [showcurrentpasses]);

  useEffect(() => {
    if (!showpdfgetter) {
      return undefined;
    }

    const handleOutsidePdfPickerClick = (event) => {
      if (pdfPickerRef.current && !pdfPickerRef.current.contains(event.target)) {
        setShowpdfgetter(false);
      }
    };

    document.addEventListener("mousedown", handleOutsidePdfPickerClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsidePdfPickerClick);
    };
  }, [showpdfgetter]);

  useEffect(() => {
    if (!showCourseDocsButtons) {
      return undefined;
    }

    const handleOutsideCourseDocsClick = (event) => {
      const actionableTarget = event.target.closest("button, .passstart222, .passstart222active");

      if (!actionableTarget) {
        return;
      }

      if (
        courseDocsButtonsRef.current &&
        courseDocsButtonsRef.current.contains(actionableTarget)
      ) {
        return;
      }

      setShowCourseDocsButtons(false);
    };

    document.addEventListener("mousedown", handleOutsideCourseDocsClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideCourseDocsClick);
    };
  }, [showCourseDocsButtons]);

  const gogetclasses = async () => {

    try {
      const docRef = doc(firebase, "users", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const userDoc = docSnap.data();

        setDrinkpasslocal(userDoc.drinkpass || "");
        setBathroompasslocal(userDoc.bathroompass || "");
        setNonbathroompasslocal(userDoc.nonbathroompass || "");
        setTeacheriscalled(userDoc.teacheriscalled || "");

        setAccesstoken(userDoc.access_token || "");
        setRefreshtoken(userDoc.refresh_token || "");
        setExpiryDate(userDoc.expiry_date || "");

        // All other user info
        if (userDoc.activeclassid) {
          setActiveid(userDoc.activeclassid);
          console.log("✅ Active class ID set:", userDoc.activeclassid);
        } else {
          console.warn("⚠️ No active class ID found for user");
        }

        if (userDoc.activeclassname) {
          setActivename(userDoc.activeclassname);
          console.log("✅ Active class name set:", userDoc.activeclassname);
        } else {
          console.warn("⚠️ No active class name found for user");
        }

        gogetclasses23(userDoc.access_token, userDoc.refresh_token, userDoc.expiry_date, userDoc.activeclassid, userDoc.activeclassname, userDoc.email)

      } else {
        console.warn("⚠️ No document found in Firestore for user id:");
      }
    } catch (error) {
      console.error("❌ Error fetching user data from Firestore:", error);
    }

  };

  async function gogetclasses23(accessToken, refreshToken, expiryDate, activeclassid, activeclassname, email) {

    console.log("Is the class id present2", activeclassid, activeid);

    const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
    const redirectUrl = encodeURIComponent(window.location.href + "/gcclasses");
    const currentUrl = encodeURIComponent(window.location.href);

    try {
      console.log("Initiating login request...");

      const requestState = {
        id: id,
        currentUrl: currentUrl,
        redirectUrl: redirectUrl,
        databasecourseId: activeclassid ? activeclassid : activeid,
        task: "fetchCourses",
        email: email || localemailaddress,
      };

      console.log("Sending request with state:", requestState);

      const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify(requestState))}`, { method: "GET" });
      const finalUrl = response.url || "";
      if (!finalUrl.startsWith(API_BASE_URL)) {
        window.location.href = decodeURIComponent(redirectUrl) + "?id=" + id + "&dataStoredInDatabase=true";
        return;
      }
      const responseData = await response.json();

      console.log("fetchCourses login response:", {
        hasAuthUrl: !!responseData?.authUrl,
        directExecution: !!responseData?.directExecution,
        hasRedirectUrl: !!responseData?.redirectUrl,
        success: responseData?.success,
      });

      const authUrl = typeof responseData?.authUrl === "string" ? responseData.authUrl.trim() : "";

      if (authUrl) {
        if (!/^https?:\/\//i.test(authUrl)) {
          console.error("Invalid auth URL returned from the server:", authUrl);
          alert("Failed to retrieve a valid authentication URL.");
          return;
        }

        console.log("Redirecting to auth URL:", authUrl);
        window.location.href = authUrl;
      } else {
        console.error("Unexpected response from the server:", responseData);
        alert("Failed to retrieve the authentication URL");
      }
    } catch (error) {
      console.error("Login request failed:", error);
      alert(`Login failed: ${error.message}`);
    }
  }


  async function gogetclassesfromadifferentaccount(user) {
    console.log("Is the class id present", user, activeid);

    const refreshToken = "";
    const accessToken = "";
    const expiryDate = "";

    const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
    const redirectUrl = encodeURIComponent(window.location.href + "/gcclasses"); // Current URL
    const currentUrl = encodeURIComponent(window.location.href);

    setProcessingtrue(false);

    try {
      const stateParam2 = JSON.stringify({
        id: id,
        currentUrl: currentUrl,
        redirectUrl: redirectUrl,
        databasecourseId: user ? user : activeid,
        task: "fetchCourses",
        email: localemailaddress,
      });
      const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(stateParam2)}`, { method: "GET" });
      const finalUrl2 = response.url || "";
      if (!finalUrl2.startsWith(API_BASE_URL)) {
        window.location.href = decodeURIComponent(redirectUrl) + "?id=" + id + "&dataStoredInDatabase=true";
        return;
      }
      const responseData2 = await response.json();

      console.log("fetchCourses login response:", {
        hasAuthUrl: !!responseData2?.authUrl,
        directExecution: !!responseData2?.directExecution,
        hasRedirectUrl: !!responseData2?.redirectUrl,
        success: responseData2?.success,
      });

      const authUrl2 = typeof responseData2?.authUrl === "string" ? responseData2.authUrl.trim() : "";

      if (authUrl2) {
        if (!/^https?:\/\//i.test(authUrl2)) {
          console.error("Invalid auth URL returned from the server:", authUrl2);
          alert("Failed to retrieve a valid authentication URL.");
          return;
        }

        window.location.href = authUrl2;
      } else {
        console.error("Unexpected response from the server:", responseData2);
      }
    } catch (error) {
      console.error("Error during login:", error.message);
      alert("Failed to initiate login. Please check the console for details.");
    }
  }

  const auth = getAuth();

  async function signout() {
    auth.signOut();
    setId2();
  }

  useEffect(() => {
    localStorage.setItem("availablecourses", "not loaded");
    if (typeof selectedclass != "undefined") {
      setActiveid("123");
      setActivestudentlist([]);
      setActivename("");
      setActiveperiod("");
    }
    if (state && town && school) {
      findschoollisting();
      getlocationsqrcodes();
    }
  }, []);

  useEffect(() => {
    if (typeof currentstudent != "undefined") {
      console.log("4this was run right here", studentidd, currentstudent, "4this was run right here");
      setStudentidd(currentstudent.id);
    }
  }, [currentstudent]);

  useEffect(() => {
    if (typeof selectedclass != "undefined") {

      setNeedtoslect(true);

      console.log(selectedclass, "selected class in useeffect that you are looking for");


      setSchool(selectedclass.school || "");
      setTown(selectedclass.town || "");
      setState(selectedclass.state || "");
      setActiveid(selectedclass.id || "");
      setActivestudentlist(selectedclass.students || "");
      setActivename(selectedclass.classname || "");
      setActiveperiod(selectedclass.period || "");
      setGclassroomid(selectedclass.googleclassroomid || "");
      setGclassroomname(selectedclass.googleclassroomname || "");
      setAdditionallinklevel(selectedclass.additionallinklevel || "");

      setCoursename(selectedclass.classname || "");
      setActiveid2(selectedclass.id || "");
      setLinkedclass(selectedclass.id || "");
      setTeacher(selectedclass.teacheriscalled || "");

      setDrinkwater(selectedclass.drinkofwater || "");
      setBroom(selectedclass.timelimitbathroompass || "");
      setCurrentlocation(selectedclass.location || "");
      setOtherpass(selectedclass.timelimitnonbathroompass || "");
      setLocation2(selectedclass.location || "");

      setAssignmentname1(selectedclass.gc1title || "");

      setAssignmentid1(selectedclass.gc1assignmentid || "");

      setLast10updated(selectedclass.gc1timesent || "");

      let classe = selectedclass.classname || "";
      let idselect = selectedclass.id || "";
      let gcid = selectedclass.googleclassroomid || "";
      let studentsss = selectedclass.students || "";
      let courseId = selectedclass.googleclassroomname || "";
      let classiddd = selectedclass.id || "";
      updatedatabase(classiddd, classe, studentsss, gcid, courseId);

      localStorage.setItem("activeid", selectedclass.id || "");
      localStorage.setItem("activename", selectedclass.classname || "");
      localStorage.setItem("activeperiod", selectedclass.period || "");
      localStorage.setItem("gclassroomid", selectedclass.googleclassroomid || "");
      localStorage.setItem("gclassroomname", selectedclass.googleclassroomname || "");

      console.log(selectedclass.classname, selectedclass.id, "selected class");
    }
  }, [selectedclass]);

  useEffect(() => {

    if (state && town && school) {
      findschoollisting();
      getlocationsqrcodes();
    }
  }, [state, town, school]);

  async function findschoollisting() {
    console.log("Revise Stats was run");
    const q = query(
      collection(firebase, "schools"),
      where("state", "==", state),
      where("town", "==", town),
      where("school", "==", school)
    );

    const snapshot1 = await getCountFromServer(q);
    const totalCount = snapshot1.data().count;
    console.log("qrcode  4  call", totalCount);

    if (totalCount == 1) {
      const querySnapshot = await getDocs(q).then(async (snapshot1) => {
        snapshot1.forEach((doc) => {
          setGetschoolid(doc.data().id);
          console.log(doc.data().id, "This is the school ID ");
        });
      });
    } else {
      setGetschoolid("");
    }
  }

  async function getlocationsqrcodes() {
    console.log("getlocationsqrcodes called with:", {
      id2,
      state,
      town,
      school,
      userdata2Current: userdata2 // Log current state before updating
    });

    if (!id2) {
      console.log("Skipping getlocationsqrcodes because id2 is undefined");
      return;
    }
    let nowwww = Date.now();
    //last seven days
    let number = nowwww - 604800000;

    // passes in the last 12 hours
    let lastday = Date.now() - 43200000;

    const q = query(
      collection(firebase, "passes"),
      where("teacherid", "==", id2),
      where("timepassinitiated", ">", lastday),
      orderBy("timepassinitiated", "desc")
    );

    const querySnapshot = await getDocs(q).then(function (snapshot) {
      let statusarray = [];
      let array = [];
      let datelast7 = [];
      let listofids = [];
      let totaltime = [];
      snapshot.forEach((doc) => {
        if (
          isNaN(doc.data().timeallowedonpass) ||
          isNaN(doc.data().differenceoverorunderinminutes)
        ) {
          array.push(doc.data());
        } else {
          totaltime.push(
            doc.data().timeallowedonpass -
            doc.data().differenceoverorunderinminutes
          );

          array.push(doc.data());
          statusarray.push(doc.data().status);
          if (doc.data().leftclass > number) {
            datelast7.push(doc.data().studentid);
            if (!listofids.includes(doc.data().studentid)) {
              listofids.push(doc.data().studentid);
            }
          }
        }
      });
      if (array.length === 0) {
        setUserdata2([{ classname: "You haven't Registered" }]);
        setEmpty(true);
      } else {
        // setIdselected2();

        setEmpty(false);
        setUserdata2(array);
      }


    });

    const snapshot1 = await getCountFromServer(q);
    const totalCount = snapshot1.data().count;
    console.log("This is the totalcount at QrCodes", totalCount);

  }

  const updatedatabase = (a, b, c, d, e) => {

    console.log("27777", a);
    updateDoc(doc(firebase, "users", id), {
      activeclassid: a,
      activeclassname: b,
      activeclassstudentlist: c,
      gclassroomid: d,
      gclassroomname: e,
      currentclass: a,
    }).catch((error) => {
      console.log(error);
      alert(error);
    });
  };

  async function gogetstudents2() {

    try {
      const docRef = doc(firebase, "users", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const userDoc = docSnap.data();

        setAccesstoken(userDoc.access_token || "");
        setRefreshtoken(userDoc.refresh_token || "");
        setExpiryDate(userDoc.expiry_date || "");

        // All other user info
        if (userDoc.activeclassid) {
          setActiveid(userDoc.activeclassid);
          console.log("✅ Active class ID set:", userDoc.activeclassid);
        } else {
          console.warn("⚠️ No active class ID found for user");
        }

        if (userDoc.activeclassname) {
          setActivename(userDoc.activeclassname);
          console.log("✅ Active class name set:", userDoc.activeclassname);
        } else {
          console.warn("⚠️ No active class name found for user");
        }

        gogetstudents299(userDoc.access_token, userDoc.refresh_token, userDoc.expiry_date, userDoc.activeclassid, userDoc.activeclassname)

      } else {
        console.warn("⚠️ No document found in Firestore for user id:");
      }
    } catch (error) {
      console.error("❌ Error fetching user data from Firestore:", error);
    }


  }

  async function gogetstudents299(accessToken, refreshToken, expiryDate, activeid, activeclassname) {
    if (typeof gclassroomid != "undefined") {


      const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
      const currentUrl = window.location.href;
      // Get the current URL

      const isProduction = process.env.NODE_ENV === "production";
      const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
      const redirectUrl = `${baseUrl}/role/${role}/mainmenu/id/${id}/gcstudents`;

      try {
        const stateParamStudents = JSON.stringify({
          id: id,
          currentUrl: currentUrl,
          task: "fetchStudents",
          redirectUrl: redirectUrl,
          email: localemailaddress,
          courseId: gclassroomid,
          databasecourseId: activeid,
        });
        const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(stateParamStudents)}`, { method: "GET" });

        console.log("fetchStudents login response url:", response.url);

        const finalUrlStudents = response.url || "";
        if (!finalUrlStudents.startsWith(API_BASE_URL)) {
          window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
          return;
        }

        const dataStudents = await response.json();

        console.log("fetchStudents login response:", {
          hasAuthUrl: !!dataStudents?.authUrl,
          directExecution: !!dataStudents?.directExecution,
          hasRedirectUrl: !!dataStudents?.redirectUrl,
          success: dataStudents?.success,
        });

        if (dataStudents?.directExecution === true) {
          const directResultUrl =
            typeof dataStudents?.redirectUrl === "string" && dataStudents.redirectUrl.trim().length > 0
              ? dataStudents.redirectUrl.trim()
              : typeof dataStudents?.authUrl === "string"
                ? dataStudents.authUrl.trim()
                : redirectUrl;

          if (!directResultUrl) {
            console.error("Direct execution completed without a redirect URL:", dataStudents);
            alert("Students were fetched, but no redirect URL was returned.");
            return;
          }

          window.location.href = directResultUrl;
          return;
        }

        const authUrl = typeof dataStudents?.authUrl === "string" ? dataStudents.authUrl.trim() : "";

        if (authUrl) {
          if (!/^https?:\/\//i.test(authUrl)) {
            console.error("Invalid auth URL returned from the server:", authUrl);
            alert("Failed to retrieve a valid authentication URL.");
            return;
          }

          window.location.href = authUrl;
        } else {
          console.error("Auth URL not received from the server.");
          alert("Failed to retrieve the authentication URL.");
        }
      } catch (error) {
        console.error("Error during login:", error.message);
        alert("Failed to initiate login. Please check the console for details.");
      }
    }
  }


  async function gogetlastttengcassiignments() {


    try {
      const docRef = doc(firebase, "users", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const userDoc = docSnap.data();

        setAccesstoken(userDoc.access_token || "");
        setRefreshtoken(userDoc.refresh_token || "");
        setExpiryDate(userDoc.expiry_date || "");

        // All other user info
        if (userDoc.activeclassid) {
          setActiveid(userDoc.activeclassid);
          console.log("✅ Active class ID set:", userDoc.activeclassid);
        } else {
          console.warn("⚠️ No active class ID found for user");
        }

        if (userDoc.gclassroomid) {
          setGclassroomid(userDoc.gclassroomid);
          console.log("✅ Active class name set:", userDoc.gclassroomid);
        } else {
          console.warn("⚠️ No active class name found for user");
        }

        gogetlastttengcassiignments999(userDoc.activeclassid, userDoc.gclassroomid)

      } else {
        console.warn("⚠️ No document found in Firestore for user id:");
      }
    } catch (error) {
      console.error("❌ Error fetching user data from Firestore:", error);
    }

  }


  async function createclassthengogetstudents() {

    setProcessingtrue(true);
    try {
      const userRec = await addDoc(collection(firebase, "classesbeingtaught"), {
        dailycheck: 0,
        languagesinthisclass: [],
        created: Date.now(),
        classname: coursename2 ? coursename2 : "",
        location: location5 ? location5 : "",
        teacherid: id ? id : "",
        teachernotificationid: "",
        school: schoollocal ? schoollocal : "",
        town: townlocal ? townlocal : "",
        state: statelocal ? statelocal : "",
        teacheriscalled: teacheriscalled ? teacheriscalled : "",
        period: period2 ? period2 : "",
        passesareavailable: false,
        acceptingincomingstudents: true,
        ledby: role ? role : "",
        timelimitbathroompass: bathroompasslocaal ? bathroompasslocaal : "",
        timelimitnonbathroompass: nonbathroompasslocal ? nonbathroompasslocal : "",
        drinkofwater: drinkpasslocal ? drinkpasslocal : "",
        ifoverundernegativepassaccess: 1,
        additionallinklevel: 0,
        students: [],
        googleclassroomid: "",
        closewebpass: false,
      });

      const user = userRec.id;
      console.log("In function New id of current class 2 is:", user, "New id of current class 2 is:");

      await updateDoc(doc(firebase, "classesbeingtaught", user), {
        id: user,
        key: user,
        activeAnswerKeyAssignment: {
          versions: "0",
        },
      });
      await updateDoc(doc(firebase, "users", id), {
        activeclassid: user,
        activeclassname: coursename2,
        currentclass: user,
      });

      gogetclassesfromadifferentaccount(user);
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }

  async function gogetgradesofmostrecentassignment() {
    console.log("gogetgradesofmostrecentassignment is called", gclassroomid, "gclassroomid");

    if (typeof gclassroomid != "undefined") {
      async function waitForLocalStorageItems(keys) {
        return new Promise((resolve) => {
          const startTime = Date.now();
          const interval = setInterval(() => {
            const allItemsPresent = keys.every((key) => localStorage.getItem(key) !== null);
            const elapsedTime = Date.now() - startTime;

            if (allItemsPresent || elapsedTime >= 3000) { // 3-second limit
              clearInterval(interval);
              resolve();
            }
          }, 100); // Check every 100ms
        });
      }

      await waitForLocalStorageItems(["refresh_token", "access_token", "expiry_date"]);

      // Refresh and resave tokens to localStorage
      const urlParams = new URLSearchParams(window.location.search);
      const accessToken = urlParams.get("access_token");
      const refreshToken = urlParams.get("refresh_token");
      const expiryDate = urlParams.get("expiry_date");

      if (accessToken) {
        localStorage.setItem("access_token", accessToken);
        console.log("Access token refreshed and saved to localStorage:", accessToken);
      } else {
        console.warn("No access token found in the URL.");
      }

      if (refreshToken) {
        localStorage.setItem("refresh_token", refreshToken);
        console.log("Refresh token refreshed and saved to localStorage:", refreshToken);
      } else {
        console.warn("No refresh token found in the URL.");
      }

      if (expiryDate) {
        localStorage.setItem("expiry_date", expiryDate);
        console.log("Expiry date refreshed and saved to localStorage:", expiryDate);
      } else {
        console.warn("No expiry date found in the URL.");
      }

      const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
      const currentUrl = window.location.href; // Get the current URL

      const isProduction = process.env.NODE_ENV === "production";
      const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
      const redirectUrl = `${baseUrl}/role/${role}/mainmenu/id/${id}/gcgrades`;

      // Check if we're returning from OAuth with student grades results
      const urlSearchParams = new URLSearchParams(window.location.search);
      const studentGrades = urlSearchParams.get('studentGrades');

      // Handle case where student grades are returned directly in URL
      if (studentGrades) {
        try {
          const results = JSON.parse(decodeURIComponent(studentGrades));
          console.log("Received student grades results:", results);

          // Update localStorage with new tokens if provided
          const accessToken = urlSearchParams.get('access_token');
          const refreshToken = urlSearchParams.get('refresh_token');
          const expiryDate = urlSearchParams.get('expiry_date');

          if (accessToken) {
            localStorage.setItem("access_token", accessToken);
          }
          if (refreshToken) {
            localStorage.setItem("refresh_token", refreshToken);
          }
          if (expiryDate) {
            localStorage.setItem("expiry_date", expiryDate);
          }

          // Display results to user
          if (results.success && results.grades) {
            const studentName = results.studentName || "Unknown Student";
            const className = results.className || "Unknown Class";
            const totalAssignments = results.grades.length;

            let message = `📊 GRADES RETRIEVED!\n\nStudent: ${studentName}\nClass: ${className}\nTotal Assignments: ${totalAssignments}\n\n`;

            if (totalAssignments > 0) {
              message += "Recent Assignments:\n";
              // Show first 5 assignments
              results.grades.slice(0, 5).forEach((grade, index) => {
                const score = grade.score !== undefined ? grade.score : "No Score";
                const maxPoints = grade.maxPoints ? `/${grade.maxPoints}` : "";
                message += `• ${grade.assignmentTitle}: ${score}${maxPoints}\n`;
              });

              if (totalAssignments > 5) {
                message += `\n... and ${totalAssignments - 5} more assignments\n`;
              }

              message += `\nCheck console for complete details.`;
            } else {
              message += "No assignments found for this student.";
            }

            alert(message);
            console.log("📊 Complete student grades data:", results.grades);

          } else {
            let errorMessage = `❌ FAILED!\n\nCould not retrieve grades for the student.\n\n`;

            if (results.error) {
              if (results.error.includes("Student not found")) {
                errorMessage += "Error: Student not found in this class.\n\nPlease verify:\n• The student ID is correct\n• The student is enrolled in this class\n• The student hasn't been removed from the class";
              } else if (results.error.includes("Course not found")) {
                errorMessage += "Error: Course not found.\n\nPlease verify:\n• The class ID is correct\n• You have access to this class\n• The class is still active";
              } else {
                errorMessage += `Error: ${results.error}`;
              }
            } else {
              errorMessage += "Unknown error occurred. Please try again.";
            }

            alert(errorMessage);
            console.error("Failed to retrieve student grades:", results);
          }

        } catch (error) {
          console.error('Error parsing student grades results:', error);
          alert('Error processing student grades results. Check console for details.');
        } finally {
          // Clean up URL parameters
          window.history.replaceState({}, document.title, window.location.pathname);
        }

        return; // Exit early since we've processed the results
      }

      try {
        const stateParamGrades = JSON.stringify({
          id: id,
          currentUrl: currentUrl,
          task: "fetchGradesOfMostRecentAssignment",
          email: localemailaddress,
          redirectUrl: redirectUrl,
          courseId: gclassroomid,
          databasecourseId: activeid,
        });
        const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(stateParamGrades)}`, { method: "GET" });
        const finalUrlGrades = response.url || "";
        if (!finalUrlGrades.startsWith(API_BASE_URL)) {
          window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
          return;
        }
        const dataGrades = await response.json();
        console.log("Auth URL:", dataGrades.authUrl);
        if (dataGrades.authUrl) {
          window.location.href = dataGrades.authUrl;
        } else {
          console.error("Auth URL not received from the server.");
          alert("Failed to retrieve the authentication URL.");
        }
      } catch (error) {
        console.error("Error during login:", error.message);
        alert("Failed to initiate login. Please check the console for details.");
      }
    }
  }

  useEffect(() => {
    if (typeof currentstudent != "undefined") {
      console.log("1this was run right here", studentidd, currentstudent, "1this was run right here");
      setStudentidd(currentstudent.id);
      setParentlanguagecode(currentstudent.parentlanguagecode);
    }
  }, [currentstudent]);

  useEffect(() => {
    if (
      typeof activeid != "undefined" &&
      activeid != "123" &&
      typeof activestudentlist2 != "undefined"
    ) {
      // Filter students from this class
      console.log(activestudentlist2, "YO");

      let current = activestudentlist2.filter((person) =>
        person.classlist.includes(activeid)
      );

      // Add the property matching activeid to make the check work
      current = current.map(student => {
        const enhancedStudent = { ...student };
        enhancedStudent[activeid] = true; // This makes currentclass[0][activeid] defined
        return enhancedStudent;
      });

      setCurrentclass(current);
    }
  }, [activeid]);

  const navigate = useNavigate();

  const cardData = ["hello", "goodbye", "hii"];
  async function signout() {
    auth.signOut();
    setId2();

    navigate("/");
  }

  async function gogetstudents() {
    navigate("/Getstudents");
  }

  // Helper function to check if auth tokens are valid
  const checkAuthTokens = () => {
    const refreshToken = localStorage.getItem("refresh_token");
    const accessToken = localStorage.getItem("access_token");
    const expiryDate = localStorage.getItem("expiry_date");

    // Check if tokens exist
    const hasTokens = refreshToken && accessToken && expiryDate;

    // Check if access token is expired
    let isExpired = false;
    if (expiryDate) {
      const expiryTimestamp = parseInt(expiryDate, 10);
      const currentTimestamp = Date.now();
      isExpired = currentTimestamp >= expiryTimestamp;
    }

    return {
      hasTokens,
      isExpired,
      refreshToken,
      accessToken,
      expiryDate
    };
  };

  const Creatingmessage = "/Messagesforsending/role/Teacher/mainmenu/id/" + id;

  const getSelectedAssignmentPayloadForSend = () => {
    const visibleAssignmentName = (assignmentname1 || "").trim();
    const visibleAssignmentId = (assignmentid1 || "").trim();

    if (!visibleAssignmentName) {
      return {
        selectedAssignmentName: "",
        selectedAssignmentId: "",
        selectedAssignmentLastUpdated: last10updated || "",
      };
    }

    if (visibleAssignmentId) {
      return {
        selectedAssignmentName: visibleAssignmentName,
        selectedAssignmentId: visibleAssignmentId,
        selectedAssignmentLastUpdated: last10updated || "",
      };
    }

    try {
      const raw = localStorage.getItem("fetchGradesOfSelectedAssignment");
      if (!raw) {
        return {
          selectedAssignmentName: visibleAssignmentName,
          selectedAssignmentId: "",
          selectedAssignmentLastUpdated: last10updated || "",
        };
      }

      const parsed = JSON.parse(raw);
      const storedAssignmentName = typeof parsed?.assignmentName === "string"
        ? parsed.assignmentName.trim()
        : "";
      const storedAssignmentId = parsed?.assignmentId ? String(parsed.assignmentId).trim() : "";

      if (storedAssignmentName && storedAssignmentName === visibleAssignmentName) {
        return {
          selectedAssignmentName: visibleAssignmentName,
          selectedAssignmentId: storedAssignmentId,
          selectedAssignmentLastUpdated: last10updated || "",
        };
      }

      console.warn("[Assignment Sync] Visible MainMenu assignment does not match stored assignment selection; skipping assignment id handoff.", {
        visibleAssignmentName,
        storedAssignmentName,
        storedAssignmentId,
      });
    } catch (error) {
      console.error("[Assignment Sync] Failed to read selected assignment for send handoff:", error);
    }

    return {
      selectedAssignmentName: visibleAssignmentName,
      selectedAssignmentId: "",
      selectedAssignmentLastUpdated: last10updated || "",
    };
  };

  useEffect(() => {
    if (typeof id2 != "undefined") {
      getclasses();
      runthefunctiontogetstudents();
    }
  }, [id2]);

  useEffect(() => {
    if (typeof additionallinklevel != "undefined") {

      console.log("Additionallinklevel changed:", additionallinklevel);

    }
  }, [additionallinklevel]);


  // ...existing code...

  // 1. matchAndUpdateStudentIdsInClass
  // ...existing code...

  function extractStudentInfo(pageText) {
    // Helper function to filter out student-specific emails/phones
    const filterStudentData = (array, dataType) => {
      return array.filter((item) => {
        const itemEscaped = item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        if (dataType === 'email') {
          // Look for "student email" key near this email value
          const studentEmailPattern = new RegExp(`student\\s+email[^@]*${itemEscaped}`, 'i');
          if (studentEmailPattern.test(pageText)) {
            console.log(`Filtering out student email: ${item}`);
            return false;
          }
        } else if (dataType === 'phone') {
          // Look for "student phone" or "student number" key near this phone value
          const studentPhonePattern = new RegExp(`student\\s+(?:phone|number)[^0-9]*${itemEscaped.replace(/\D/g, '')}`, 'i');
          if (studentPhonePattern.test(pageText)) {
            console.log(`Filtering out student phone: ${item}`);
            return false;
          }
        }
        return true;
      });
    };

    // 1. parentemail: all emails, filtered to exclude student emails
    let parentemail = Array.from(pageText.matchAll(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g)).map(m => m[0]);
    parentemail = filterStudentData(parentemail, 'email');

    // 2. parentphonenumber: all 10-digit numbers, filtered to exclude student phone numbers
    const phoneRaw = Array.from(pageText.matchAll(/(?:\+?1[-.\s]*)?\(?(\d{3})\)?[-.\s]*(\d{3})[-.\s]*(\d{4})/g));
    let parentphonenumber = phoneRaw.map(m => {
      let digits = `${m[1]}${m[2]}${m[3]}`;
      if (digits.length === 10) return digits;
      if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
      return "";
    }).filter(Boolean);
    parentphonenumber = filterStudentData(parentphonenumber, 'phone');

    // 3. password: after "Password" or "Student Password"
    let password = "";
    const pwMatch = pageText.match(/(?:Student\s+Password|Password)\s+([^\s]+)/i);
    if (pwMatch) password = pwMatch[1];

    // 4. gender: enhanced detection with "sex" alternative and better case handling
    let gender = "undisclosed";
    let genderFound = false;
    const lines = pageText.split(/[\n\r]+/);

    // Strategy 1: Look for "gender" or "sex" key with male/female/M/F value on same line
    for (let line of lines) {
      if (/(gender|sex)\s*[:=]?\s*/i.test(line)) {
        // Match M, Male, F, Female (case-insensitive, word boundaries)
        if (/\b(m|male)\b/i.test(line)) {
          gender = "he";
          genderFound = true;
          console.log(`Found gender via key-value (gender/sex): ${line.trim()}`);
          break;
        }
        if (/\b(f|female)\b/i.test(line)) {
          gender = "she";
          genderFound = true;
          console.log(`Found gender via key-value (gender/sex): ${line.trim()}`);
          break;
        }
      }
    }

    // Strategy 2: Look for "male" or "female" as whole words anywhere in document
    if (!genderFound) {
      const genderWordMatch = pageText.match(/\b(male|female)\b/i);
      if (genderWordMatch) {
        gender = genderWordMatch[1].toLowerCase() === "male" ? "he" : "she";
        genderFound = true;
        console.log(`Found gender via word match: ${genderWordMatch[1]}`);
      }
    }

    // Strategy 3: Look for "Gender:" or "Sex:" followed by M/F (even with separators)
    if (!genderFound) {
      const keyValueMatch = pageText.match(/(gender|sex)[^a-zA-Z0-9]{0,5}([mf])\b/i);
      if (keyValueMatch) {
        gender = keyValueMatch[2].toLowerCase() === "m" ? "he" : "she";
        genderFound = true;
        console.log(`Found gender via key-single letter: ${keyValueMatch[0].trim()}`);
      }
    }

    // Strategy 4: Look for standalone M or F on its own line (not part of name/initial)
    if (!genderFound) {
      for (let line of lines) {
        if (/father|mother|first|last|name/i.test(line)) continue; // Skip lines with name context
        const soloMatch = line.match(/^\s*([mf])\s*$/i);
        if (soloMatch) {
          gender = soloMatch[1].toLowerCase() === "m" ? "he" : "she";
          genderFound = true;
          console.log(`Found gender via standalone letter: ${soloMatch[1]}`);
          break;
        }
      }
    }

    // Default if still not found
    if (!genderFound) {
      console.log("Gender not found, defaulting to 'undisclosed'");
    }

    // 5. name: after "Student Name", "First Name", "Last Name"
    let name = "";
    const nameMatch = pageText.match(/(?:Student\s+Name|First\s+Name|Last\s+Name)\s+([^\s,]+)/i);
    if (nameMatch) name = nameMatch[1];
    // fallback: try "Name (Last, First MI)"
    if (!name) {
      const altNameMatch = pageText.match(/Name\s+\(Last,\s*First\s*MI\)\s+([^\s,]+)/i);
      if (altNameMatch) name = altNameMatch[1];
    }

    // 6. dateofbirth: extract date in MM/DD/YYYY format
    let dateofbirth = "";
    let dobFound = false;

    // Strategy 1: Look for "dob", "date of birth", "dateofbirth" key with date value on same line
    for (let line of lines) {
      if (/(dob|date\s+of\s+birth|dateofbirth)\s*[:=]?\s*/i.test(line)) {
        // Match MM/DD/YYYY format
        const dateMatch = line.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
        if (dateMatch) {
          dateofbirth = `${dateMatch[1]}/${dateMatch[2]}/${dateMatch[3]}`;
          dobFound = true;
          console.log(`Found DOB via key-value: ${line.trim()}`);
          break;
        }
      }
    }

    // Strategy 2: Look for standalone date patterns (MM/DD/YYYY)
    if (!dobFound) {
      const datePattern = pageText.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
      if (datePattern) {
        dateofbirth = `${datePattern[1]}/${datePattern[2]}/${datePattern[3]}`;
        dobFound = true;
        console.log(`Found DOB via date pattern: ${datePattern[0]}`);
      }
    }

    if (!dobFound) {
      console.log("DOB not found");
    }

    // Log extraction for debugging
    console.log("Extracted student info:", {
      parentemail,
      parentphonenumber,
      password,
      gender,
      name,
      dateofbirth
    });

    return { parentemail, parentphonenumber, password, gender, name, dateofbirth };
  }

  function extractInfoFromPdfPage(pageText) {
    // Helper function to filter out student-specific emails/phones
    const filterStudentData = (array, dataType) => {
      return array.filter((item) => {
        const itemEscaped = item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        if (dataType === 'email') {
          // Look for "student email" key near this email value
          const studentEmailPattern = new RegExp(`student\\s+email[^@]*${itemEscaped}`, 'i');
          if (studentEmailPattern.test(pageText)) {
            console.log(`Filtering out student email: ${item}`);
            return false;
          }
        } else if (dataType === 'phone') {
          // Look for "student phone" or "student number" key near this phone value
          const studentPhonePattern = new RegExp(`student\\s+(?:phone|number)[^0-9]*${itemEscaped.replace(/\D/g, '')}`, 'i');
          if (studentPhonePattern.test(pageText)) {
            console.log(`Filtering out student phone: ${item}`);
            return false;
          }
        }
        return true;
      });
    };

    // 1. parentemail: all emails, filtered to exclude student emails
    let parentemail = Array.from(pageText.matchAll(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g)).map(m => m[0]);
    parentemail = filterStudentData(parentemail, 'email');

    // 2. parentphonenumber: all 10-digit numbers, filtered to exclude student phone numbers
    const phoneRaw = Array.from(pageText.matchAll(/(?:\+?1[-.\s]*)?\(?(\d{3})\)?[-.\s]*(\d{3})[-.\s]*(\d{4})/g));
    let parentphonenumber = phoneRaw.map(m => {
      let digits = `${m[1]}${m[2]}${m[3]}`;
      if (digits.length === 10) return digits;
      if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
      return "";
    }).filter(Boolean);
    parentphonenumber = filterStudentData(parentphonenumber, 'phone');

    // 3. password: after "Password" or "Student Password"
    let password = "";
    const pwMatch = pageText.match(/(?:Student\s+Password|Password)\s+([^\s]+)/i);
    if (pwMatch) password = pwMatch[1];

    // 4. gender: enhanced detection with "sex" alternative and better case handling
    let gender = "";
    let genderFound = false;
    const lines = pageText.split(/[\n\r]+/);

    // Strategy 1: Look for "gender" or "sex" key with male/female/M/F value on same line
    for (let line of lines) {
      if (/(gender|sex)\s*[:=]?\s*/i.test(line)) {
        // Match M, Male, F, Female (case-insensitive, word boundaries)
        if (/\b(m|male)\b/i.test(line)) {
          gender = "he";
          genderFound = true;
          console.log(`Found gender via key-value (gender/sex): ${line.trim()}`);
          break;
        }
        if (/\b(f|female)\b/i.test(line)) {
          gender = "she";
          genderFound = true;
          console.log(`Found gender via key-value (gender/sex): ${line.trim()}`);
          break;
        }
      }
    }

    // Strategy 2: Look for "male" or "female" as whole words anywhere in document
    if (!genderFound) {
      const genderWordMatch = pageText.match(/\b(male|female)\b/i);
      if (genderWordMatch) {
        gender = genderWordMatch[1].toLowerCase() === "male" ? "he" : "she";
        genderFound = true;
        console.log(`Found gender via word match: ${genderWordMatch[1]}`);
      }
    }

    // Strategy 3: Look for "Gender:" or "Sex:" followed by M/F (even with separators)
    if (!genderFound) {
      const keyValueMatch = pageText.match(/(gender|sex)[^a-zA-Z0-9]{0,5}([mf])\b/i);
      if (keyValueMatch) {
        gender = keyValueMatch[2].toLowerCase() === "m" ? "he" : "she";
        genderFound = true;
        console.log(`Found gender via key-single letter: ${keyValueMatch[0].trim()}`);
      }
    }

    // Strategy 4: Look for standalone M or F on its own line (not part of name/initial)
    if (!genderFound) {
      for (let line of lines) {
        if (/father|mother|first|last|name/i.test(line)) continue; // Skip lines with name context
        const soloMatch = line.match(/^\s*([mf])\s*$/i);
        if (soloMatch) {
          gender = soloMatch[1].toLowerCase() === "m" ? "he" : "she";
          genderFound = true;
          console.log(`Found gender via standalone letter: ${soloMatch[1]}`);
          break;
        }
      }
    }

    // Default if still not found
    if (!genderFound) {
      console.log("Gender not found, defaulting to 'Not Specified'");
    }

    // 5. homeroom extraction
    let homeroom = "";
    let homeroomFound = false;
    for (let line of lines) {
      if (/home\s*room/i.test(line)) {
        // Look for a value (letters/digits, up to 7 chars) after "home room"
        const match = line.match(/home\s*room[^a-zA-Z0-9]{0,10}([a-zA-Z0-9]{1,7})/i);
        if (match) {
          homeroom = match[1];
          homeroomFound = true;
          break;
        }
        // Or, if the value is before "home room"
        const matchBefore = line.match(/([a-zA-Z0-9]{1,7})[^a-zA-Z0-9]{0,10}home\s*room/i);
        if (matchBefore) {
          homeroom = matchBefore[1];
          homeroomFound = true;
          break;
        }
      }
    }

    // 6. passwordactual: same as password
    let passwordactual = password;

    // 7. dateofbirth: extract date in MM/DD/YYYY format
    let dateofbirth = "";
    let dobFound = false;

    // Strategy 1: Look for "dob", "date of birth", "dateofbirth" key with date value on same line
    for (let line of lines) {
      if (/(dob|date\s+of\s+birth|dateofbirth)\s*[:=]?\s*/i.test(line)) {
        // Match MM/DD/YYYY format
        const dateMatch = line.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
        if (dateMatch) {
          dateofbirth = `${dateMatch[1]}/${dateMatch[2]}/${dateMatch[3]}`;
          dobFound = true;
          console.log(`Found DOB via key-value: ${line.trim()}`);
          break;
        }
      }
    }

    // Strategy 2: Look for standalone date patterns (MM/DD/YYYY)
    if (!dobFound) {
      const datePattern = pageText.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
      if (datePattern) {
        dateofbirth = `${datePattern[1]}/${datePattern[2]}/${datePattern[3]}`;
        dobFound = true;
        console.log(`Found DOB via date pattern: ${datePattern[0]}`);
      }
    }

    if (!dobFound) {
      console.log("DOB not found");
    }

    return { parentemail, parentphonenumber, gender, password, password, passwordactual, homeroom: homeroom || "", dateofbirth };
  }


  async function matchAndUpdateStudents(currentclassParam, pdfPagesArray, firebase, activeid) {
    let currentclass = [...currentclassParam];
    let unmatchedStudents = [];
    let updatedCount = 0;
    let newStudentIds = [];

    console.log("[matchAndUpdateStudents] starting", {
      activeid,
      currentclassCount: Array.isArray(currentclassParam) ? currentclassParam.length : "not-array",
      pdfPagesCount: Array.isArray(pdfPagesArray) ? pdfPagesArray.length : "not-array",
    });

    for (let i = 0; i < currentclass.length; i++) {
      const student = currentclass[i];
      const first = (student.localfirstname || "").toLowerCase();
      const last = (student.locallastname || "").toLowerCase();
      const emailPrefix = (student.email || "").split("@")[0].toLowerCase();

      console.log("[matchAndUpdateStudents] scanning student", {
        index: i,
        studentId: student.id,
        first,
        last,
        emailPrefix,
      });

      // Find all pages with at least 2 out of 3 matches
      let candidatePages = [];
      for (let j = 0; j < pdfPagesArray.length; j++) {
        const originalText = pdfPagesArray[j].rawText || pdfPagesArray[j].parsed || pdfPagesArray[j] || "";
        const pageTextLower = originalText.toLowerCase();
        let found = [
          pageTextLower.includes(first),
          pageTextLower.includes(last),
          pageTextLower.includes(emailPrefix)
        ];
        const count = found.filter(Boolean).length;
        if (count >= 2) {
          candidatePages.push({ idx: j, pageText: originalText, found });
        }
      }

      console.log("[matchAndUpdateStudents] candidate pages found", {
        studentId: student.id,
        candidateCount: candidatePages.length,
        candidatePageIndexes: candidatePages.map((page) => page.idx),
      });

      let info = {};
      if (candidatePages.length === 1) {
        info = extractInfoFromPdfPage(candidatePages[0].pageText);

        console.log("[matchAndUpdateStudents] extracted single-match info", {
          studentId: student.id,
          dateofbirth: info.dateofbirth || "",
          homeroom: info.homeroom || "",
          gender: info.gender || "",
          parentemailCount: Array.isArray(info.parentemail) ? info.parentemail.length : "not-array",
          parentphoneCount: Array.isArray(info.parentphonenumber) ? info.parentphonenumber.length : "not-array",
        });

        // Logging for debugging
        console.log("Updating Firestore for student:", {
          studentId: student.id,
          parentemail: info.parentemail,
          parentphonenumber: info.parentphonenumber,
          gender: info.gender,
          password: info.password,
          passwordactual: info.passwordactual,
          homeroom: info.homeroom,
          dateofbirth: info.dateofbirth
        });

        // Update Firebase user document
        try {
          await updateDoc(doc(firebase, "users", student.id), {
            parentphonenumber: arrayUnion(...info.parentphonenumber),
            parentemail: arrayUnion(...info.parentemail),
            gender: info.gender,
            password: info.password,
            passwordactual: info.passwordactual,
            homeroom: info.homeroom,
            dateofbirth: info.dateofbirth
          });
          console.log(`✅ Updated student ${student.id} in Firestore with:`, info);
        } catch (err) {
          console.error(`❌ Error updating student ${student.id}:`, err);
        }

        // Update locally, prevent duplicates
        currentclass[i] = {
          ...student,
          parentphonenumber: Array.isArray(student.parentphonenumber)
            ? Array.from(new Set([...student.parentphonenumber, ...info.parentphonenumber]))
            : Array.from(new Set(info.parentphonenumber)),
          parentemail: Array.isArray(student.parentemail)
            ? Array.from(new Set([...student.parentemail, ...info.parentemail]))
            : Array.from(new Set(info.parentemail)),
          gender: info.gender,
          password: info.password,
          passwordactual: info.passwordactual,
          homeroom: info.homeroom,
          dateofbirth: info.dateofbirth
        };
        updatedCount++;
      } else if (candidatePages.length > 1) {
        const pagesWithEmailPrefix = candidatePages.filter(p => p.pageText.includes(emailPrefix));
        console.log("[matchAndUpdateStudents] multiple candidates after email filter", {
          studentId: student.id,
          matchingEmailPrefixPages: pagesWithEmailPrefix.map((page) => page.idx),
          matchingEmailPrefixCount: pagesWithEmailPrefix.length,
        });
        if (pagesWithEmailPrefix.length === 1) {
          info = extractInfoFromPdfPage(pagesWithEmailPrefix[0].pageText);

          console.log("[matchAndUpdateStudents] extracted multiple-match info", {
            studentId: student.id,
            dateofbirth: info.dateofbirth || "",
            homeroom: info.homeroom || "",
            gender: info.gender || "",
            parentemailCount: Array.isArray(info.parentemail) ? info.parentemail.length : "not-array",
            parentphoneCount: Array.isArray(info.parentphonenumber) ? info.parentphonenumber.length : "not-array",
          });

          // Logging for debugging
          console.log("Updating Firestore for student (multiple matches):", {
            studentId: student.id,
            parentemail: info.parentemail,
            parentphonenumber: info.parentphonenumber,
            gender: info.gender,
            password: info.password,
            passwordactual: info.passwordactual,
            homeroom: info.homeroom,
            dateofbirth: info.dateofbirth
          });

          try {
            await updateDoc(doc(firebase, "users", student.id), {
              parentphonenumber: arrayUnion(...info.parentphonenumber),
              parentemail: arrayUnion(...info.parentemail),
              gender: info.gender,
              password: info.password,
              passwordactual: info.passwordactual,
              homeroom: info.homeroom,
              dateofbirth: info.dateofbirth
            });
            console.log(`✅ Updated student ${student.id} in Firestore with:`, info);
          } catch (err) {
            console.error(`❌ Error updating student ${student.id}:`, err);
          }

          currentclass[i] = {
            ...student,
            parentphonenumber: Array.isArray(student.parentphonenumber)
              ? Array.from(new Set([...student.parentphonenumber, ...info.parentphonenumber]))
              : Array.from(new Set(info.parentphonenumber)),
            parentemail: Array.isArray(student.parentemail)
              ? Array.from(new Set([...student.parentemail, ...info.parentemail]))
              : Array.from(new Set(info.parentemail)),
            gender: info.gender,
            password: info.password,
            passwordactual: info.passwordactual,
            homeroom: info.homeroom,
            dateofbirth: info.dateofbirth
          };
          updatedCount++;
        } else {
          console.log(`⚠️ Ambiguous match for student ${student.id} (${first}, ${last}, ${emailPrefix}), skipping update.`);
        }
      } else {
        console.log(`ℹ️ No match for student ${student.id} (${first}, ${last}, ${emailPrefix})`);
        unmatchedStudents.push(student);
      }

      // Always push the student to the new studentIds array (using info if available)
      newStudentIds.push({
        email: student.email || "",
        firebasestudentid: student.id || "",
        firstName: student.localfirstname || "",
        lastName: student.locallastname || "",
        parentemail: info.parentemail ? info.parentemail : [],
        parentlanguagecode: student.parentlanguagecode || "en",
        languagecode: student.languagecode || "en",
        studentId: student.googleclassroomid || "",
        gender: info.gender || "",
        homeroom: info.homeroom || "",
        dateofbirth: info.dateofbirth || ""
      });

      console.log("[matchAndUpdateStudents] appended studentIds entry", {
        studentId: student.id,
        googleclassroomid: student.googleclassroomid || "",
        dateofbirth: info.dateofbirth || "",
        homeroom: info.homeroom || "",
        gender: info.gender || "",
      });
    }

    // Update the studentIds array in classesbeingtaught/activeid
    try {
      console.log("[matchAndUpdateStudents] writing class studentIds", {
        activeid,
        totalStudentIds: newStudentIds.length,
        studentIdsPreview: newStudentIds.map((studentInfo) => ({
          firebasestudentid: studentInfo.firebasestudentid,
          firstName: studentInfo.firstName,
          lastName: studentInfo.lastName,
          dateofbirth: studentInfo.dateofbirth,
        })),
      });

      await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
        studentIds: newStudentIds
      });

      console.log(`✅ studentIds updated for class ${activeid}`);
    } catch (err) {
      console.error(`❌ Error updating studentIds for class ${activeid}:`, err);
    }
    setCurrentclass(currentclass);

    return { updatedCount, unmatchedStudents };
  }

  // 2. handleFileChange
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const fileURL = URL.createObjectURL(file);
      setPdfFileUrl(fileURL);

      console.log("[handleFileChange] accepted PDF", {
        fileName: file.name,
        fileSize: file.size,
        activeid,
        selectedclassKey: selectedclass?.key || "",
        selectedclassName: selectedclass?.classname || "",
        currentclassCount: Array.isArray(currentclass) ? currentclass.length : "not-array",
      });

      try {
        const pdf = await pdfjsLib.getDocument(fileURL).promise;
        const numPages = pdf.numPages;
        const extracted = {};

        for (let i = 1; i <= numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();
          const pageText = textContent.items.map((item) => item.str).join(' ');
          extracted[`Page ${i}`] = pageText;
        }

        console.log('Extracted PDF Text (raw pages):', extracted);

        // For each page, extract the student info
        const studentsArray = Object.keys(extracted).map((pageKey, idx) => {
          const pageText = extracted[pageKey] || "";
          const info = extractStudentInfo(pageText);
          return {
            page: idx + 1,
            pageKey,
            rawText: pageText,
            ...info
          };
        });

        console.log('Parsed students array:', studentsArray);
        setPdfText(studentsArray);

        console.log("[handleFileChange] parsed students array summary", {
          parsedPageCount: studentsArray.length,
          parsedDateOfBirths: studentsArray.map((studentInfo) => ({
            page: studentInfo.page,
            dateofbirth: studentInfo.dateofbirth || "",
            parentemailCount: Array.isArray(studentInfo.parentemail) ? studentInfo.parentemail.length : "not-array",
            parentphoneCount: Array.isArray(studentInfo.parentphonenumber) ? studentInfo.parentphonenumber.length : "not-array",
          })),
        });

        // Run matching and updating right after parsing
        if (Array.isArray(currentclass) && Array.isArray(studentsArray)) {
          console.log("[handleFileChange] invoking matchAndUpdateStudents", {
            activeid,
            currentclassCount: currentclass.length,
            studentsArrayCount: studentsArray.length,
          });

          // Call matchAndUpdateStudents and get unmatchedStudents from it
          // Modify matchAndUpdateStudents to return { updatedCount, unmatchedStudents }
          const { updatedCount, unmatchedStudents } = await matchAndUpdateStudents(currentclass, studentsArray, firebase, activeid);

          console.log("[handleFileChange] matchAndUpdateStudents finished", {
            activeid,
            updatedCount,
            unmatchedCount: unmatchedStudents.length,
          });

          // Collect students with missing contact info
          const notFound = currentclass.filter(student => !student.parentemail || student.parentemail.length === 0);

          // Combine unmatchedStudents and notFound arrays, removing duplicates by student.id
          const allNotFound = [...unmatchedStudents, ...notFound].filter(
            (student, index, self) =>
              index === self.findIndex(s => s.id === student.id)
          );

          console.log("All not found students:", allNotFound);

          setUpdateSummary(`${updatedCount} out of ${currentclass.length} students were found and updated.`);
          setNotFoundStudents(allNotFound);
          setShowUpdateModal(true);
          setShowpdfgetter(false);
        } else {
          console.warn("[handleFileChange] skipped matchAndUpdateStudents because inputs were invalid", {
            currentclassIsArray: Array.isArray(currentclass),
            studentsArrayIsArray: Array.isArray(studentsArray),
            activeid,
          });
        }

      } catch (err) {
        console.error('Error extracting PDF text:', err);
        setPdfText(null);
      }
    } else {
      alert('Please select a valid PDF file.');
      setPdfFileUrl(null);
      setPdfText(null);
    }
  };

  async function getclasses() {
    try {

      const f = query(
        collection(firebase, "classesbeingtaught"),
        where("teacherid", "==", id)
      );

      const querySnapshot = await getDocs(f);
      console.log("classesbeingtaught get4", "getclasses");

      if (querySnapshot.empty) {
        console.error("No classes found for the given teacher ID.");
        return;
      }

      const array2 = [];
      const array = [
        { key: "123", classname: "", period: "", students: [], googleclassroomid: "" },
      ];

      querySnapshot.forEach((doc) => {
        let user = { ...doc.data(), key: doc.data().id };
        console.log(user, "see what this shows. Main Menu");
        array.push(user);
        array2.push(user);
      });

      localStorage.setItem("myclasses", JSON.stringify(array2));
      setTemparray(array);
    } catch (error) {
      console.error("Error fetching classes:", error.message || error);
      alert("Failed to fetch classes. Please check the console for details.");
    }
  }


  async function runthefunctiontogetstudents(iddddd) {
    const q = query(
      collection(firebase, "users"),
      where("teacherlist", "array-contains", id)
    );

    const snapshot1 = await getCountFromServer(q);
    const totalCount = snapshot1.data().count;
    const array = [];
    const querySnapshot = await getDocs(q)
      .then(async (snapshot) => {
        snapshot.forEach((doc) => {
          array.push(doc.data());
        });
      })
      .then(async (snapshot) => {
        console.log(array, "D");
        localStorage.setItem("allstudents", JSON.stringify(array));
        setActivestudentlist2(array);
      });
  }




  // const studentIds = [{"email":
  // "contactdingsdagames@gmail.com",
  // "firebasestudentid":"102872109319805136687",
  // "firstName":"Matthew",
  // "lastName":"Krebs",
  // "studentId":"102872109319805136687"}, {"email":
  // "krebsmathclass@gmail.com",
  // "firebasestudentid":"106072500053133932009",
  // "firstName":"Justin",
  // "lastName":"Krebs",
  // "studentId":"106072500053133932009"}]

  useEffect(() => {
    if (
      selectedStudents &&
      Array.isArray(selectedStudents) &&
      selectedStudents.length > 0 &&
      selectedclass &&
      Array.isArray(selectedclass.studentIds)
    ) {
      console.log("IS THIS RUNNING? ", selectedStudents.length)
      const filteredStudentIds = selectedclass.studentIds.filter(
        studentObj => selectedStudents.includes(studentObj.firebasestudentid)
      );
      localStorage.setItem("infoforsending", JSON.stringify(filteredStudentIds));
    }


  }, [selectedStudents, selectedclass]);




  useEffect(() => {
    if (!id) return; // Don't set up listener if id is not available

    const unsubscribe = onSnapshot(doc(firebase, "users", id), (doc) => {
      const userData = doc.data();
      if (userData) {
        const passnumber = userData.passnumber;
        if (typeof passnumber === 'string' && passnumber !== "") {
          console.log(id, " and ", passnumber, "This is the numbberr12345");
          setPasslist(passnumber);
        }
      }
    });

    // Clean up listener on component unmount or id change
    return () => unsubscribe();
  }, [id]);



  // useEffect(() =>
  //   onSnapshot(doc(firebase, "users", id), (doc) => {
  //     const userData = doc.data();
  //     if (userData) {
  //       const passnumber = userData.passnumber;

  //       if (typeof passnumber === 'string' && passnumber !== "") {
  //         console.log(id, " and ", passnumber, "This is the numbberr12345");
  //         setPasslist(passnumber);
  //       } else {
  //         console.warn("Invalid passnumber type:", typeof passnumber);
  //       }
  //     }
  //     // ...
  //   }),
  //   []
  // );


  console.log("Student objects check:", {
    activeid,
    firstStudentHasActiveidProperty: currentclass && currentclass[0] ? Boolean(currentclass[0][activeid]) : false,
    studentSample: currentclass && currentclass[0] ? Object.keys(currentclass[0]).slice(0, 5) : []
  });

  useEffect(() => {
    if (activeid && activeid !== "123" && activestudentlist2 && activestudentlist2.length > 0) {
      console.log("Rebuilding currentclass for activeid:", activeid);
      // Your existing code to build currentclass...
    }
  }, [activeid, activestudentlist2]);

  // Add this inside your App function, with your other useEffect hooks
  useEffect(() => {
    console.log('Key state changes detected:', {
      showcurrentroster,
      showcurrentpassesValue: showcurrentpasses,
      activeidValue: activeid,
      currentclassLength: currentclass ? currentclass.length : 'undefined',
      studentidd,
      componentsRendered: {
        studentsComponent: showcurrentroster === true,
        passesComponent: showcurrentroster !== true
      }
    });
  }, [showcurrentroster, showcurrentpasses, activeid, currentclass, studentidd]);

  useEffect(() => {
    if (activeid && activeid !== "123" && Array.isArray(activestudentlist2)) {
      console.log("Processing student list for class:", activeid);

      // Filter students from this class
      let current = [];

      try {
        // Make sure each student has a classlist property
        current = activestudentlist2.filter((person) =>
          Array.isArray(person.classlist) && person.classlist.includes(activeid)
        );

        // Add the property matching activeid to make the check work
        current = current.map(student => {
          const enhancedStudent = { ...student };
          enhancedStudent[activeid] = true; // This makes currentclass[0][activeid] defined
          return enhancedStudent;
        });

        console.log(`Enhanced ${current.length} students with ${activeid} property`);
      } catch (error) {
        console.error("Error enhancing student objects:", error);
      }

      setCurrentclass(current);
    }
  }, [activeid, activestudentlist2]);


  useEffect(() => {
    if (
      typeof passlist != "undefined" && passlist != "" &&
      typeof userdata2 != "undefined"
    ) {
      console.log(passlist, "This is the numbberr232");
      fetchData();
    }
  }, [passlist]);

  async function fetchData() {
    //check arrray created on the other side to adjust currrent data

    if (!passlist || typeof passlist !== 'string') {
      console.log("Invalid passlist value:", passlist);
      return;
    }

    console.log("⏺️ FETCH DATA START - Passlist:", passlist);
    console.log("⏺️ Current userdata2 before fetch:", userdata2.map(item => item.id));

    let newData = [];
    //calling tthe items one at a time.

    try {
      const docRef = doc(firebase, "passes", passlist);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const passData = docSnap.data();
        console.log("✅ Retrieved pass from Firestore:", passData.id);
        console.log("📋 Pass data:", passData);

        //entry from otherr siide iis found in datablase
        if (userdata2.some((obj) => obj.id === passlist)) {
          console.log("🔄 Updating existing pass in userdata2");

          // Create a NEW array for React state update
          const updatedData = userdata2.map((obj) =>
            obj.id === passData.id ? passData : obj
          );

          console.log("📊 Updated data IDs:", updatedData.map(item => item.id));
          setUserdata2(updatedData);
        } else {
          console.log("➕ Adding new pass to userdata2");

          // Create a NEW array for React state update
          const updatedData = [passData, ...userdata2];
          console.log("📊 New userdata2 IDs:", updatedData.map(item => item.id));
          setUserdata2(updatedData);
        }
      } else {
        console.log("❌ Pass document doesn't exist in Firestore:", passlist);
      }

      console.log("⏺️ Setting timeout for endiingfunction");
      setTimeout(() => {
        endiingfunction();
      }, 4000);

    } catch (error) {
      console.error("❌ Error fetching pass data:", error);
    }
  }

  async function inputpdftoread() {
    console.log("inputpdftoread is called");
  }

  async function endiingfunction() {
    console.log("🧹 Clearing passnumber in Firestore for user:", id);

    await updateDoc(doc(firebase, "users", id), {
      passnumber: "",
    }).catch((error) => {
      console.error("❌ Error clearing passnumber:", error);
      alert(error);
    });

    console.log("🧹 Setting passlist state to empty");
    setPasslist("");
  }


  // Add this useEffect to monitor userdata2 changes
  useEffect(() => {
    console.log("🔄 userdata2 state changed:", {
      count: userdata2.length,
      ids: userdata2.map(item => item.id).slice(0, 5) // Show first 5 IDs
    });
  }, [userdata2]);


  async function handleRemoveStudent(student) {
    if (!student || !student.id || !activeid || !id) return;

    try {
      // 1. Remove class from student's classlist and teacherlist in Firestore
      const studentDocRef = doc(firebase, "users", student.id);
      const studentSnap = await getDoc(studentDocRef);
      if (studentSnap.exists()) {
        const studentData = studentSnap.data();
        const newClassList = (studentData.classlist || []).filter(cid => cid !== activeid);
        const newTeacherList = (studentData.teacherlist || []).filter(tid => tid !== id);

        await updateDoc(studentDocRef, {
          [activeid]: "",
          classlist: newClassList,
          teacherlist: newTeacherList,
        });
      }

      // 2. Remove student from class's students and studentIds arrays in Firestore
      const classDocRef = doc(firebase, "classesbeingtaught", activeid);
      const classSnap = await getDoc(classDocRef);
      if (classSnap.exists()) {
        const classData = classSnap.data();
        const newStudents = (classData.students || []).filter(sid => sid !== student.id);
        const newStudentIds = (classData.studentIds || []).filter(
          obj => obj.firebasestudentid !== student.id
        );
        await updateDoc(classDocRef, {
          students: newStudents,
          studentIds: newStudentIds,
        });
      }

      // 3. Update local modal state (remove from notFoundStudents)
      setNotFoundStudents(prev => prev.filter(s => s.id !== student.id));

      // 4. Update local selectedclass (students and studentIds arrays)
      setSelectedclass(prev => {
        if (!prev) return prev;
        return {
          ...prev,
          students: Array.isArray(prev.students)
            ? prev.students.filter(sid => sid !== student.id)
            : prev.students,
          studentIds: Array.isArray(prev.studentIds)
            ? prev.studentIds.filter(obj => obj.firebasestudentid !== student.id)
            : prev.studentIds,
        };
      });

      // 5. Update local currentclass (remove student object)
      setCurrentclass(prev =>
        Array.isArray(prev) ? prev.filter(s => s.id !== student.id) : prev
      );

      console.log(`Removed ${student.localfirstname} ${student.locallastname} from class.`);
    } catch (error) {
      console.error("Error removing student:", error);
      alert("Failed to remove student. See console for details.");
    }
  }

  useEffect(() => {
    if (
      typeof selectedclass === "undefined" &&
      typeof activeid !== "undefined" &&
      Array.isArray(temparray)
    ) {
      const found = temparray.find(item => item.key === activeid || item.key === activeid);
      if (found) {
        setSelectedclass(found);
        console.log("selectedclass set from temparray using activeid:", found);
      }
    }
  }, [selectedclass, activeid, temparray]);

  useEffect(() => {
    // Listen for pass created events from student component
    const handlePassCreated = (event) => {
      const { newPass } = event.detail;
      setUserdata2(prev => Array.isArray(prev) ? [...prev, newPass] : [newPass]);
    };

    window.addEventListener('passCreated', handlePassCreated);

    return () => {
      window.removeEventListener('passCreated', handlePassCreated);
    };
  }, []);

  async function handleRemoveAllStudents() {
    if (!Array.isArray(notFoundStudents) || notFoundStudents.length === 0) return;

    for (const student of notFoundStudents) {
      await handleRemoveStudent(student);
    }

    // After all removals, clear the modal and update local state
    setNotFoundStudents([]);
    setShowUpdateModal(false);
  }


  async function sendpremadeemail() {
    try {

      const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
      const subject =
        (school ? school : "") +
        "-" +
        (teacheriscalled ? teacheriscalled : "") +
        ` (` +
        (coursename ? coursename : "") +
        `)`;

      // Only one student/parent: use selectedclass and related state
      const messages = [];
      const whowillbeemailedVal = typeof whowillbeemailed !== "undefined" ? whowillbeemailed : 2;

      // Build website link for parent
      let websiteforparents = "";
      if (additionallinklevel == 2) {
        websiteforparents =
          "https://fastclasspass.web.app/studentid/" +
          (studentid2 || "") +
          "/" +
          (classid2 || "") +
          "/id/" +
          (id || "") +
          "/language/" +
          (parentlangcode || "en");
      } else if (additionallinklevel > 0) {
        websiteforparents =
          "https://fastclasspass.web.app/only2studentid/" +
          (studentid2 || "") +
          "/" +
          (classid2 || "") +
          "/id/" +
          (id || "") +
          "/language/" +
          (parentlangcode || "en");
      }

      // Prepare student and parent emails
      const studentEmail = emailll;
      const parentEmail = parentemailll;
      const validStudentEmail = studentEmail && studentEmail !== "" ? studentEmail : null;
      // Handle parentEmail as array or string
      let validParentEmails = [];
      if (Array.isArray(parentEmail)) {
        validParentEmails = parentEmail.filter((e) => typeof e === "string" && e.trim() !== "");
      } else if (typeof parentEmail === "string" && parentEmail.trim() !== "") {
        validParentEmails = [parentEmail];
      }

      // Prepare student message
      let studentBody = typeof newgreeting !== "undefined" && newgreeting ? newgreeting : "";
      studentBody = studentBody
        .replaceAll("{Student Name}", studentfirstname || "")
        .replaceAll("{Student Time}", totaltimegone ? totaltimegone : "");
      // Translate if needed
      let studentBodyTranslated = studentBody;
      if (locallanguagecode && locallanguagecode !== "en") {
        try {
          const response = await axios.post(
            "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
            {
              source: "en",
              format: "text",
              q: studentBody,
              target: locallanguagecode,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          studentBodyTranslated = response.data.data.translations[0].translatedText;
        } catch (e) { /* ignore translation error */ }
      }

      // Prepare parent message
      let parentBody = typeof newgreetinga !== "undefined" && newgreetinga ? newgreetinga : "";
      parentBody = parentBody
        .replaceAll("{Student Name}", studentfirstname || "")
        .replaceAll("{Student Time}", totaltimegone ? totaltimegone : "");
      // Translate if needed
      let parentBodyTranslated = parentBody;
      if (parentlangcode && parentlangcode !== "en") {
        try {
          const response = await axios.post(
            "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
            {
              source: "en",
              format: "text",
              q: parentBody,
              target: parentlangcode,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          parentBodyTranslated = response.data.data.translations[0].translatedText;
        } catch (e) { /* ignore translation error */ }
      }
      if (websiteforparents && !parentBodyTranslated.includes(websiteforparents)) {
        parentBodyTranslated = (parentBodyTranslated || "") + "\n\n" + websiteforparents;
      }

      // Compose messages array based on whowillbeemailed
      if (whowillbeemailedVal === 0 && validStudentEmail) {
        messages.push({
          to: validStudentEmail,
          body: studentBodyTranslated,
          studentId: studentid || "",
          subject,
        });
      } else if (whowillbeemailedVal === 1 && validParentEmails.length > 0) {
        validParentEmails.forEach((email) => {
          messages.push({
            to: email,
            body: parentBodyTranslated,
            studentId: studentid || "",
            subject,
          });
        });
      } else {
        if (validStudentEmail) {
          messages.push({
            to: validStudentEmail,
            body: studentBodyTranslated,
            studentId: studentid || "",
            subject,
          });
        }
        if (validParentEmails.length > 0) {
          validParentEmails.forEach((email) => {
            messages.push({
              to: email,
              body: parentBodyTranslated,
              studentId: studentid || "",
              subject,
            });
          });
        }
      }

      if (messages.length === 0) {

        alert("No emails prepared for sending.");
        return;
      }

      try {
        await updateDoc(doc(firebase, "users", id), {
          thesearethemessages: messages,
        });
      } catch (firestoreErr) {
        console.error("Failed to save messages to Firestore:", firestoreErr);
        alert("Failed to prepare emails for sending. Please try again.");
        return;
      }

      // Try to get stored tokens from Firestore user doc
      let storedAccessToken = "";
      let storedRefreshToken = "";
      let storedExpiry = "";
      try {
        const userDoc = await getDoc(doc(firebase, "users", id));
        if (userDoc && userDoc.exists()) {
          const data = userDoc.data();
          storedAccessToken = data?.access_token || "";
          storedRefreshToken = data?.refresh_token || "";
          storedExpiry = data?.expiry_date || data?.expiryDate || "";
        }
      } catch (e) {
        console.warn("Failed to read tokens from Firestore:", e);
      }

      try {
        const currentUrl = window.location.href;
        const redirectUrl = currentUrl;

        const stateObj = {
          id,
          currentUrl,
          task: "sendEmail",
          redirectUrl,
          subject,
          thesearethemessages: messages,
          studentLinks: [],
          locallinklevel: additionallinklevel,
          localclassid: classid2,
          localteacherid: id,
          email: localemailaddress,
        };

        // request backend to start OAuth and return authUrl
        const q = `${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify(stateObj))}`;
        console.log("Requesting OAuth authUrl:", q);

        const loginResp = await fetch(q, { method: "GET" });
        if (!loginResp.ok) {
          const txt = await loginResp.text().catch(() => "");
          throw new Error(`Auth request failed ${loginResp.status} ${txt}`);
        }
        const loginData = await loginResp.json();
        if (loginData && loginData.authUrl) {
          const authUrl = typeof loginData.authUrl === "string" ? loginData.authUrl.trim() : "";

          if (loginData?.directExecution === true) {
            const directResultUrl =
              typeof loginData?.redirectUrl === "string" && loginData.redirectUrl.trim().length > 0
                ? loginData.redirectUrl.trim()
                : authUrl;
            const parsedResult = directResultUrl ? parseEmailResultFromUrl(directResultUrl) : null;
            const hydratedResult = await hydrateEmailSendResultFromFirestore(parsedResult);

            if (hydratedResult?.flowCompleted || hydratedResult?.status === "success") {
              openEmailReportModal(hydratedResult);
            } else {
              showNoEmailsSentReport(
                messages.length,
                hydratedResult?.modalMessage ||
                hydratedResult?.alert ||
                "Email send flow returned an incomplete direct result."
              );
            }

            setSendEmail(false);
            return;
          }

          if (!authUrl || !/^https?:\/\//i.test(authUrl)) {
            throw new Error(`Invalid authUrl returned from backend: ${authUrl}`);
          }

          if (typeof window !== "undefined" && window.location) {
            window.location.href = authUrl;
          } else {
            throw new Error("Browser navigation unavailable for OAuth redirect.");
          }
          return;
        } else {
          throw new Error("No authUrl returned from backend");
        }
      } catch (err) {
        console.error("Failed to initiate OAuth flow:", err);

        alert("Failed to initiate Gmail authentication/send flow. See console for details.");
        return { success: false, error: err };
      }
    } catch (err) {

      console.error("setpremadeemail error:", err);
      alert("Error preparing or sending emails. See console for details.");
      return { success: false, error: err };
    }
  }


  async function gogetlastttengcassiignments999(activeid, gclassroomid) {

    if (typeof gclassroomid != "undefined") {

      const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
      const currentUrl = window.location.href;

      const isProduction = process.env.NODE_ENV === "production";
      const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
      const redirectUrl = `${baseUrl}/role/${role}/mainmenu/id/${id}/gcassignments`;

      // Open window FIRST (before async call) to avoid popup blocker


      try {
        const stateParamAssign = JSON.stringify({
          id: id,
          currentUrl: currentUrl,
          task: "gogetlastttengcassiignments",
          redirectUrl: redirectUrl,
          courseId: gclassroomid,
          databasecourseId: activeid,
          allowImmediateTaskResult: true,
          email: localemailaddress,
        });
        const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(stateParamAssign)}`, { method: "GET", redirect: "manual" });

        console.log("gogetlastttengcassiignments login response type:", response.type, "status:", response.status);

        // Backend redirected → task completed successfully; navigate manually to avoid CORS on redirect
        if (response.type === "opaqueredirect" || (response.status >= 300 && response.status < 400)) {
          window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
          return;
        }

        const dataAssign = await response.json();

        console.log("gogetlastttengcassiignments login response:", {
          hasAuthUrl: !!dataAssign?.authUrl,
          directExecution: !!dataAssign?.directExecution,
          hasRedirectUrl: !!dataAssign?.redirectUrl,
          success: dataAssign?.success,
        });

        if (dataAssign?.directExecution === true) {
          const directResultUrl =
            typeof dataAssign?.redirectUrl === "string" && dataAssign.redirectUrl.trim().length > 0
              ? dataAssign.redirectUrl.trim()
              : typeof dataAssign?.authUrl === "string"
                ? dataAssign.authUrl.trim()
                : redirectUrl;

          if (!directResultUrl) {
            console.error("Direct execution completed without a redirect URL:", dataAssign);
            alert("Assignments were fetched, but no redirect URL was returned.");
            return;
          }

          window.location.href = directResultUrl;
          return;
        }

        const authUrl = typeof dataAssign?.authUrl === "string" ? dataAssign.authUrl.trim() : "";

        if (authUrl) {
          if (!/^https?:\/\//i.test(authUrl)) {
            console.error("Invalid auth URL returned from the server:", authUrl);
            alert("Failed to retrieve a valid authentication URL.");
            return;
          }

          window.open(authUrl, "_blank", "noopener,noreferrer");

        } else {

          console.error("Auth URL not received from the server.");
          alert("Failed to retrieve the authentication URL.");
        }
      } catch (error) {

        console.error("Error during login:", error.message);
        alert("Failed to initiate login. Please check the console for details.");
      }
    }
  }
  const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";

  async function getsyllabus() {
    console.log("[Syllabus] getsyllabus() called");
    console.log("[Syllabus] localemailaddress at open time:", localemailaddress || "(empty — not yet set)");
    console.log("[Syllabus] id (teacher firebase uid):", id);
    console.log("[Syllabus] activeid:", activeid);
    console.log("[Syllabus] gclassroomid:", gclassroomid);
    // NOTE: The Google account icon shown in the embedded iframe is whichever
    // account is actively signed into the browser — it cannot be set via URL params.
    // authuser=0/1/2 in embedded iframes picks by account index, not email.
    // If the wrong account shows, the browser simply has that account signed in first.
    console.log("[Syllabus] Browser account note: the icon in the iframe reflects whichever Google account is currently active in this browser, not necessarily localemailaddress.");
    setShowSyllabusModal(true);
    setSyllabusModalError(null);
    setSyllabusGenerating(false);
    setSyllabusModalLoading(true);
    setSyllabusInfo(null);

    try {
      // Fetch existing syllabus from Firestore class document
      if (activeid && activeid !== "123") {
        const classSnap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
        console.log("classesbeingtaught get5 getsyllabus");
        if (classSnap.exists()) {
          const data = classSnap.data();
          setSyllabusInfo(data.syllabus || null);
        }
      }
    } catch (err) {
      console.error("[Syllabus] Error fetching syllabus from Firestore:", err);
      setSyllabusModalError("Could not load existing syllabus.");
    } finally {
      setSyllabusModalLoading(false);
    }
  }

  async function generateSyllabusFromBackend() {
    if (!gclassroomid || !activeid || !id) {
      setSyllabusModalError("Missing course or teacher information. Please select a class first.");
      return;
    }
    setSyllabusGenerating(true);
    setSyllabusModalError(null);

    try {
      const stateObj = {
        preferJsonResponse: true,
        task: "generateSyllabus",
        courseId: gclassroomid,
        id: id,
        teacherId: id,
        databasecourseId: activeid,
        currentUrl: window.location.href,
        redirectUrl: window.location.href,
        email: localemailaddress || null,
        location: selectedclass?.location || null,
        period: selectedclass?.period || null,
        school: school || null,
        town: town || null,
        state: state || null,
        classname: coursename || null,
        teacheriscalled: teacheriscalled || null,
      };

      const url = `${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify(stateObj))}`;
      const existingTimestamp = syllabusInfo?.generatedAt || null;

      const response = await fetch(url, { method: "GET" });
      const contentType = response.headers.get("content-type") || "";

      if (!contentType.includes("application/json")) {
        throw new Error(`Unexpected response while starting syllabus flow (${response.status})`);
      }

      const data = await response.json();

      if (data.directExecution === true || data.result?.success === true || data.success === true) {
        const classSnap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
        console.log("classesbeingtaught get6 getsyllabus from backend");
        if (classSnap.exists()) setSyllabusInfo(classSnap.data().syllabus || null);
        return;
      }

      if (!data.authUrl) {
        if (data.error) throw new Error(data.error);
        throw new Error("Failed to start syllabus authorization.");
      }

      const width = 600, height = 700;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;
      const popup = window.open(data.authUrl, "SyllabusOAuth", `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);

      if (!popup) {
        setSyllabusModalError("Popup blocked. Please allow popups and try again.");
        return;
      }

      await new Promise((resolve) => {
        let resolved = false;
        const finish = (newSyllabus) => {
          if (resolved) return;
          resolved = true;
          clearInterval(popupTimer);
          clearInterval(firestoreTimer);
          clearTimeout(maxTimer);
          if (popup && !popup.closed) popup.close();
          if (newSyllabus) setSyllabusInfo(newSyllabus);
          resolve();
        };

        const popupTimer = setInterval(() => {
          try {
            if (popup.closed) finish(null);
          } catch (e) { }
        }, 500);

        const firestoreTimer = setInterval(async () => {
          try {
            const snap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
            console.log("classesbeingtaught get7 getsyllabus from backend firestoreTimer");
            if (snap.exists()) {
              const newSyllabus = snap.data().syllabus;
              if (newSyllabus && newSyllabus.generatedAt !== existingTimestamp) {
                finish(newSyllabus);
              }
            }
          } catch (e) { }
        }, 2000);

        const maxTimer = setTimeout(() => finish(null), 300000);
      });
    } catch (err) {
      console.error("[Syllabus] generateSyllabusFromBackend error:", err);
      setSyllabusModalError(err.message || "Failed to generate syllabus.");
    } finally {
      setSyllabusGenerating(false);
    }
  }

  function getGoogleDocEmbedUrl(docIdOrLink) {
    let docId = docIdOrLink;
    if (docIdOrLink && docIdOrLink.includes("docs.google.com")) {
      const match = docIdOrLink.match(/\/d\/([a-zA-Z0-9_-]+)/);
      if (match) docId = match[1];
    }
    return `https://docs.google.com/document/d/${docId}/edit?embedded=true`;
  }

  function renderSyllabusModal() {
    if (!showSyllabusModal) return null;
    const hasSyllabus = syllabusInfo && syllabusInfo.documentLink;

    return (
      <div
        style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center",
          justifyContent: "center", zIndex: 9999,
        }}
        onClick={(e) => { if (e.target === e.currentTarget) setShowSyllabusModal(false); }}
      >
        <div style={{
          position: "relative", width: "90%", height: "90%", background: "#fff",
          borderRadius: "8px", boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
          display: "flex", flexDirection: "column", overflow: "hidden", fontFamily: "Arial, sans-serif",
        }}>
          {/* Header */}
          <div style={{
            padding: "16px 20px", borderBottom: "1px solid #e0e0e0",
            display: "flex", justifyContent: "space-between", alignItems: "center",
            background: "#f8f9fa", flexShrink: 0,
          }}>
            <div>
              <h2 style={{ margin: 0, fontSize: "20px", color: "#202124" }}>
                {syllabusInfo?.documentTitle || "Syllabus"}
              </h2>
              {syllabusInfo?.generatedAt && (
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#5f6368" }}>
                  Last generated: {new Date(syllabusInfo.generatedAt).toLocaleDateString()} at {new Date(syllabusInfo.generatedAt).toLocaleTimeString()}
                </p>
              )}
            </div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <button
                onClick={generateSyllabusFromBackend}
                disabled={syllabusGenerating}
                style={{
                  padding: "8px 16px", background: syllabusGenerating ? "#aaa" : "#1f73e6",
                  color: "#fff", border: "none", borderRadius: "4px", cursor: syllabusGenerating ? "not-allowed" : "pointer", fontSize: "14px",
                }}
              >
                {syllabusGenerating ? "Generating…" : hasSyllabus ? "Regenerate" : "Generate"}
              </button>
              {hasSyllabus && (
                <button
                  onClick={() => {
                    const base = syllabusInfo.documentLink.split('?')[0];
                    const openUrl = localemailaddress
                      ? `${base}?authuser=${encodeURIComponent(localemailaddress)}`
                      : syllabusInfo.documentLink;
                    window.open(openUrl, "_blank");
                  }}
                  style={{
                    padding: "8px 16px", background: "#34a853", color: "#fff",
                    border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "14px",
                  }}
                >
                  Open in Google Docs
                </button>
              )}
              <button
                onClick={() => setShowSyllabusModal(false)}
                style={{ padding: "4px 12px", background: "transparent", color: "#5f6368", border: "none", cursor: "pointer", fontSize: "24px" }}
              >
                ✕
              </button>
            </div>
          </div>

          {/* Content */}
          <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", background: "#fff" }}>
            {syllabusModalLoading ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#5f6368" }}>
                <div style={{ fontSize: "24px", marginBottom: "16px" }}>⏳</div>
                <p>Loading syllabus…</p>
              </div>
            ) : syllabusGenerating ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#5f6368" }}>
                <div style={{ fontSize: "24px", marginBottom: "16px" }}>⏳</div>
                <p>Generating syllabus… Please wait.</p>
                <p style={{ fontSize: "12px" }}>This may take a moment.</p>
              </div>
            ) : syllabusModalError ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#d93025", padding: "20px", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
                <p style={{ fontSize: "18px", marginBottom: "8px" }}>Error</p>
                <p style={{ fontSize: "14px" }}>{syllabusModalError}</p>
              </div>
            ) : hasSyllabus ? (
              <iframe
                src={getGoogleDocEmbedUrl(syllabusInfo.documentId || syllabusInfo.documentLink)}
                style={{ flex: 1, width: "100%", border: "none", height: "100%" }}
                title="Syllabus"
                allowFullScreen
              />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#5f6368", padding: "20px", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>📄</div>
                <p style={{ fontSize: "18px", marginBottom: "8px" }}>No syllabus generated yet</p>
                <p style={{ fontSize: "14px" }}>Click "Generate" to create a syllabus for this course.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ─── Curriculum Map ──────────────────────────────────────────────────────────

  async function getcurriculummap() {
    console.log("[CurriculumMap] getcurriculummap() called");
    setShowCurriculumMapModal(true);
    setCurriculumMapModalError(null);
    setCurriculumMapGenerating(false);
    setCurriculumMapModalLoading(true);
    setCurriculumMapInfo(null);
    setStandardsInputVisible(false);
    setStandardsUrlDraft("");

    try {
      if (activeid && activeid !== "123") {
        const classSnap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
        console.log("classesbeingtaught get8 getcurriculummap from backend");
        if (classSnap.exists()) {
          const data = classSnap.data();
          setCurriculumMapInfo(data.curriculumMap || null);
          setLinkToStateStandards(data.linkToStateStandards || "");
        }
      }
    } catch (err) {
      console.error("[CurriculumMap] Error fetching from Firestore:", err);
      setCurriculumMapModalError("Could not load existing curriculum map.");
    } finally {
      setCurriculumMapModalLoading(false);
    }
  }

  function extractGoogleDriveFileId(value) {
    if (!value || typeof value !== "string") return null;
    const trimmed = value.trim();
    const directIdMatch = trimmed.match(/^[a-zA-Z0-9_-]{20,}$/);
    if (directIdMatch) return directIdMatch[0];
    const pathMatch = trimmed.match(/\/d\/([a-zA-Z0-9_-]+)/);
    if (pathMatch) return pathMatch[1];
    const queryMatch = trimmed.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (queryMatch) return queryMatch[1];
    return null;
  }

  function getGoogleDrivePdfPreviewUrl(answerSheet) {
    const fileId = extractGoogleDriveFileId(answerSheet?.documentId || answerSheet?.previewLink || answerSheet?.documentLink || "");
    return fileId ? `https://drive.google.com/file/d/${fileId}/preview` : null;
  }

  function getGoogleDrivePdfDownloadUrl(answerSheet) {
    if (answerSheet?.downloadLink) return answerSheet.downloadLink;
    const fileId = extractGoogleDriveFileId(answerSheet?.documentId || answerSheet?.documentLink || "");
    return fileId ? `https://drive.google.com/uc?export=download&id=${fileId}` : answerSheet?.documentLink || null;
  }


  // //partofoldcorrectingcode
  // async function syncAnswerSheetInfo(fallbackInfo = null) {
  //   if (activeid && activeid !== "123") {
  //     const classSnap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
  //     console.log("classesbeingtaught get9 getanswersheetinfo from backend");
  //     if (classSnap.exists()) {
  //       const latestInfo = classSnap.data().activeAnswerKeyAssignment || null;
  //       const latestActiveAnswerKey = classSnap.data().activeAnswerKeyAssignment || null;
  //       const resolved = latestInfo || fallbackInfo;
  //       setAnswerSheetInfo(resolved);
  //       setActiveAnswerKeyInfo(latestActiveAnswerKey);
  //       setAnswerSheetAssignmentTitle(latestActiveAnswerKey?.assignmentTitle || resolved?.assignmentTitle || "");
  //       if (resolved?.versionCount) {
  //         setAnswerSheetVersionCount(String(resolved.versionCount));
  //       } else if (latestActiveAnswerKey?.versionCount) {
  //         setAnswerSheetVersionCount(String(latestActiveAnswerKey.versionCount));
  //       }
  //       return;
  //     }
  //   }
  //   if (typeof resolved !== "undefined" && resolved?.versionCount) {
  //     setAnswerSheetVersionCount(String(resolved.versionCount));
  //   }
  //   if (fallbackInfo) {
  //     setAnswerSheetInfo(fallbackInfo);
  //   }
  // }

  async function saveStandardsLink(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      setCurriculumMapModalError("Please enter a valid URL starting with http:// or https://");
      return;
    }
    try {
      if (activeid && activeid !== "123") {
        await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
          linkToStateStandards: url,
        });
      }
      setLinkToStateStandards(url);
      setStandardsInputVisible(false);
      setStandardsUrlDraft("");
      setCurriculumMapModalError(null);
    } catch (err) {
      console.error("[CurriculumMap] Error saving standards link:", err);
      setCurriculumMapModalError("Could not save the link. Please try again.");
    }
  }
  //partofoldcorrectingcode
  async function uploadPdfAndGetUrl(file, { folder, fileName }) {
    if (!file) {
      throw new Error("A file is required before upload.");
    }

    const storage = getStorage();
    const safeFileName = `${Date.now()}-${String(fileName || file.name || "document.pdf").replace(/[^a-zA-Z0-9._-]/g, "_")}`;
    const storagePath = `${folder}/${safeFileName}`;
    const storageRef = ref(storage, storagePath);

    await uploadBytes(storageRef, file, {
      contentType: file.type || "application/pdf",
    });

    return getDownloadURL(storageRef);
  }

  //partofoldcorrectingcode
  async function loadPendingHandwritingReviews() {
    if (!activeid || activeid === "123") {
      setPendingHandwritingReviews([]);
      return;
    }
    try {
      const reviewsRef = collection(firebase, "classesbeingtaught", activeid, "pendingHandwritingReviews");
      const reviewsQuery = query(reviewsRef, where("status", "==", "pending"));
      const snapshot = await getDocs(reviewsQuery);
      console.log("classesbeingtaught get10 loadPendingHandwritingReviews from backend");
      const reviews = snapshot.docs.map((docSnap) => ({ reviewId: docSnap.id, ...(docSnap.data() || {}) }));
      setPendingHandwritingReviews(reviews);
    } catch (error) {
      console.error("[Correcting] loadPendingHandwritingReviews error:", error);
      setPendingHandwritingReviews([]);
    }
  }
  //partofoldcorrectingcode
  function setHandwritingReviewChoice(reviewId, questionNumber, reading) {
    setHandwritingReviewChoices((previous) => ({
      ...previous,
      [reviewId]: {
        ...(previous[reviewId] || {}),
        [questionNumber]: reading,
      },
    }));
  }
  //partofoldcorrectingcode
  async function resolveHandwritingReviewFromBackend(review) {
    if (!activeid || !id) {
      setHandwritingReviewError("Missing class or teacher information. Please select a class first.");
      return;
    }

    const choices = handwritingReviewChoices[review.reviewId] || {};
    const flags = Array.isArray(review.flags) ? review.flags : [];
    const everyFlagChosen = flags.every((flag) => choices[flag.questionNumber] != null && choices[flag.questionNumber] !== "");
    if (!everyFlagChosen) {
      setHandwritingReviewError("Choose a reading for every highlighted answer before resolving this review.");
      return;
    }

    setResolvingHandwritingReviewId(review.reviewId);
    setHandwritingReviewError(null);

    const stateObj = {
      allowImmediateTaskResult: true,
      preferJsonResponse: true,
      task: "correctandsendassignmentstogc",
      courseId: gclassroomid || null,
      id,
      teacherId: id,
      databasecourseId: activeid,
      currentUrl: window.location.href,
      redirectUrl: window.location.href,
      email: localemailaddress || null,
      handwritingReviewResolution: {
        reviewId: review.reviewId,
        choices,
      },
    };

    const startTask = async () => {
      const url = `${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify(stateObj))}`;
      const response = await fetch(url, { method: "GET" });
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        throw new Error(`Unexpected response while resolving handwriting review (${response.status})`);
      }
      const rawBody = await response.text();
      if (!rawBody || !rawBody.trim()) {
        throw new Error(`Resolve flow returned an empty JSON body (${response.status}).`);
      }
      return JSON.parse(rawBody);
    };

    const applyResolved = (resolvedPayload) => {
      const remaining = Array.isArray(resolvedPayload.remainingPendingHandwritingReviews)
        ? resolvedPayload.remainingPendingHandwritingReviews
        : null;
      if (remaining) {
        setPendingHandwritingReviews(remaining);
      } else {
        loadPendingHandwritingReviews().catch(() => { });
      }
      const outcome = resolvedPayload.resolutionOutcome || null;
      setCorrectingPrimaryActionFeedback(
        outcome && outcome.gradePosted
          ? `Resolved and posted ${outcome.studentLabel || "the student"}'s grade${typeof outcome.draftGrade === "number" ? ` (${outcome.draftGrade}/${outcome.maxPoints})` : ""}.`
          : "Handwriting review resolved.",
      );
    };

    try {
      let data = await startTask();
      let payload = data.result ?? data;

      if (data.directExecution === true || payload.handwritingReviewResolved === true || payload.success === true) {
        applyResolved(payload);
        return;
      }

      if (data.authUrl) {
        const width = 600;
        const height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        const popup = window.open(
          data.authUrl,
          "CorrectAndSendAssignmentsOAuth",
          `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`,
        );
        if (!popup) {
          throw new Error("Popup blocked. Please allow popups and try again.");
        }
        await new Promise((resolve, reject) => {
          let resolved = false;
          const finish = (error = null) => {
            if (resolved) return;
            resolved = true;
            clearInterval(popupTimer);
            clearTimeout(maxTimer);
            if (popup && !popup.closed) popup.close();
            if (error) reject(error);
            else resolve();
          };
          const popupTimer = setInterval(() => {
            try {
              if (popup.closed) finish();
            } catch (_) { }
          }, 500);
          const maxTimer = setTimeout(() => {
            finish(new Error("Authorization timed out. Please try again."));
          }, 300000);
        });

        data = await startTask();
        payload = data.result ?? data;
        if (data.directExecution === true || payload.handwritingReviewResolved === true || payload.success === true) {
          applyResolved(payload);
          return;
        }
      }

      if (payload.error) {
        throw new Error(payload.error);
      }
      throw new Error(payload.message || "Failed to resolve the handwriting review.");
    } catch (err) {
      console.error("[Correcting] resolveHandwritingReviewFromBackend error:", err);
      setHandwritingReviewError(err.message || "Failed to resolve the handwriting review.");
    } finally {
      setResolvingHandwritingReviewId(null);
    }
  }
  //partofoldcorrectingcode

  async function generateCurriculumMapFromBackend() {
    if (!gclassroomid || !activeid || !id) {
      setCurriculumMapModalError("Missing course or teacher information. Please select a class first.");
      return;
    }
    if (!linkToStateStandards) {
      setCurriculumMapModalError("Please add a State Standards link before generating.");
      return;
    }
    setCurriculumMapGenerating(true);
    setCurriculumMapModalError(null);

    try {
      const stateObj = {
        allowImmediateTaskResult: true,
        preferJsonResponse: true,
        task: "generateCurriculumMap",
        courseId: gclassroomid,
        id: id,
        teacherId: id,
        databasecourseId: activeid,
        currentUrl: window.location.href,
        redirectUrl: window.location.href,
        email: localemailaddress || null,
        location: selectedclass?.location || null,
        period: selectedclass?.period || null,
        school: school || null,
        town: town || null,
        state: state || null,
        classname: coursename || null,
        teacheriscalled: teacheriscalled || null,
        linkToStateStandards: linkToStateStandards,
        existingCurriculumMapDocId: curriculumMapInfo?.documentId || null,
      };

      const url = `${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify(stateObj))}`;
      const existingTimestamp = curriculumMapInfo?.generatedAt || null;
      const response = await fetch(url, { method: "GET" });
      const contentType = response.headers.get("content-type") || "";

      if (!contentType.includes("application/json")) {
        throw new Error(`Unexpected response while starting curriculum map flow (${response.status})`);
      }

      const data = await response.json();

      if (data.directExecution === true || data.result?.success === true || data.success === true) {

        const classSnap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
        console.log("classesbeingtaught get11 getcurriculummap from backend");
        if (classSnap.exists()) setCurriculumMapInfo(classSnap.data().curriculumMap || null);
        return;
      }

      if (!data.authUrl) {
        if (data.error) throw new Error(data.error);
        throw new Error("Failed to start curriculum map authorization.");
      }

      const width = 600, height = 700;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;
      const popup = window.open(data.authUrl, "CurriculumMapOAuth", `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
      if (!popup) {
        setCurriculumMapModalError("Popup blocked. Please allow popups and try again.");
        return;
      }
      await new Promise((resolve) => {
        let resolved = false;
        const finish = (newMap) => {
          if (resolved) return;
          resolved = true;
          clearInterval(popupTimer);
          clearInterval(firestoreTimer);
          clearTimeout(maxTimer);
          if (popup && !popup.closed) popup.close();
          if (newMap) setCurriculumMapInfo(newMap);
          resolve();
        };
        const popupTimer = setInterval(() => {
          try { if (popup.closed) finish(null); } catch (e) { }
        }, 500);
        const firestoreTimer = setInterval(async () => {
          try {
            const snap = await getDoc(doc(firebase, "classesbeingtaught", activeid));
            console.log("classesbeingtaught get12 getcurriculummap from backend");
            if (snap.exists()) {
              const newMap = snap.data().curriculumMap;
              if (newMap && newMap.generatedAt !== existingTimestamp) finish(newMap);
            }
          } catch (e) { }
        }, 2000);
        const maxTimer = setTimeout(() => finish(null), 300000);
      });
    } catch (err) {
      console.error("[CurriculumMap] generateCurriculumMapFromBackend error:", err);
      setCurriculumMapModalError(err.message || "Failed to generate curriculum map.");
    } finally {
      setCurriculumMapGenerating(false);
    }
  }

  function renderCurriculumMapModal() {
    if (!showCurriculumMapModal) return null;
    const hasMap = curriculumMapInfo && curriculumMapInfo.documentLink;

    return (
      <div
        style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center",
          justifyContent: "center", zIndex: 9999,
        }}
        onClick={(e) => { if (e.target === e.currentTarget) setShowCurriculumMapModal(false); }}
      >
        <div style={{
          position: "relative", width: "90%", height: "90%", background: "#fff",
          borderRadius: "8px", boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
          display: "flex", flexDirection: "column", overflow: "hidden", fontFamily: "Arial, sans-serif",
        }}>
          {/* Header */}
          <div style={{
            padding: "16px 20px", borderBottom: "1px solid #e0e0e0",
            display: "flex", justifyContent: "space-between", alignItems: "center",
            background: "#f8f9fa", flexShrink: 0,
          }}>
            <div>
              <h2 style={{ margin: 0, fontSize: "20px", color: "#202124" }}>
                {curriculumMapInfo?.documentTitle || "Curriculum Map"}
              </h2>
              {curriculumMapInfo?.generatedAt && (
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#5f6368" }}>
                  Last generated: {new Date(curriculumMapInfo.generatedAt).toLocaleDateString()} at {new Date(curriculumMapInfo.generatedAt).toLocaleTimeString()}
                </p>
              )}
            </div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <button
                onClick={generateCurriculumMapFromBackend}
                disabled={curriculumMapGenerating}
                style={{
                  padding: "8px 16px", background: curriculumMapGenerating ? "#aaa" : "#1f73e6",
                  color: "#fff", border: "none", borderRadius: "4px",
                  cursor: curriculumMapGenerating ? "not-allowed" : "pointer", fontSize: "14px",
                }}
              >
                {curriculumMapGenerating ? "Generating…" : hasMap ? "Regenerate" : "Generate"}
              </button>
              {hasMap && (
                <button
                  onClick={() => {
                    const docId = curriculumMapInfo.documentId ||
                      (curriculumMapInfo.documentLink.match(/\/d\/([a-zA-Z0-9_-]+)/) || [])[1];
                    if (docId) {
                      window.open(`https://docs.google.com/document/d/${docId}/export?format=pdf`, "_blank");
                    } else {
                      window.open(curriculumMapInfo.documentLink, "_blank");
                    }
                  }}
                  style={{
                    padding: "8px 16px", background: "#34a853", color: "#fff",
                    border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "14px",
                  }}
                >
                  Download PDF
                </button>
              )}
              <button
                onClick={() => setShowCurriculumMapModal(false)}
                style={{ padding: "4px 12px", background: "transparent", color: "#5f6368", border: "none", cursor: "pointer", fontSize: "24px" }}
              >
                ✕
              </button>
            </div>
          </div>

          {/* State Standards Row */}
          <div style={{
            padding: "10px 20px", borderBottom: "1px solid #e0e0e0",
            background: "#fafafa", flexShrink: 0,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span style={{ fontWeight: 500, fontSize: "14px", color: "#202124" }}>State Standards:</span>
              {linkToStateStandards ? (
                <a href={linkToStateStandards} target="_blank" rel="noreferrer"
                  style={{ fontSize: "14px", color: "#1a73e8", maxWidth: "480px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {linkToStateStandards}
                </a>
              ) : (
                <span style={{ fontSize: "14px", color: "#5f6368", fontStyle: "italic" }}>Not set</span>
              )}
              <button
                onClick={() => { setStandardsInputVisible(!standardsInputVisible); setStandardsUrlDraft(linkToStateStandards || ""); setCurriculumMapModalError(null); }}
                style={{
                  padding: "5px 12px", background: "#f1f3f4", color: "#202124",
                  border: "1px solid #dadce0", borderRadius: "4px", cursor: "pointer", fontSize: "13px",
                }}
              >
                {linkToStateStandards ? "Replace" : "Add"}
              </button>
            </div>

            {standardsInputVisible && (
              <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", gap: "8px" }}>
                <p style={{ margin: 0, fontSize: "12px", color: "#5f6368" }}>
                  Paste a public web page URL containing the state standards (e.g. a state education dept page).
                </p>
                <div style={{ display: "flex", gap: "8px" }}>
                  <input
                    type="text"
                    value={standardsUrlDraft}
                    onChange={(e) => setStandardsUrlDraft(e.target.value)}
                    placeholder="https://..."
                    style={{
                      flex: 1, padding: "8px 10px", border: "1px solid #dadce0",
                      borderRadius: "4px", fontSize: "14px",
                    }}
                  />
                  <button
                    onClick={() => saveStandardsLink(standardsUrlDraft.trim())}
                    style={{
                      padding: "8px 16px", background: "#1a73e8", color: "#fff",
                      border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "14px",
                    }}
                  >
                    Save
                  </button>
                  <button
                    onClick={() => { setStandardsInputVisible(false); setStandardsUrlDraft(""); }}
                    style={{
                      padding: "8px 16px", background: "#f1f3f4", color: "#202124",
                      border: "1px solid #dadce0", borderRadius: "4px", cursor: "pointer", fontSize: "14px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Content */}
          <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", background: "#fff" }}>
            {curriculumMapModalLoading ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#5f6368" }}>
                <div style={{ fontSize: "24px", marginBottom: "16px" }}>⏳</div>
                <p>Loading…</p>
              </div>
            ) : curriculumMapGenerating ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#5f6368" }}>
                <div style={{ fontSize: "24px", marginBottom: "16px" }}>⏳</div>
                <p>Generating curriculum map… Please wait.</p>
                <p style={{ fontSize: "12px" }}>This may take a moment.</p>
              </div>
            ) : curriculumMapModalError ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#d93025", padding: "20px", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
                <p style={{ fontSize: "18px", marginBottom: "8px" }}>Error</p>
                <p style={{ fontSize: "14px" }}>{curriculumMapModalError}</p>
              </div>
            ) : hasMap ? (
              <iframe
                src={`https://docs.google.com/document/d/${curriculumMapInfo.documentId ||
                  (curriculumMapInfo.documentLink.match(/\/d\/([a-zA-Z0-9_-]+)/) || [])[1]
                  }/edit?embedded=true`}
                style={{ flex: 1, width: "100%", border: "none", height: "100%" }}
                title="Curriculum Map"
                allowFullScreen
              />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", color: "#5f6368", padding: "20px", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>🗺️</div>
                <p style={{ fontSize: "18px", marginBottom: "8px" }}>No curriculum map generated yet</p>
                <p style={{ fontSize: "14px" }}>Add a State Standards link above, then click "Generate".</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  function closeCorrectAssignmentModal() {
    hasUserEditedCorrectingAssignmentTitleRef.current = false;
    setShowCorrectAssignmentModal(false);
    setCorrectAssignmentTooltip(null);
    setShowCorrectingSpecialInstructions(false);
    setShowCorrectingGradingNorms(false);
    setAnswerSheetPdf([]);
    setTestsToSolvePdf([]);
    setStudentWorkPdf([]);
    setCorrectingGenerating(false);
    setCorrectingProgressMessage("");
    setCorrectingModalError(null);
    setCorrectingOrientationIssue(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");
    setSelectedAnswerVersionPreviewId("");
  }

  function handleCorrectingAnswerSourceModeChange(nextMode) {
    const resolvedMode = nextMode === "solve-test" ? "solve-test" : "answer-key";
    setCorrectingAnswerSourceMode(resolvedMode);
    localStorage.setItem("correctingAnswerSourceMode", resolvedMode);
    if (resolvedMode === "answer-key") {
      setTestsToSolvePdf([]);
    } else {
      setAnswerSheetPdf([]);
    }
    setCorrectingModalError(null);
    setCorrectingOrientationIssue(null);
    setCorrectingReport(null);
    setCorrectingPrimaryActionFeedback("");
  }

  function buildStudentCodeDisplayRoster(rawRoster = []) {
    return (Array.isArray(rawRoster) ? rawRoster : [])
      .map((student, index) => {
        const firstName = String(student?.firstName || student?.firstname || "").trim();
        const lastName = String(student?.lastName || student?.lastname || "").trim();
        const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
        const email = String(student?.email || "").trim();
        const sortName = `${lastName.toLowerCase()} ${firstName.toLowerCase()} ${email.toLowerCase()}`.trim();

        return {
          firstName,
          lastName,
          fullName: fullName || email || `Student ${index + 1}`,
          email,
          sortName: sortName || `${index}`,
        };
      })
      .filter((student) => student.fullName)
      .sort((left, right) => left.sortName.localeCompare(right.sortName))
      .map((student, index) => ({
        ...student,
        displayCode: String(index + 1),
      }));
  }

  // Attaches the same student code shown on the front end (displayCode) to each
  // roster student as `studentIdentifier`, so the backend can match each page
  // deterministically by the exact number the student wrote — no AI guessing.
  function buildRosterStudentsWithStudentIdentifier(rawRoster = []) {
    const sourceRoster = Array.isArray(rawRoster) ? rawRoster : [];
    const displayRoster = buildStudentCodeDisplayRoster(sourceRoster);
    const displayCodeBySortName = new Map(
      displayRoster.map((student) => [student.sortName, student.displayCode])
    );

    return sourceRoster.map((student) => {
      const firstName = String(student?.firstName || student?.firstname || "").trim();
      const lastName = String(student?.lastName || student?.lastname || "").trim();
      const email = String(student?.email || "").trim();
      const sortName = `${lastName.toLowerCase()} ${firstName.toLowerCase()} ${email.toLowerCase()}`.trim();
      const displayCode = displayCodeBySortName.get(sortName);

      return displayCode
        ? { ...student, studentIdentifier: displayCode }
        : { ...student };
    });
  }

  function closeStudentCodeHelperModal() {
    setShowStudentCodeHelperModal(false);
  }

  function showCorrectAssignmentTooltip(event, message = "Ready to give the test? Click here for student test codes to display on the board.", width = 300) {
    const rect = event.currentTarget.getBoundingClientRect();
    const tooltipWidth = width;
    const gutter = 16;
    const preferredLeft = rect.right + gutter;
    const fallbackLeft = rect.left - tooltipWidth - gutter;
    const left = preferredLeft + tooltipWidth <= window.innerWidth - gutter
      ? preferredLeft
      : Math.max(gutter, fallbackLeft);
    const top = Math.min(
      window.innerHeight - 24,
      Math.max(24, rect.top + rect.height / 2)
    );

    setCorrectAssignmentTooltip({ top, left, message, width: tooltipWidth });
  }

  function hideCorrectAssignmentTooltip() {
    setCorrectAssignmentTooltip(null);
  }

  function renderCorrectAssignmentTooltip() {
    if (!correctAssignmentTooltip || typeof document === "undefined") {
      return null;
    }

    return createPortal(
      <div
        style={{
          position: "fixed",
          top: `${correctAssignmentTooltip.top}px`,
          left: `${correctAssignmentTooltip.left}px`,
          transform: "translateY(-50%)",
          background: "#013469",
          color: "#fff",
          padding: "10px 16px",
          borderRadius: "8px",
          fontSize: "16px",
          zIndex: 10002,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          borderColor: "#E43522",
          borderWidth: "3px",
          borderStyle: "solid",
          pointerEvents: "none",
          width: `${correctAssignmentTooltip.width || 300}px`,
          textAlign: "center",
          lineHeight: 1.45,
          whiteSpace: "pre-line",
        }}
      >
        {correctAssignmentTooltip.message}
      </div>,
      document.body
    );
  }

  function renderCorrectAssignmentHelpTrigger(message, width = 320) {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          marginLeft: "8px",
          borderRadius: "999px",
          border: "2px solid #E43522",
          background: "#013469",
          color: "#fff",
          fontSize: "12px",
          fontWeight: 800,
          cursor: "help",
          verticalAlign: "middle",
        }}
        onMouseEnter={(event) => showCorrectAssignmentTooltip(event, message, width)}
        onMouseMove={(event) => showCorrectAssignmentTooltip(event, message, width)}
        onMouseLeave={hideCorrectAssignmentTooltip}
      >
        ?
      </span>
    );
  }

  function renderCorrectAssignmentHelpTrigger2(message, width = 320) {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          marginLeft: "8px",
          borderRadius: "999px",
          border: "2px solid #E43522",
          background: "#013469",
          color: "#fff",
          fontSize: "12px",
          fontWeight: 800,
          cursor: "help",
          verticalAlign: "middle",
        }}
        onMouseEnter={(event) => showCorrectAssignmentTooltip(event, message, width)}
        onMouseMove={(event) => showCorrectAssignmentTooltip(event, message, width)}
        onMouseLeave={hideCorrectAssignmentTooltip}
      >
        ?
      </span>
    );
  }

  function renderStudentCodeHelperModal() {
    if (!showStudentCodeHelperModal) {
      return null;
    }

    const studentCodeRoster = buildStudentCodeDisplayRoster(selectedclass?.studentIds || []);
    console.log("studentCodeRoster", studentCodeRoster, "studentCodeRoster");

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.72)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10001,
          padding: "20px",
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeStudentCodeHelperModal();
          }
        }}
      >
        <div
          style={{
            width: "min(2300px, 230vw)",
            maxHeight: "92vh",
            overflowY: "auto",
            background: "#FFF9F1",
            color: "#111",
            borderRadius: "18px",
            border: "5px solid #E43522",
            boxShadow: "0 18px 60px rgba(0,0,0,0.35)",
            padding: "24px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px" }}>
            <div>
              <div style={{ fontSize: "32px", fontWeight: 800, color: "#8F1D14", letterSpacing: "0.02em" }}>
                Student Test Codes
              </div>
              <div style={{ marginTop: "6px", fontSize: "18px", fontWeight: 700, color: "#013469" }}>
                Put this on the board before the test starts.
              </div>
            </div>
            <button
              onClick={closeStudentCodeHelperModal}
              style={{
                padding: "4px 12px",
                background: "transparent",
                color: "#8F1D14",
                border: "none",
                cursor: "pointer",
                fontSize: "28px",
                lineHeight: 1,
              }}
            >
              X
            </button>
          </div>

          <div
            style={{
              marginTop: "18px",
              padding: "18px 20px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, #FFF1D9, #FFE5E0)",
              border: "2px solid #F29A2E",
              textAlign: "center",
            }}
          >

            <div style={{ fontSize: "20px", fontWeight: 900, color: "#8F1D14", textTransform: "uppercase" }}>
              Write this code (the number) that is above your name on the top of the answer sheet next to the field which says "Student Identifier:".
            </div>
            <div style={{ marginTop: "12px", fontSize: "20px", color: "#333" }}>
              When writing down your answers for each question, make sure to write clearly and use a writing utensil that writes boldlly and distinctly (as opposed to faintly and imperceptibly) so that the answer that you have come up with can be easily read and understood. If the answer sheet cannot be read, it may not be graded correctly.
            </div>
            <div style={{ marginTop: "12px", fontSize: "20px", color: "#333" }}>
              In the field that says <strong>Write "0123456789":</strong> (just under your Student Identifier), write the digits 0 through 9 in your own handwriting. This shows the grader exactly how you form each number so your answers are read correctly. Skipping it is at your own risk &mdash; your numbers may be misread.
            </div>
          </div>

          {studentCodeRoster.length > 0 ? (
            <div
              style={{
                marginTop: "22px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
                gap: "14px",
              }}
            >
              {studentCodeRoster.map((student) => (
                <div
                  key={`${student.displayCode}-${student.fullName}-${student.email}`}
                  style={{
                    borderRadius: "16px",
                    border: "2px solid #013469",
                    background: "#FFFFFF",
                    padding: "16px 14px",
                    minHeight: "120px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 6px 16px rgba(1,52,105,0.08)",
                  }}
                >
                  <div style={{ fontSize: "40px", fontWeight: 900, color: "#013469", lineHeight: 1 }}>
                    {student.displayCode}
                  </div>
                  <div style={{ marginTop: "12px", fontSize: "20px", fontWeight: 700, color: "#111", lineHeight: 1.2 }}>
                    {student.fullName}
                  </div>
                  {student.email ? (
                    <div style={{ marginTop: "6px", fontSize: "13px", color: "#5F6368", wordBreak: "break-word" }}>
                      {student.email}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                marginTop: "22px",
                borderRadius: "16px",
                border: "2px dashed #013469",
                padding: "24px",
                textAlign: "center",
                fontSize: "18px",
                color: "#013469",
                background: "rgba(1,52,105,0.05)",
              }}
            >
              No student roster is loaded for this class yet.
            </div>
          )}
        </div>
      </div>
    );
  }

  function renderPendingHandwritingReviewsPanel() {
    if (!Array.isArray(pendingHandwritingReviews) || pendingHandwritingReviews.length === 0) {
      return null;
    }

    return (
      <div
        style={{
          width: "min(460px, 100%)",
          border: "2px solid #FFB100",
          borderRadius: "10px",
          background: "rgba(255,177,0,0.10)",
          padding: "14px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          textAlign: "left",
        }}
      >
        <div style={{ fontSize: "16px", fontWeight: 800, color: "#FFB100", textAlign: "center" }}>
          {pendingHandwritingReviews.length === 1
            ? "1 handwriting answer needs your review"
            : `${pendingHandwritingReviews.length} handwriting answers need your review`}
        </div>
        <div style={{ fontSize: "12px", color: "#ffd8a8", textAlign: "center" }}>
          A digit could be read two ways (for example 4 vs 9) and it would change the score. Confirm the correct reading to post these grades. New submissions for this class are paused until these are resolved.
        </div>

        {handwritingReviewError && (
          <div style={{ fontSize: "12px", color: "#ff6b6b", textAlign: "center" }}>{handwritingReviewError}</div>
        )}

        {pendingHandwritingReviews.map((review) => {
          const flags = Array.isArray(review.flags) ? review.flags : [];
          const choices = handwritingReviewChoices[review.reviewId] || {};
          const everyFlagChosen = flags.every((flag) => choices[flag.questionNumber] != null && choices[flag.questionNumber] !== "");
          const isResolving = resolvingHandwritingReviewId === review.reviewId;

          return (
            <div
              key={review.reviewId}
              style={{
                border: "1px solid rgba(255,255,255,0.18)",
                borderRadius: "8px",
                background: "rgba(255,255,255,0.06)",
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div style={{ fontSize: "13px", fontWeight: 700, color: "#fff" }}>
                {review.studentLabel || "Student"}
                {review.assignmentTitle ? ` · ${review.assignmentTitle}` : ""}
                {review.pageNumber ? ` · page ${review.pageNumber}` : ""}
              </div>

              {flags.map((flag) => {
                const candidates = Array.isArray(flag.candidates) && flag.candidates.length > 0
                  ? flag.candidates
                  : [flag.currentReading, flag.alternateReading].filter(Boolean);
                const selectedReading = choices[flag.questionNumber];

                return (
                  <div
                    key={`${review.reviewId}-q${flag.questionNumber}`}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      paddingBottom: "8px",
                      borderBottom: "1px dashed rgba(255,255,255,0.12)",
                    }}
                  >
                    <div style={{ fontSize: "12px", color: "#ffd8a8", fontWeight: 700 }}>
                      Question {flag.questionNumber}
                    </div>
                    {flag.cropDataUrl && (
                      <img
                        src={flag.cropDataUrl}
                        alt={`Handwritten answer for question ${flag.questionNumber}`}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "140px",
                          objectFit: "contain",
                          background: "#fff",
                          borderRadius: "6px",
                          alignSelf: "center",
                        }}
                      />
                    )}
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
                      {candidates.map((candidate) => {
                        const isSelected = String(selectedReading) === String(candidate);
                        return (
                          <button
                            type="button"
                            key={`${review.reviewId}-q${flag.questionNumber}-${candidate}`}
                            onClick={() => setHandwritingReviewChoice(review.reviewId, flag.questionNumber, candidate)}
                            disabled={isResolving}
                            style={{
                              padding: "8px 16px",
                              borderRadius: "7px",
                              border: isSelected ? "2px solid #00FF00" : "1px solid rgba(255,255,255,0.3)",
                              background: isSelected ? "#00FF00" : "transparent",
                              color: isSelected ? "#000" : "#fff",
                              fontWeight: 800,
                              fontSize: "14px",
                              cursor: isResolving ? "not-allowed" : "pointer",
                            }}
                          >
                            Read as {candidate}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}

              <button
                type="button"
                onClick={() => resolveHandwritingReviewFromBackend(review)}
                disabled={isResolving || !everyFlagChosen}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "none",
                  background: !everyFlagChosen || isResolving ? "rgba(255,255,255,0.2)" : "#00FF00",
                  color: !everyFlagChosen || isResolving ? "#bbb" : "#000",
                  fontWeight: 800,
                  fontSize: "14px",
                  cursor: isResolving || !everyFlagChosen ? "not-allowed" : "pointer",
                }}
              >
                {isResolving ? "Resolving…" : "Confirm and post grade"}
              </button>
            </div>
          );
        })}
      </div>
    );
  }

  function renderCorrectAssignmentModal() {
    if (!showCorrectAssignmentModal) {
      return null;
    }

    // effectiveGradeScaleSettings: use the local draft while the panel is open
    // so the preview updates on every keystroke without a Firebase round-trip.
    const effectiveGradeScaleSettings = localGradeScaleSettings ?? correctingGradeScaleSettings;
    const gradeScalePreview = computeScaledGradesPreview(activegradesfromscaling, effectiveGradeScaleSettings);
    const hasStudentWorkFiles = studentWorkPdf.length > 0;
    const hasTeacherAnswerKeys = answerSheetPdf.length > 0 || (Array.isArray(activeAnswerKeyInfo?.versions) && activeAnswerKeyInfo.versions.length > 0);
    const hasSolvableTestFiles = testsToSolvePdf.length > 0;
    const isSolveTestMode = correctingAnswerSourceMode === "solve-test";
    const hasSelectedAnswerSource = isSolveTestMode ? hasSolvableTestFiles : hasTeacherAnswerKeys;
    const hasAssignmentTitle = typeof newassignmentname === "string" && newassignmentname.trim().length > 0;
    const readyToSubmit = hasAssignmentTitle && hasSelectedAnswerSource;
    const activeAnswerKeyParsingStatus = String(activeAnswerKeyInfo?.parsingStatus || "").trim().toLowerCase();
    const isAnswerKeyParsing = activeAnswerKeyParsingStatus === "processing";
    const isAnswerKeyParseFailed = activeAnswerKeyParsingStatus === "failed";
    const activeAnswerKeyParseError = typeof activeAnswerKeyInfo?.lastParseError === "string"
      ? activeAnswerKeyInfo.lastParseError.trim()
      : "";
    const storedRescoreAssignmentId = correctingLastGradingRun?.assignmentId || null;
    const storedRescoreStudentCount = Array.isArray(correctingLastGradingRun?.students)
      ? correctingLastGradingRun.students.length
      : 0;
    const trimmedModalAssignmentTitle = typeof newassignmentname === "string" ? newassignmentname.trim() : "";
    // The title that identifies the assignment whose Google Classroom scores can
    // be re-scaled: prefer the last graded run, fall back to the active answer key.
    const rescoreAssignmentTitle = (typeof correctingLastGradingRun?.assignmentTitle === "string" && correctingLastGradingRun.assignmentTitle.trim())
      ? correctingLastGradingRun.assignmentTitle.trim()
      : (typeof activeAnswerKeyInfo?.assignmentTitle === "string" ? activeAnswerKeyInfo.assignmentTitle.trim() : "");
    const rescoreTitleMatchesActiveAssignment = Boolean(rescoreAssignmentTitle)
      && (trimmedModalAssignmentTitle.length === 0
        || trimmedModalAssignmentTitle.toLowerCase() === rescoreAssignmentTitle.toLowerCase());
    // A graded Google Classroom assignment may exist either because we have a
    // stored grading run (assignments graded after this feature shipped) or
    // because there is a stored active answer key for this title (older
    // assignments — the backend reconstructs the baseline from current grades).
    const hasStoredTeacherAnswerKeyVersions = Array.isArray(activeAnswerKeyInfo?.versions)
      && activeAnswerKeyInfo.versions.length > 0;
    const hasRescoreableAssignment = (Boolean(storedRescoreAssignmentId) && storedRescoreStudentCount > 0)
      || hasStoredTeacherAnswerKeyVersions;
    const canModifyScoringMethodOnly = !hasStudentWorkFiles
      && !hasSolvableTestFiles
      && answerSheetPdf.length === 0
      && hasRescoreableAssignment
      && rescoreTitleMatchesActiveAssignment;
    // Answer-key setup and student-work grading are two separate steps. A new
    // teacher must establish the assignment and its answer key(s) first; only
    // then does submitting student work become available. Thereafter the
    // teacher can EITHER add another answer key OR submit another set of
    // student tests — but never both in the same submission.
    const storedAnswerKeyVersionCount = Array.isArray(activeAnswerKeyInfo?.versions)
      ? activeAnswerKeyInfo.versions.length
      : 0;
    const isSupplyingNewAnswerSource = answerSheetPdf.length > 0 || hasSolvableTestFiles;
    const activeAssignmentTitleTrimmed = typeof activeAnswerKeyInfo?.assignmentTitle === "string"
      ? activeAnswerKeyInfo.assignmentTitle.trim()
      : "";
    const titleMatchesActiveAssignment = activeAssignmentTitleTrimmed.length > 0
      && trimmedModalAssignmentTitle.length > 0
      && trimmedModalAssignmentTitle.toLowerCase() === activeAssignmentTitleTrimmed.toLowerCase();
    // When the teacher has typed a NEW assignment title that does not match the
    // stored active assignment, the stored answer key belongs to a different
    // assignment and must not bleed into this fresh context. Treat the modal as
    // a brand-new assignment: no established key, student-work step hidden, and
    // the stored-version message suppressed until a key is stored for this title.
    const typedTitleIsDifferentAssignment = activeAssignmentTitleTrimmed.length > 0
      && trimmedModalAssignmentTitle.length > 0
      && !titleMatchesActiveAssignment;
    const hasEstablishedAnswerKey = storedAnswerKeyVersionCount > 0;
    // The student-work input only exists once an answer key has been
    // established for the class. Until then, the teacher is setting up the
    // assignment, so we hide the student-work step entirely.
    const showStudentWorkInput = hasEstablishedAnswerKey;
    // While the teacher is supplying a new answer source, the student-work
    // input is deactivated; while student work is selected, the answer-source
    // inputs are deactivated. This enforces the one-at-a-time workflow.
    // Additionally, while the typed title differs from the stored assignment
    // (an uncommitted new-assignment title) OR while the title-change reset is
    // still being written to Firestore, BOTH inputs are deactivated until the
    // reset commits and the stored answer key is cleared.
    const studentWorkInputDisabled = activeAnswerKeyInfo?.versions?.length == 0;
    const answerSourceInputDisabled = hasStudentWorkFiles || correctingGenerating || typedTitleIsDifferentAssignment || correctingTitleResetPending;
    const answerSourceActionLabel = titleMatchesActiveAssignment ? "Add answer key" : "Create new assignment";
    const primaryActionLabel = canModifyScoringMethodOnly
      ? "Modify Scoring Method"
      : (hasStudentWorkFiles
        ? "Correct and Send to Google Classroom"
        : (isSupplyingNewAnswerSource
          ? answerSourceActionLabel
          : "Create Assignment and Store Answer Sheets"));
    const displayedPrimaryActionLabel = correctingGenerating
      ? (canModifyScoringMethodOnly
        ? "Updating Scores…"
        : (hasStudentWorkFiles
          ? "Correcting…"
          : (isSupplyingNewAnswerSource
            ? (titleMatchesActiveAssignment ? "Adding…" : "Creating…")
            : "Saving…")))
      : (correctingPrimaryActionFeedback || primaryActionLabel);
    const studentCodeRoster = buildStudentCodeDisplayRoster(selectedclass?.studentIds || []);
    const reportSummary = correctingReport?.summary || {};
    const gradingReport = correctingReport?.grading || {};
    const classroomReport = correctingReport?.classroom || {};
    const correctedFilesReport = correctingReport?.correctedFiles || {};
    const processingReport = correctingReport?.processing || {};
    const reviewNeededStudents = Array.isArray(gradingReport.reviewNeededStudents)
      ? gradingReport.reviewNeededStudents
      : [];
    const reviewNeededStudentsPreview = reviewNeededStudents.map((entry, index) => {
      if (typeof entry === "string") {
        const trimmedEntry = entry.trim();
        return {
          key: `review-needed-${index}-${trimmedEntry || 'unknown'}`,
          label: trimmedEntry || `student-${index + 1}`,
          detail: null,
        };
      }

      const studentLabel = typeof entry?.studentLabel === "string" && entry.studentLabel.trim().length > 0
        ? entry.studentLabel.trim()
        : `student-${index + 1}`;
      const extractedStudentCodes = Array.isArray(entry?.extractedStudentCodes)
        ? entry.extractedStudentCodes.map((value) => String(value || "").trim()).filter(Boolean)
        : [];

      return {
        key: `review-needed-${index}-${studentLabel}`,
        label: studentLabel,
        detail: extractedStudentCodes.length > 0
          ? `Read Student Identifier: ${extractedStudentCodes.join(", ")}`
          : null,
      };
    });
    const unmatchedStudentNames = Array.isArray(classroomReport.unmatchedStudentNames)
      ? classroomReport.unmatchedStudentNames
      : [];
    const normalizeUnmatchedStudentEntry = (entry, index) => {
      if (typeof entry === "string") {
        return {
          studentLabel: entry,
          extractedStudentCodes: [],
        };
      }

      const studentLabel = typeof entry?.studentLabel === "string" && entry.studentLabel.trim().length > 0
        ? entry.studentLabel.trim()
        : `student-${index + 1}`;
      const extractedStudentCodes = Array.isArray(entry?.extractedStudentCodes)
        ? entry.extractedStudentCodes.map((value) => String(value || "").trim()).filter(Boolean)
        : [];

      return {
        studentLabel,
        extractedStudentCodes,
      };
    };
    const unmatchedStudentsPreview = Array.isArray(classroomReport.unmatchedStudentsPreview)
      ? classroomReport.unmatchedStudentsPreview.map((entry, index) => normalizeUnmatchedStudentEntry(entry, index))
      : unmatchedStudentNames.map((entry, index) => normalizeUnmatchedStudentEntry(entry, index));
    const processingWarnings = Array.isArray(processingReport.warnings)
      ? processingReport.warnings
      : [];
    const reportAnswerVersionDetails = Array.isArray(processingReport.answerKeyVersionDetails)
      ? processingReport.answerKeyVersionDetails
      : [];
    const storedAnswerVersionDetails = Array.isArray(activeAnswerKeyInfo?.versions)
      ? activeAnswerKeyInfo.versions
      : [];
    const availableAnswerVersionDetails = reportAnswerVersionDetails.length > 0
      ? reportAnswerVersionDetails
      : storedAnswerVersionDetails;
    const selectedAnswerVersion = activeAnswerKeyInfoVersionsArray?.[selectedAnswerVersionPreviewId] ||
      activeAnswerKeyInfoVersionsArray?.["1"] ||
      {};
    const scoreWritebackPreview = Array.isArray(classroomReport.studentScoreWritebackPreview)
      ? classroomReport.studentScoreWritebackPreview
      : [];
    const activeCorrectingGradeScaleOption = CORRECTING_GRADE_SCALE_OPTIONS.find(
      (option) => option.value === correctingGradeScaleSettings.mode,
    ) || CORRECTING_GRADE_SCALE_OPTIONS[0];
    const activeCorrectingGradeScaleValueLabel = correctingGradeScaleSettings.mode === "fixed-total-points"
      ? `Chosen Total Points: ${correctingGradeScaleSettings.fixedTotalPoints}`
      : ([
        "curve-top-score",
        "curve-bottom-score",
      ].includes(correctingGradeScaleSettings.mode)
        ? `Chosen Percent: ${correctingGradeScaleSettings.curvedTopScorePercent}%`
        : "");
    const correctedTestsMissingUpload = Array.isArray(correctedFilesReport.correctedTestsMissingUpload)
      ? correctedFilesReport.correctedTestsMissingUpload
      : [];
    const uploadedCorrectedFilesPreview = Array.isArray(correctedFilesReport.uploadedCorrectedFilesPreview)
      ? correctedFilesReport.uploadedCorrectedFilesPreview
      : [];
    const orientationIssueFiles = Array.isArray(correctingOrientationIssue?.files)
      ? correctingOrientationIssue.files
      : [];
    const isSaveOnlyReport = Boolean(correctingReport)
      && !reportSummary.hasStudentWorkPdf
      && reportSummary.implementationStatus !== "analysis-failed";
    const activeAnswerKeyVersionCount = Number(activeAnswerKeyInfo?.versionCount) || 0;
    const savedAnswerKeyVersionCount = Array.isArray(activeAnswerKeyInfo?.versions)
      ? activeAnswerKeyInfo.versions.length
      : 0;
    const compactSaveMessage = classroomReport.assignmentCreationMessage
      || "Saved the active assignment to this class. Google Classroom coursework will be created or reused when student work is submitted.";

    // True when any of the four toggle panels (Scoring Method, Special Grading
    // Instructions, Grading Norms, Active Answer Sheets) is open. While a panel
    // is open we hide the three primary inputs and show the opened panel in their
    // place, so the teacher never has to scroll to see the active panel.
    const anyCorrectingPanelOpen = showCorrectingGradeScale
      || showCorrectingSpecialInstructions
      || showCorrectingGradingNorms
      || showCorrectingActiveAnswerSheets;

    // Opening one panel closes the other three so only a single panel shows at a
    // time. Clicking the button for an already-open panel closes it.
    const openCorrectingPanelExclusively = (panel) => {
      setShowCorrectingGradeScale(panel === "gradeScale" ? (currentValue) => !currentValue : false);
      setShowCorrectingSpecialInstructions(panel === "specialInstructions" ? (currentValue) => !currentValue : false);
      setShowCorrectingGradingNorms(panel === "gradingNorms" ? (currentValue) => !currentValue : false);
      setShowCorrectingActiveAnswerSheets(panel === "activeAnswerSheets" ? (currentValue) => !currentValue : false);
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.55)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          padding: "20px",
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeCorrectAssignmentModal();
          }
        }}
      >
        <div
          style={{
            width: "min(560px, 92vw)",
            maxHeight: "90vh",
            overflowY: "auto",
            background: "#000",
            color: "#fff",
            borderRadius: "10px",
            border: "4px solid #E43522",
            boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", width: "100%" }}>
            <div style={{ flex: 1, textAlign: "center", paddingLeft: "36px" }}>
              <div
                style={{
                  fontSize: "28px",
                  fontWeight: "bold",
                  color: "#fff",
                  cursor: studentCodeRoster.length > 0 ? "pointer" : "default",
                }}
                onClick={() => {
                  if (studentCodeRoster.length > 0) {
                    setShowStudentCodeHelperModal(true);
                  }
                }}
                onMouseEnter={(event) => showCorrectAssignmentTooltip(event)}
                onMouseMove={(event) => showCorrectAssignmentTooltip(event)}
                onMouseLeave={hideCorrectAssignmentTooltip}
              >
                Create/Correct Assignment
              </div>
            </div>
            <button
              onClick={closeCorrectAssignmentModal}
              style={{
                padding: "4px 12px",
                background: "transparent",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "24px",
              }}
            >
              X
            </button>
          </div>

          {renderPendingHandwritingReviewsPanel()}

          {/* <div
            style={{
              width: "min(420px, 100%)",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "8px",
              padding: "6px",
              border: "1px solid rgba(255,216,204,0.45)",
              borderRadius: "10px",
              background: "rgba(255,255,255,0.06)",
            }}
          >
            <button
              type="button"
              onClick={() => handleCorrectingAnswerSourceModeChange("answer-key")}
              disabled={correctingGenerating}
              style={{
                padding: "10px 12px",
                background: !isSolveTestMode ? "#00FF00" : "transparent",
                color: !isSolveTestMode ? "#000" : "gray",
                border: "1px solid rgba(255,255,255,0.22)",
                borderRadius: "7px",
                cursor: correctingGenerating ? "not-allowed" : "pointer",
                fontSize: "13px",
                fontWeight: 800,
              }}
            >
              Supplying Answers
            </button>
            <button
              type="button"
              onClick={() => handleCorrectingAnswerSourceModeChange("solve-test")}
              disabled={correctingGenerating}
              style={{
                padding: "10px 12px",
                background: isSolveTestMode ? "#00FF00" : "transparent",
                color: isSolveTestMode ? "#000" : "gray",
                border: "1px solid rgba(255,255,255,0.22)",
                borderRadius: "7px",
                cursor: correctingGenerating ? "not-allowed" : "pointer",
                fontSize: "13px",
                fontWeight: 800,
              }}
            >
              Have AI Solve Test
            </button>
          </div> */}

          <div
            ref={correctingInputsMeasureRef}
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "18px",
              alignItems: "center",
              ...(anyCorrectingPanelOpen && correctingInputsHeight
                ? { height: `${correctingInputsHeight}px`, overflowY: "auto" }
                : {}),
            }}
          >

            <div style={{ display: "flex", flexDirection: "column", gap: "8px", color: "#fff", fontWeight: 600, alignItems: "center", width: "100%", margin: anyCorrectingPanelOpen ? "auto" : undefined }}>
              {!anyCorrectingPanelOpen && (
                <>
                  <span>
                    Title of Active Assignment
                    {renderCorrectAssignmentHelpTrigger("This title is stored with the active teacher answer keys for the class. If you keep the same title later, the same Google Classroom assignment will be reused and grades can be overwritten.", 340)}
                  </span>
                  <input
                    type="text"
                    value={newassignmentname || ""}
                    onChange={(e) => {
                      const nextTitle = e.target.value;
                      hasUserEditedCorrectingAssignmentTitleRef.current = true;
                      setNewassignmentname(nextTitle);
                      setCorrectingModalError(null);
                      setCorrectingReport(null);
                      setCorrectingPrimaryActionFeedback("");
                    }}
                    onBlur={() => {
                      commitCorrectingAssignmentTitleChange().catch(() => { });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.currentTarget.blur();
                      }
                    }}
                    placeholder="Enter assignment title"
                    style={{
                      fontWeight: 400,
                      color: "#fff",
                      background: "#013469",
                      border: "3px solid #E43522",
                      borderRadius: "6px",
                      padding: "10px",
                      width: "min(360px, 100%)",
                      textAlign: "center",
                    }}
                  />
                  {typedTitleIsDifferentAssignment ? (
                    <span style={{ fontSize: "12px", color: "#FFD8CC", fontWeight: 700, textAlign: "center", width: "min(360px, 100%)" }}>
                      New assignment title. Press Enter or click away to start it — this clears the stored answer key, then add a new answer key below.
                    </span>
                  ) : (correctingTitleResetPending ? (
                    <span style={{ fontSize: "12px", color: "#FFD8CC", fontWeight: 700, textAlign: "center", width: "min(360px, 100%)" }}>
                      Starting the new assignment…
                    </span>
                  ) : null)}
                </>
              )}
              {showCorrectingGradeScale ? (
                <div
                  style={{
                    width: "min(440px, 100%)",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,216,204,0.3)",
                    borderRadius: "10px",
                    padding: "14px 16px",
                    textAlign: "left",
                    color: "#FFF4EF",
                    fontSize: "13px",
                    fontWeight: 400,
                    lineHeight: 1.55,
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: 800, color: "#FFD8CC", marginBottom: "8px", textAlign: "center" }}>
                    Assignment Scoring Method
                  </div>
                  <label style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "10px" }}>
                    <span style={{ fontWeight: 700, color: "#FFFFFF" }}>Scoring Method</span>
                    <select
                      value={effectiveGradeScaleSettings.mode}
                      disabled={correctingGenerating || correctingSavingScaledScores}
                      onChange={(e) => {
                        const nextMode = e.target.value;
                        const nextSettings = normalizeCorrectingGradeScaleSettings({
                          ...(localGradeScaleSettings ?? correctingGradeScaleSettings),
                          mode: nextMode,
                        });
                        setLocalGradeScaleSettings(nextSettings);
                      }}
                      style={{
                        fontWeight: 400,
                        color: "#fff",
                        background: "#013469",
                        border: "2px solid #E43522",
                        borderRadius: "6px",
                        padding: "10px",
                        width: "100%",
                      }}
                    >
                      {CORRECTING_GRADE_SCALE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  </label>
                  <div style={{ marginBottom: "10px", fontSize: "12px", color: "#FFD8CC" }}>
                    {(CORRECTING_GRADE_SCALE_OPTIONS.find((option) => option.value === effectiveGradeScaleSettings.mode) || CORRECTING_GRADE_SCALE_OPTIONS[0]).description}
                  </div>

                  {effectiveGradeScaleSettings.mode === "fixed-total-points" ? (
                    <label style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "10px" }}>
                      <span style={{ fontWeight: 700, color: "#FFFFFF" }}>Assignment Total Points</span>
                      <input
                        type="number"
                        value={effectiveGradeScaleSettings.fixedTotalPoints ?? ""}
                        onChange={(e) => {
                          const rawValue = e.target.value;
                          const nextValue = rawValue === "" ? "" : Number(rawValue);
                          if (rawValue === "" || (Number.isFinite(nextValue) && nextValue >= 0)) {
                            setLocalGradeScaleSettings((prev) =>
                              normalizeCorrectingGradeScaleSettings({
                                ...(prev ?? correctingGradeScaleSettings),
                                fixedTotalPoints: nextValue,
                              })
                            );
                          }
                        }}
                        style={{
                          fontWeight: 400,
                          color: "#fff",
                          background: "#013469",
                          border: "2px solid #E43522",
                          borderRadius: "6px",
                          padding: "10px",
                          width: "100%",
                        }}
                      />
                    </label>
                  ) : null}

                  {effectiveGradeScaleSettings.mode === "curve-top-score" ? (
                    <label style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "10px" }}>
                      <span style={{ fontWeight: 700, color: "#FFFFFF" }}>Target Highest Score (%)</span>
                      <input
                        type="number"
                        value={effectiveGradeScaleSettings.curvedTopScorePercent ?? ""}
                        onChange={(e) => {
                          const rawValue = e.target.value;
                          const nextValue = rawValue === "" ? "" : Number(rawValue);
                          if (rawValue === "" || (Number.isFinite(nextValue) && nextValue >= 0)) {
                            setLocalGradeScaleSettings((prev) =>
                              normalizeCorrectingGradeScaleSettings({
                                ...(prev ?? correctingGradeScaleSettings),
                                curvedTopScorePercent: nextValue,
                              })
                            );
                          }
                        }}
                        style={{
                          fontWeight: 400,
                          color: "#fff",
                          background: "#013469",
                          border: "2px solid #E43522",
                          borderRadius: "6px",
                          padding: "10px",
                          width: "100%",
                        }}
                      />
                    </label>
                  ) : null}

                  {effectiveGradeScaleSettings.mode === "curve-bottom-score" ? (
                    <label style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "10px" }}>
                      <span style={{ fontWeight: 700, color: "#FFFFFF" }}>Target Lowest Score (%)</span>
                      <input
                        type="number"
                        value={effectiveGradeScaleSettings.curvedBottomScorePercent ?? ""}
                        onChange={(e) => {
                          const rawValue = e.target.value;
                          const nextValue = rawValue === "" ? "" : Number(rawValue);
                          if (rawValue === "" || (Number.isFinite(nextValue) && nextValue >= 0)) {
                            setLocalGradeScaleSettings((prev) =>
                              normalizeCorrectingGradeScaleSettings({
                                ...(prev ?? correctingGradeScaleSettings),
                                curvedBottomScorePercent: nextValue,
                              })
                            );
                          }
                        }}
                        style={{
                          fontWeight: 400,
                          color: "#fff",
                          background: "#013469",
                          border: "2px solid #E43522",
                          borderRadius: "6px",
                          padding: "10px",
                          width: "100%",
                        }}
                      />
                    </label>
                  ) : null}

                  {gradeScalePreview && gradeScalePreview.length > 0 ? (
                    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                      <div style={{ fontSize: "12px", fontWeight: 700, color: "#FFD8CC", marginBottom: "6px", textAlign: "center" }}>
                        Grade Preview — {gradeScalePreview.length} student{gradeScalePreview.length === 1 ? "" : "s"}
                      </div>
                      <div style={{ maxHeight: "160px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "3px" }}>
                        {gradeScalePreview
                          .slice()
                          .sort((a, b) => b.rawPct - a.rawPct)
                          .map((entry, i) => (
                            <div
                              key={`preview-${i}-${entry.label}`}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "12px",
                                padding: "3px 8px",
                                borderRadius: "4px",
                                background: "rgba(255,255,255,0.05)",
                              }}
                            >
                              <span style={{ color: "#FFF4EF", flexShrink: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingRight: "8px" }}>
                                {entry.label}
                              </span>
                              <span style={{ flexShrink: 0, fontWeight: 700, color: "#00FF00" }}>
                                {entry.scaledDisplay}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : activegradesfromscaling ? (
                    <div style={{ marginTop: "10px", marginBottom: "10px", fontSize: "12px", color: "#FFD8CC", textAlign: "center" }}>
                      No student scores available for preview.
                    </div>
                  ) : null}

                  <div style={{ fontSize: "12px", color: "#FFD8CC" }}>
                    Current setting: {describeCorrectingGradeScaleSettings(effectiveGradeScaleSettings)}.
                  </div>
                  {correctingGradeScaleStatus?.message ? (
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "12px",
                        color: correctingGradeScaleStatus.type === "error" ? "#FFB5A7" : "#FFF4EF",
                      }}
                    >
                      {correctingGradeScaleStatus.message}
                    </div>
                  ) : null}
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "14px" }}>
                    {gradeScalePreview && gradeScalePreview.length > 0 ? <button
                      type="button"
                      onClick={() => {
                        saveScaledScoresToGoogleClassroom().catch(() => { });
                      }}
                      disabled={correctingGenerating || correctingSavingScaledScores || !gradeScalePreview || gradeScalePreview.length === 0}
                      style={{
                        padding: "8px 16px",
                        background: "#013469",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: (correctingGenerating || correctingSavingScaledScores || !gradeScalePreview || gradeScalePreview.length === 0) ? "not-allowed" : "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                        opacity: (correctingGenerating || correctingSavingScaledScores || !gradeScalePreview || gradeScalePreview.length === 0) ? 0.65 : 1,
                      }}
                    >
                      {correctingSavingScaledScores ? "Saving..." : "Save Scores"}
                    </button> : activegradesfromscaling ?  <button
                      type="button"
                      onClick={() => {
                        persistCorrectingGradeScaleSettings(localGradeScaleSettings ?? correctingGradeScaleSettings).catch(() => { console.error("Failed to persist correcting grade scale settings");});
                      }}
                      style={{
                        padding: "8px 16px",
                        background: "rgba(255,255,255,0.08)",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                     Save Scoring Settings
                    </button> : null}
                    <button
                      type="button"
                      onClick={() => {
                        setShowCorrectingGradeScale(false);
                      }}
                      style={{
                        padding: "8px 16px",
                        background: "rgba(255,255,255,0.08)",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              ) : null}
              {showCorrectingSpecialInstructions ? (
                <div
                  style={{
                    width: "min(440px, 100%)",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,216,204,0.3)",
                    borderRadius: "10px",
                    padding: "14px 16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <span>
                    Special Grading Instructions (Optional)
                    {renderCorrectAssignmentHelpTrigger("These instructions are saved on this class so they auto-fill next time and can be applied during AI review when answers need interpretation.", 320)}
                  </span>
                  <textarea
                    value={correctingSpecialInstructions || ""}
                    onChange={(e) => {
                      setCorrectingSpecialInstructions(e.target.value);
                      setCorrectingModalError(null);
                      setCorrectingReport(null);
                      setCorrectingPrimaryActionFeedback("");
                    }}
                    placeholder="Optional special grading instructions, for example: accept answers rounded to the nearest whole number."
                    rows={4}
                    style={{
                      fontWeight: 400,
                      color: "#fff",
                      background: "#013469",
                      border: "3px solid #E43522",
                      borderRadius: "6px",
                      padding: "10px",
                      width: "min(420px, 100%)",
                      resize: "vertical",
                    }}
                  />
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "14px" }}>
                    <button
                      type="button"
                      onClick={() => setShowCorrectingSpecialInstructions(false)}
                      style={{
                        padding: "8px 16px",
                        background: "rgba(255,255,255,0.08)",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : null}
              {showCorrectingGradingNorms ? (
                <div
                  style={{
                    width: "min(440px, 100%)",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,216,204,0.3)",
                    borderRadius: "10px",
                    padding: "14px 16px",
                    textAlign: "left",
                    color: "#FFF4EF",
                    fontSize: "13px",
                    fontWeight: 400,
                    lineHeight: 1.55,
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: 800, color: "#FFD8CC", marginBottom: "8px", textAlign: "center" }}>
                    Grading Norms
                    {renderCorrectAssignmentHelpTrigger("Make adjustments as needed. Changes save immediately to this class.", 360)}
                  </div>
                  {CORRECTING_GRADING_NORMS.map((norm) => {
                    const currentValue = correctingScoringSettings?.[norm.key];
                    const isSelect = norm.type === "select";

                    return (
                      <div
                        key={norm.key}
                        style={{
                          display: "flex",
                          // Stack text above the element for select dropdowns, but keep row alignment for checkboxes
                          flexDirection: isSelect ? "column" : "row",
                          alignItems: isSelect ? "flex-start" : "flex-start",
                          gap: isSelect ? "8px" : "15px",
                          padding: "12px 0",
                          borderTop: "1px solid rgba(255, 255, 255, 0.08)",
                          opacity: correctingGenerating ? 0.7 : 1,
                          alignItems: "center"
                        }}
                      >
                        {/* 1. Text Content Column/Row (Rendered first for dropdowns, second for checkboxes) */}
                        {isSelect && (
                          <div style={{ width: "100%", paddingLeft: "30px", paddingRight: "15px" }}>

                            <div style={{ fontSize: "13px", color: "#FFFFFF", marginTop: "2px", fontWeight: 800 }}>
                              {norm.description}
                            </div>
                          </div>
                        )}

                        {/* 2. Interactive UI Control Area */}
                        <div
                          style={{
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            // Dropdowns align left naturally under the text; checkboxes center in their column bounds
                            minWidth: isSelect ? "auto" : "40px",
                            justifyContent: isSelect ? "flex-start" : "center"
                          }}
                        >
                          {norm.type === "checkbox" ? (
                            <input
                              type="checkbox"
                              checked={Boolean(currentValue)}
                              disabled={correctingGenerating}
                              onChange={() => {
                                handleCorrectingNormChange(norm.key);
                                setCorrectingPrimaryActionFeedback("");
                                setCorrectingReport(null);
                              }}
                              style={{
                                transform: "scale(1.5)",
                                transformOrigin: "center",
                                cursor: correctingGenerating ? "not-allowed" : "pointer"
                              }}
                            />
                          ) : (
                            <select
                              value={currentValue || "exact"}
                              disabled={correctingGenerating}
                              onChange={(e) => {
                                handleCorrectingNormChange(norm.key, e.target.value);
                                setCorrectingPrimaryActionFeedback("");
                                setCorrectingReport(null);
                              }}
                              style={{
                                background: "#22222E",
                                color: "#FFFFFF",
                                border: "1px solid rgba(255, 255, 255, 0.2)",
                                borderRadius: "4px",
                                padding: "4px 8px",
                                fontSize: "12px",
                                marginTop: "4px",
                                cursor: correctingGenerating ? "not-allowed" : "pointer"
                              }}
                            >
                              {norm.options.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                              ))}
                            </select>
                          )}
                        </div>

                        {/* 3. Fallback Text Content Placement (Only used when item type is a checkbox) */}
                        {!isSelect && (
                          <div style={{ flexGrow: 1, minWidth: 0 }}>
                            <div style={{ fontSize: "13px", fontWeight: 800, color: "#FFFFFF" }}>
                              {norm.label}
                            </div>
                            <div style={{ fontSize: "12px", color: "#FFD8CC", marginTop: "2px" }}>
                              {norm.description}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}


                  {correctingNormsStatus?.message ? (
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "12px",
                        color: correctingNormsStatus.type === "error" ? "#FFB5A7" : "#FFF4EF",
                      }}
                    >
                      {correctingNormsStatus.message}
                    </div>
                  ) : null}
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "14px" }}>
                    <button
                      type="button"
                      onClick={() => setShowCorrectingGradingNorms(false)}
                      style={{
                        padding: "8px 16px",
                        background: "rgba(255,255,255,0.08)",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : null}



              {activeAnswerKeyVersionCount > 0 && showCorrectingActiveAnswerSheets ? (
                <div style={{ width: "min(440px, 100%)", border: "1px solid rgba(228,53,34,0.6)", borderRadius: "10px", padding: "14px 16px", textAlign: "left", background: "rgba(1,52,105,0.18)" }}>
                  <div style={{ fontSize: "16px", fontWeight: 700, textAlign: "center", marginBottom: "10px" }}>
                    Active Answer Sheets
                  </div>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center", flexWrap: "wrap", marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", fontWeight: 600 }}>Version:</label>
                    <select
                      value={selectedAnswerVersionPreviewId || "1"} // Keeps "1" as the default active key
                      onChange={(e) => setSelectedAnswerVersionPreviewId(e.target.value)}
                      style={{
                        fontWeight: 400,
                        color: "#fff",
                        background: "#013469",
                        border: "2px solid #E43522",
                        borderRadius: "6px",
                        padding: "8px 10px",
                        minWidth: "180px",
                      }}
                    >
                      {activeAnswerKeyInfoVersionsArray && Object.keys(activeAnswerKeyInfoVersionsArray).length > 0 ? (
                        // Object.entries extracts the keys ("1", "2", "3") as 'key' and the data objects as 'versionEntry'
                        Object.entries(activeAnswerKeyInfoVersionsArray).map(([key, versionEntry]) => {
                          const versionValue = String(key); // This will match your state ("1", "2", etc.)
                          const questionCount = Array.isArray(versionEntry?.answers) ? versionEntry.answers.length : 0;

                          return (
                            <option key={versionValue} value={versionValue}>
                              {`Version ${versionEntry?.source_page || key} (${questionCount} question${questionCount === 1 ? "" : "s"})`}
                            </option>
                          );
                        })
                      ) : (
                        <option value="">No versions available</option>
                      )}
                    </select>
                  </div>
                  {activeAnswerKeyInfoVersionsArray && Object.keys(activeAnswerKeyInfoVersionsArray).length > 0 ? (
                    <>
                      <div style={{ fontSize: "13px", lineHeight: 1.55, color: "#FFF4EF", marginBottom: "12px", textAlign: "center" }}>
                        {activeAnswerKeyInfo?.assignmentTitle || newassignmentname || "Untitled assignment"}
                      </div>

                      <div style={{ maxHeight: "220px", overflowY: "auto", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "8px", padding: "10px 12px", background: "rgba(0,0,0,0.14)" }}>
                        {/* 
        NOTE: Your dropdown map checked for 'versionEntry.answers', 
        but your display maps over 'selectedAnswerVersion.questions'.
        This safely checks both fallback arrays to prevent crashes.
      */}
                        {(() => {
                          const questionsList = Array.isArray(selectedAnswerVersion?.questions)
                            ? selectedAnswerVersion.questions
                            : Array.isArray(selectedAnswerVersion?.answers)
                              ? selectedAnswerVersion.answers
                              : [];

                          if (questionsList.length > 0) {
                            return (
                              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "8px 12px" }}>
                                {questionsList.map((question, qIdx) => {
                                  const qNum = question?.problemNumber || question?.number || (qIdx + 1);
                                  const qAns = question?.correctAnswer || question?.text || "No answer text";
                                  return (
                                    <div key={`question-${qNum}`} style={{ fontSize: "13px", lineHeight: 1.45 }}>
                                      <strong>{`${qNum}.`}</strong> {qAns}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          }

                          return (
                            <div style={{ fontSize: "13px", textAlign: "center", color: "#FFD8CC" }}>
                              No question answers are available for this version yet.
                            </div>
                          );
                        })()}
                      </div>
                    </>
                  ) : null}

                  {selectedAnswerVersion ? (<div style={{ display: "flex", justifyContent: "center", marginTop: "14px" }}>
                    <button
                      type="button"
                      onClick={() => setShowCorrectingActiveAnswerSheets(false)}
                      style={{
                        padding: "8px 16px",
                        background: "rgba(255,255,255,0.08)",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                      Cancel
                    </button>
                  </div>) : (<div style={{ display: "flex", justifyContent: "center", marginTop: "14px" }}>
                    <button
                      type="button"
                      onClick={() => setShowCorrectingActiveAnswerSheets(false)}
                      style={{
                        padding: "8px 16px",
                        background: "rgba(255,255,255,0.08)",
                        color: "#FFD8CC",
                        border: "1px solid rgba(255,216,204,0.45)",
                        borderRadius: "999px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                      Cancel
                    </button>
                  </div>)}
                </div>


              ) : null}






            </div>
            {!anyCorrectingPanelOpen && (
              !isSolveTestMode ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", color: "#fff", fontWeight: 600, alignItems: "center", width: "100%" }}>
                  <span>
                    Teacher Answer Key Files
                    {renderCorrectAssignmentHelpTrigger("Upload files here when you want to replace or extend the current active answer key. If you keep the same assignment title later, future grading runs will reuse the same Google Classroom assignment by that name.", 340)}
                  </span>
                  <input
                    key={`answer-key-files-${correctingFileInputResetKey}`}
                    type="file"
                    accept=".pdf,application/pdf,.png,.jpg,.jpeg,.webp,image/*"
                    multiple
                    disabled={answerSourceInputDisabled}
                    onChange={(e) => {
                      handleFileChangeaddanswerkeys(e)
                    }}
                    style={{
                      fontWeight: 400,
                      color: "#fff",
                      background: "#013469",
                      border: "3px solid #E43522",
                      borderRadius: "6px",
                      padding: "10px",
                      width: "min(360px, 100%)",
                      opacity: answerSourceInputDisabled ? 0.45 : 1,
                      cursor: answerSourceInputDisabled ? "not-allowed" : "pointer",
                    }}
                  />

                  {typeof activeAnswerKeyInfo !== "undefined" && activeAnswerKeyInfo?.versionCount > 0 ? (<span style={{ fontSize: "13px", color: "#fff", fontWeight: 400 }}>
                    {answerSheetPdf.length > 0
                      ? answerSheetPdf.map((f) => f.name).join(", ")
                      : (hasEstablishedAnswerKey && activeAnswerKeyInfo?.assignmentTitle
                        ? `No files selected. Current active assignment: ${activeAnswerKeyInfo.assignmentTitle}`
                        : "No files selected")}
                  </span>) : null}

                  {typeof activeAnswerKeyInfo !== "undefined" && activeAnswerKeyInfo?.versionCount > 0 ? (
                    <span style={{ fontSize: "12px", color: "#00FF00", fontWeight: 700 }}>
                      {`${activeAnswerKeyVersionCount} answer key version${activeAnswerKeyVersionCount === 1 ? "" : "s"} stored${activeAnswerKeyInfo?.assignmentTitle ? ` for “${activeAnswerKeyInfo.assignmentTitle}”` : ""}.`}
                    </span>
                  ) : (
                    <span style={{ fontSize: "12px", color: "#FFD8CC", fontWeight: 700 }}>
                      No answer key stored yet — establish the assignment answer key first.
                    </span>
                  )}
                  {answerSourceInputDisabled && !correctingGenerating && !typedTitleIsDifferentAssignment ? (
                    <span style={{ fontSize: "12px", color: "#FFD8CC", fontWeight: 600 }}>
                      Remove the selected student work to change the answer key.
                    </span>
                  ) : null}
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", color: "#fff", fontWeight: 600, alignItems: "center", width: "100%" }}>
                  <span>
                    Blank Test Files to Solve (Optional)
                    {renderCorrectAssignmentHelpTrigger("Upload the blank quiz, test, or worksheet here when you want AI to derive the correct answers and store them under the assignment title. If the file does not show a version, it will be treated as Version 1 until another version is added.", 360)}
                  </span>
                  <input
                    key={`tests-to-solve-files-${correctingFileInputResetKey}`}
                    type="file"
                    accept=".pdf,application/pdf,.png,.jpg,.jpeg,.webp,image/*"
                    multiple
                    disabled={answerSourceInputDisabled}
                    onChange={(e) => {
                      setTestsToSolvePdf(Array.from(e.target.files || []));
                      setCorrectingModalError(null);
                      setCorrectingOrientationIssue(null);
                      setCorrectingReport(null);
                      setCorrectingPrimaryActionFeedback("");
                    }}
                    style={{
                      fontWeight: 400,
                      color: "#fff",
                      background: "#013469",
                      border: "3px solid #E43522",
                      borderRadius: "6px",
                      padding: "10px",
                      width: "min(360px, 100%)",
                      opacity: answerSourceInputDisabled ? 0.45 : 1,
                      cursor: answerSourceInputDisabled ? "not-allowed" : "pointer",
                    }}
                  />
                  <span style={{ fontSize: "13px", color: "#fff", fontWeight: 400 }}>
                    {testsToSolvePdf.length > 0
                      ? testsToSolvePdf.map((f) => f.name).join(", ")
                      : "No files selected"}
                  </span>
                  {answerSourceInputDisabled && !correctingGenerating && !typedTitleIsDifferentAssignment ? (
                    <span style={{ fontSize: "12px", color: "#FFD8CC", fontWeight: 600 }}>
                      Remove the selected student work to change the answer key.
                    </span>
                  ) : null}
                </div>
              )
            )}

            {!anyCorrectingPanelOpen && (
              typeof activeAnswerKeyInfo !== "undefined" && activeAnswerKeyInfo?.versionCount > 0 ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", color: "#fff", fontWeight: 600, alignItems: "center", width: "100%", opacity: studentWorkInputDisabled ? 0.45 : 1 }}>
                  <span>
                    Student Work Files
                    {renderCorrectAssignmentHelpTrigger("Add student work here when you want the backend to grade and send results. Leave this blank when you only want to prepare the assignment and store teacher answer keys ahead of time.", 330)}
                  </span>
                  <input
                    key={`student-work-files-${correctingFileInputResetKey}`}
                    type="file"
                    accept=".pdf,application/pdf,.png,.jpg,.jpeg,.webp,image/*"
                    multiple
                    disabled={studentWorkInputDisabled}
                    onChange={(e) => {
                      setStudentWorkPdf(Array.from(e.target.files || []));
                      setCorrectingModalError(null);
                      setCorrectingOrientationIssue(null);
                      setCorrectingReport(null);
                      setCorrectingPrimaryActionFeedback("");
                    }}
                    style={{
                      fontWeight: 400,
                      color: "#fff",
                      background: "#013469",
                      border: "3px solid #E43522",
                      borderRadius: "6px",
                      padding: "10px",
                      width: "min(360px, 100%)",
                      cursor: studentWorkInputDisabled ? "not-allowed" : "pointer",
                    }}
                  />
                  <span style={{ fontSize: "13px", color: "#fff", fontWeight: 400 }}>
                    {studentWorkPdf.length > 0
                      ? studentWorkPdf.map((f) => f.name).join(", ")
                      : "No files selected"}
                  </span>
                  {studentWorkInputDisabled && !correctingGenerating ? (
                    <span style={{ fontSize: "12px", color: "#FFD8CC", fontWeight: 600 }}>
                      Submit the answer key by itself first. Remove the selected answer key files to grade student work.
                    </span>
                  ) : null}
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px", color: "#FFD8CC", fontWeight: 600, alignItems: "center", width: "min(360px, 100%)", padding: "10px", border: "1px dashed rgba(255,216,204,0.45)", borderRadius: "8px" }}>
                  <span style={{ fontSize: "13px" }}>
                    Establish this assignment and its answer key first.
                  </span>
                  <span style={{ fontSize: "12px", fontWeight: 400 }}>
                    Once an answer key is stored, the option to submit student work for grading will appear here.
                  </span>
                </div>
              )
            )}


          </div>

          <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap", width: "100%" }}>
            <button
              type="button"
              onClick={() => openCorrectingPanelExclusively("gradeScale")}
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "8px 14px",
                background: "rgba(255,255,255,0.08)",
                color: "#FFD8CC",
                border: "1px solid rgba(255,216,204,0.45)",
                borderRadius: "999px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: 700,
              }}
            >
              {showCorrectingGradeScale ? "Hide Assignment Scoring Method" : "Assignment Scoring Method"}
              {renderCorrectAssignmentHelpTrigger(`The current scoring method is: ${activeCorrectingGradeScaleOption.description}${activeCorrectingGradeScaleValueLabel ? `\n\n${activeCorrectingGradeScaleValueLabel}` : ""}
Click to switch.`, 320)}
            </button>
            <button
              type="button"
              onClick={() => openCorrectingPanelExclusively("specialInstructions")}
              style={{
                padding: "8px 14px",
                background: "rgba(255,255,255,0.08)",
                color: "#FFD8CC",
                border: "1px solid rgba(255,216,204,0.45)",
                borderRadius: "999px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: 700,
              }}
            >
              {showCorrectingSpecialInstructions ? "Hide Special Grading Instructions" : "Special Grading Instructions"}
            </button>
            <button
              type="button"
              onClick={() => openCorrectingPanelExclusively("gradingNorms")}
              style={{
                padding: "8px 14px",
                background: "rgba(255,255,255,0.08)",
                color: "#FFD8CC",
                border: "1px solid rgba(255,216,204,0.45)",
                borderRadius: "999px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: 700,
              }}
            >
              {showCorrectingGradingNorms ? "Hide Grading Norms" : "Show Grading Norms"}  {renderCorrectAssignmentHelpTrigger2(`Your current grading preferences are: ${correctingScoringSettings ? `\n
              ${correctingScoringSettings.radicalPrompt} 
    \n\n ${correctingScoringSettings.decimalPrompt} 
` : ""}
Click to switch.`, 320)}
            </button>
            {activeAnswerKeyVersionCount > 0 ? (
              <button
                type="button"
                onClick={() => openCorrectingPanelExclusively("activeAnswerSheets")}
                style={{
                  padding: "8px 14px",
                  background: "rgba(255,255,255,0.08)",
                  color: "#FFD8CC",
                  border: "1px solid rgba(255,216,204,0.45)",
                  borderRadius: "999px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                }}
              >
                {showCorrectingActiveAnswerSheets ? "Hide Active Answer Sheets" : "Active Answer Sheets"}
              </button>
            ) : null}
          </div>

          {correctingOrientationIssue ? (
            <div
              style={{
                width: "100%",
                background: "linear-gradient(135deg, rgba(228,53,34,0.22), rgba(255,174,66,0.14))",
                border: "1px solid rgba(255,176,147,0.9)",
                borderRadius: "14px",
                padding: "16px 18px",
                textAlign: "left",
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.05)",
              }}
            >
              <div style={{ fontSize: "17px", fontWeight: 800, color: "#FFD8CC", marginBottom: "8px", textAlign: "center" }}>
                {correctingOrientationIssue.title || "Upload blocked"}
              </div>
              <div style={{ fontSize: "14px", lineHeight: 1.55, color: "#FFF4EF", marginBottom: orientationIssueFiles.length > 0 ? "14px" : 0 }}>
                {correctingOrientationIssue.message}
              </div>
              {orientationIssueFiles.map((fileIssue) => (
                <div
                  key={`${fileIssue.label}-${fileIssue.fileName || 'unknown-file'}`}
                  style={{
                    border: "1px solid rgba(255,255,255,0.14)",
                    borderRadius: "10px",
                    padding: "12px 14px",
                    background: "rgba(0,0,0,0.16)",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: 700, color: "#FFFFFF" }}>{fileIssue.label}</div>
                  <div style={{ fontSize: "12px", color: "#FFD8CC", marginTop: "2px" }}>{fileIssue.fileName || "Unnamed PDF"}</div>
                  <ul style={{ margin: "10px 0 0 18px", padding: 0, lineHeight: 1.55 }}>
                    {fileIssue.flaggedPages.map((pageIssue) => (
                      <li key={`${fileIssue.label}-page-${pageIssue.pageNumber}`} style={{ marginBottom: "6px" }}>
                        <span style={{ fontWeight: 700 }}>Page {pageIssue.pageNumber}</span>
                        {`: ${pageIssue.recommendedRotationLabel}. Upright detection found ${pageIssue.currentSelectedCount} clear bubbles at 0 degrees versus ${pageIssue.bestSelectedCount} at ${pageIssue.recommendedRotationDegrees} degrees.`}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ) : null}

          {correctingModalError ? (
            <div style={{ width: "100%", background: "rgba(228,53,34,0.18)", border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px", fontSize: "14px", lineHeight: 1.5 }}>
              {correctingModalError}
            </div>
          ) : null}

          {isAnswerKeyParseFailed && !correctingModalError ? (
            <div style={{ width: "100%", background: "rgba(228,53,34,0.18)", border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px", fontSize: "14px", lineHeight: 1.5 }}>
              {activeAnswerKeyParseError
                ? `Answer-key parsing failed: ${activeAnswerKeyParseError}`
                : "Answer-key parsing failed. Please re-upload the teacher answer keys and try again."}
            </div>
          ) : null}

          {correctingReport ? (
            <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px", textAlign: "left" }}>
              <div style={{ fontSize: "18px", fontWeight: 700, textAlign: "center" }}>Backend Report</div>
              {isSaveOnlyReport ? (
                <>
                  <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "14px 16px", background: "rgba(1,52,105,0.22)" }}>
                    <div style={{ fontSize: "18px", fontWeight: 700, textAlign: "center", marginBottom: "10px" }}>
                      {testsToSolvePdf.length > 0 ? "Answers solved and saved" : "Active assignment saved"}
                    </div>
                    <div style={{ fontSize: "14px", lineHeight: 1.6, textAlign: "center", color: "#FFF4EF" }}>
                      {compactSaveMessage}
                    </div>
                    <div style={{ marginTop: "12px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "10px" }}>
                      <div style={{ border: "1px solid rgba(228,53,34,0.45)", borderRadius: "8px", padding: "10px 12px" }}>
                        <div style={{ fontSize: "12px", color: "#FFD8CC", textTransform: "uppercase", letterSpacing: "0.04em" }}>Assignment</div>
                        <div style={{ marginTop: "4px", fontSize: "15px", fontWeight: 700 }}>{reportSummary.assignmentTitle || activeAnswerKeyInfo?.assignmentTitle || "Not reported"}</div>
                      </div>
                      <div style={{ border: "1px solid rgba(228,53,34,0.45)", borderRadius: "8px", padding: "10px 12px" }}>
                        <div style={{ fontSize: "12px", color: "#FFD8CC", textTransform: "uppercase", letterSpacing: "0.04em" }}>Stored answer key versions</div>
                        <div style={{ marginTop: "4px", fontSize: "15px", fontWeight: 700 }}>{availableAnswerVersionDetails.length || savedAnswerKeyVersionCount || answerSheetPdf.length || 0}</div>
                      </div>
                      <div style={{ border: "1px solid rgba(228,53,34,0.45)", borderRadius: "8px", padding: "10px 12px" }}>
                        <div style={{ fontSize: "12px", color: "#FFD8CC", textTransform: "uppercase", letterSpacing: "0.04em" }}>Google Classroom</div>
                        <div style={{ marginTop: "4px", fontSize: "15px", fontWeight: 700 }}>Waiting for student work</div>
                      </div>
                    </div>
                    {isAnswerKeyParsing ? (
                      <div style={{ marginTop: "12px", fontSize: "13px", lineHeight: 1.5, textAlign: "center", color: "#FFD8CC" }}>
                        Answer keys are still being parsed in the background. You can leave this open and it will update automatically.
                      </div>
                    ) : null}
                  </div>

                  {(processingWarnings.length > 0 || isAnswerKeyParseFailed) ? (
                    <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px" }}>
                      <div style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px", textAlign: "center" }}>Attention</div>
                      {isAnswerKeyParseFailed ? (
                        <div style={{ marginBottom: processingWarnings.length > 0 ? "10px" : 0 }}>
                          {activeAnswerKeyParseError || "Answer-key parsing failed. Please re-upload the teacher answer keys and try again."}
                        </div>
                      ) : null}
                      {processingWarnings.length > 0 ? (
                        <ul style={{ margin: 0, paddingLeft: "18px" }}>
                          {processingWarnings.map((warning, index) => (
                            <li key={`${warning}-${index}`}>{warning}</li>
                          ))}
                        </ul>
                      ) : null}
                    </div>
                  ) : null}

                  <details style={{ border: "1px solid rgba(228,53,34,0.5)", borderRadius: "8px", padding: "12px 14px" }}>
                    <summary style={{ cursor: "pointer", fontWeight: 700 }}>Show technical details</summary>
                    <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", gap: "6px" }}>
                      <div>Course ID: {reportSummary.courseId || "Not reported"}</div>
                      <div>Roster Matching Mode: {reportSummary.rosterMatchingMode || "Not reported"}</div>
                      <div>Implementation Status: {reportSummary.implementationStatus || "Not reported"}</div>
                      <div>PDF Ingestion: {processingReport?.phases?.pdfIngestion || "Not reported"}</div>
                      <div>Text Extraction: {processingReport?.phases?.textExtraction || "Not reported"}</div>
                      <div>Question Detection: {processingReport?.phases?.questionDetection || "Not reported"}</div>
                    </div>
                  </details>
                </>
              ) : (
                <>
                  <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px" }}>
                    <div style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px", textAlign: "center" }}>Summary</div>
                    <div>Course ID: {reportSummary.courseId || "Not reported"}</div>
                    <div>Assignment Title: {reportSummary.assignmentTitle || "Not reported"}</div>
                    <div>Max Points: {reportSummary.maxPoints ?? "Not reported"}</div>
                    <div>Google Classroom Score Scaling: {describeCorrectingGradeScaleSettings(reportSummary.gradeScaleSettings)}</div>
                    <div>Roster Matching Mode: {reportSummary.rosterMatchingMode || "Not reported"}</div>
                    <div>Implementation Status: {reportSummary.implementationStatus || "Not reported"}</div>
                    <div>Answer Key Source Available: {reportSummary.hasAnswerKeyPdf ? "Yes" : "No"}</div>
                    <div>Student Work File Received: {reportSummary.hasStudentWorkPdf ? "Yes" : "No"}</div>
                  </div>

                  <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px" }}>
                    <div style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px", textAlign: "center" }}>Processing</div>
                    <div>PDF Ingestion: {processingReport?.phases?.pdfIngestion || "Not reported"}</div>
                    <div>Text Extraction: {processingReport?.phases?.textExtraction || "Not reported"}</div>
                    <div>Question Detection: {processingReport?.phases?.questionDetection || "Not reported"}</div>
                    <div>Student Text Reader: {processingReport?.studentTextReaderSummary?.primaryReader || "Not reported"}</div>
                    {Array.isArray(processingReport?.studentTextReaderSummary?.pages) && processingReport.studentTextReaderSummary.pages.length > 0 ? (
                      <div style={{ marginTop: "4px", fontSize: "12px", color: "#FFD8CC" }}>
                        {processingReport.studentTextReaderSummary.pages.map((entry) => `page ${entry.pageNumber}: ${entry.reader}`).join(" | ")}
                      </div>
                    ) : null}
                    <div>Deterministic Scoring Preview: {processingReport?.phases?.deterministicScoring || "Not reported"}</div>
                    <div>Open Response Review: {processingReport?.phases?.openResponseReview || "Not reported"}</div>
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Warnings</div>
                    {processingWarnings.length > 0 ? (
                      <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                        {processingWarnings.map((warning, index) => (
                          <li key={`${warning}-${index}`}>{warning}</li>
                        ))}
                      </ul>
                    ) : (
                      <div style={{ marginTop: "4px" }}>No warnings reported</div>
                    )}
                  </div>

                  <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px" }}>
                    <div style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px", textAlign: "center" }}>Grading</div>
                    <div>Total Tests Detected: {gradingReport.totalTestsDetected ?? 0}</div>
                    <div>Full Confidence: {gradingReport.testsGradedWithFullConfidence ?? 0}</div>
                    <div>Review Needed: {gradingReport.testsGradedWithReviewNeeded ?? 0}</div>
                    <div>Auto-Scored on Unsure Rule: {gradingReport.testsAutoScoredUsingCorrectOnUnsureRule ?? 0}</div>
                    <div>Multiple Choice Questions Scored: {gradingReport.multipleChoiceQuestionsScored ?? 0}</div>
                    <div>Open Response Questions Scored: {gradingReport.openResponseQuestionsScored ?? 0}</div>
                    <div>Deterministic Matches: {gradingReport.deterministicObjectiveQuestionsMatched ?? 0}</div>
                    <div>Deterministic Mismatches: {gradingReport.deterministicObjectiveQuestionsMismatched ?? 0}</div>
                    <div>Deterministic Pending Review: {gradingReport.deterministicObjectiveQuestionsPendingReview ?? 0}</div>
                    <div>Open Response Detected: {gradingReport.openResponseDetected ? "Yes" : "No"}</div>
                    <div>Manual Review Recommended: {gradingReport.manualReviewRecommended ? "Yes" : "No"}</div>
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Quality Signals</div>
                    <div>Incorrect Answers Audited by AI: {gradingReport.qualitySignals?.incorrectAnswersAuditedByAi ?? 0}</div>
                    <div>Suspicious Read Flags: {gradingReport.qualitySignals?.suspiciousReadFlagsDetected ?? 0}</div>
                    <div>Suspicious Read Auto-Corrections: {gradingReport.qualitySignals?.suspiciousReadAutoCorrections ?? 0}</div>
                    <div>Suspicious Read Flag Rate: {gradingReport.qualitySignals?.suspiciousReadFlagRate ?? 0}%</div>
                    <div>AI Audit Challenge Rate: {gradingReport.qualitySignals?.incorrectAuditChallengeRate ?? 0}%</div>
                    <div style={{ marginTop: "4px", fontSize: "12px", color: "#FFD8CC" }}>{gradingReport.qualitySignals?.note || "Operational signals only."}</div>
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Review Needed Students</div>
                    {reviewNeededStudentsPreview.length > 0 ? (
                      <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                        {reviewNeededStudentsPreview.map((studentEntry) => (
                          <li key={studentEntry.key}>
                            {studentEntry.label}
                            {studentEntry.detail ? ` (${studentEntry.detail})` : ""}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div style={{ marginTop: "4px" }}>None reported</div>
                    )}
                  </div>

                  <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px" }}>
                    <div style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px", textAlign: "center" }}>Google Classroom</div>
                    <div>Assignment Created: {classroomReport.assignmentCreated ? "Yes" : "No"}</div>
                    <div>Assignment ID: {classroomReport.assignmentId || "Not reported"}</div>
                    <div>Attempted Assignment Title: {classroomReport.attemptedAssignmentTitle || "Not reported"}</div>
                    <div>Assignment Creation Attempted: {classroomReport.assignmentCreationAttempted ? "Yes" : "No"}</div>
                    <div>Assignment Creation Status: {classroomReport.assignmentCreationStatus || "Not reported"}</div>
                    <div>Assignment Creation Message: {classroomReport.assignmentCreationMessage || "Not reported"}</div>
                    <div>Matched to Google Classroom Students: {classroomReport.testsMatchedToGoogleClassroomStudents ?? 0}</div>
                    <div>Grade Posting Attempted: {classroomReport.gradePostingAttempted ? "Yes" : "No"}</div>
                    <div>Grade Posting Status: {classroomReport.gradePostingStatus || "Not reported"}</div>
                    <div>Grade Posting Message: {classroomReport.gradePostingMessage || "Not reported"}</div>
                    <div>Grades Posted: {classroomReport.gradesPostedCount ?? 0}</div>
                    <div>Turned In: {classroomReport.turnedInCount ?? 0}</div>
                    <div>Submission Return Status: {classroomReport.submissionReturnStatus || "Not reported"}</div>
                    <div>Submission Return Message: {classroomReport.submissionReturnMessage || "Not reported"}</div>
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Score Writeback Preview</div>
                    {scoreWritebackPreview.length > 0 ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "6px" }}>
                        {scoreWritebackPreview.map((studentPreview, index) => (
                          <div key={`${studentPreview.studentLabel || 'preview'}-${index}`} style={{ border: "1px solid rgba(228,53,34,0.45)", borderRadius: "6px", padding: "8px 10px" }}>
                            <div><strong>Student:</strong> {studentPreview.studentLabel || "Not reported"}</div>
                            <div><strong>Matched Objective Questions:</strong> {studentPreview.matchedObjectiveQuestions ?? 0}</div>
                            <div><strong>Mismatched Objective Questions:</strong> {studentPreview.mismatchedObjectiveQuestions ?? 0}</div>
                            <div><strong>Pending Review:</strong> {studentPreview.objectiveQuestionsPendingReview ?? 0}</div>
                            <div><strong>Full Confidence Count:</strong> {studentPreview.fullConfidenceCount ?? 0}</div>
                            <div><strong>Review Needed Count:</strong> {studentPreview.reviewNeededCount ?? 0}</div>
                            <div><strong>Grade Ready For Writeback:</strong> {studentPreview.gradeReadyForClassroomWriteback ? "Yes" : "No"}</div>
                            <div><strong>Reason:</strong> {studentPreview.reason || "Not reported"}</div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ marginTop: "4px" }}>No score preview reported</div>
                    )}
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Unmatched Student Names</div>
                    {unmatchedStudentsPreview.length > 0 ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "6px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 180px", gap: "10px", fontSize: "12px", fontWeight: 700, color: "#FFD8CC", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                          <div>Name Read</div>
                          <div>Read Student Identifier</div>
                        </div>
                        {unmatchedStudentsPreview.map((studentEntry, index) => {
                          const detectedStudentIdentifier = Array.isArray(studentEntry?.extractedStudentCodes) && studentEntry.extractedStudentCodes.length > 0
                            ? studentEntry.extractedStudentCodes.join(", ")
                            : "Not detected";
                          const studentLabel = studentEntry?.studentLabel || `student-${index + 1}`;

                          return (
                            <div
                              key={`${studentLabel}-${detectedStudentIdentifier}-${index}`}
                              style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 180px", gap: "10px", border: "1px solid rgba(228,53,34,0.45)", borderRadius: "6px", padding: "8px 10px" }}
                            >
                              <div>{studentLabel}</div>
                              <div>{detectedStudentIdentifier}</div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div style={{ marginTop: "4px" }}>None reported</div>
                    )}
                  </div>

                  <div style={{ border: "1px solid #E43522", borderRadius: "8px", padding: "12px 14px" }}>
                    <div style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px", textAlign: "center" }}>Corrected Files</div>
                    <div>Corrected Tests Generated: {correctedFilesReport.correctedTestsGeneratedCount ?? 0}</div>
                    <div>Attached to Submission: {correctedFilesReport.correctedTestsAttachedToSubmissionCount ?? 0}</div>
                    <div>Saved to Assignment Folder: {correctedFilesReport.correctedTestsSavedToAssignmentFolderCount ?? 0}</div>
                    <div>Saved to Drive: {correctedFilesReport.correctedTestsSavedToDriveCount ?? 0}</div>
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Uploaded Corrected Files</div>
                    {uploadedCorrectedFilesPreview.length > 0 ? (
                      <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                        {uploadedCorrectedFilesPreview.map((fileEntry, index) => {
                          const fileLabel = fileEntry?.title || fileEntry?.id || `Corrected file ${index + 1}`;
                          const fileHref = fileEntry?.alternateLink || null;

                          return (
                            <li key={`${fileLabel}-${index}`}>
                              {fileHref ? (
                                <a
                                  href={fileHref}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{ color: "#8ecbff" }}
                                >
                                  {fileLabel}
                                </a>
                              ) : fileLabel}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div style={{ marginTop: "4px" }}>No uploaded corrected files reported</div>
                    )}
                    <div style={{ marginTop: "8px", fontWeight: 600 }}>Missing Uploads</div>
                    {correctedTestsMissingUpload.length > 0 ? (
                      <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                        {correctedTestsMissingUpload.map((fileName, index) => (
                          <li key={`${fileName}-${index}`}>{fileName}</li>
                        ))}
                      </ul>
                    ) : (
                      <div style={{ marginTop: "4px" }}>None reported</div>
                    )}
                  </div>
                </>
              )}
            </div>
          ) : null}

          {/* Thin progress bar for answer-key processing and student-file grading.
              Always rendered so it reserves a little space and never shifts the buttons;
              it simply fades in while a run is generating and fades back out when idle. */}
          <div
            aria-hidden={!(correctingGenerating || correctingProgress > 0)}
            style={{
              width: "100%",
              height: "5px",
              marginBottom: "10px",
              borderRadius: "999px",
              background: "rgba(255,255,255,0.12)",
              overflow: "hidden",
              opacity: correctingGenerating || correctingProgress > 0 ? 1 : 0,
              transition: "opacity 0.25s ease",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${Math.min(100, Math.max(0, correctingProgress))}%`,
                background: "linear-gradient(90deg, rgba(0,255,0,0.55), #00FF00)",
                borderRadius: "999px",
                boxShadow: correctingProgress > 0 ? "0 0 6px rgba(0,255,0,0.55)" : "none",

                transition: "width 0.4s ease",
              }}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "center", gap: "10px", width: "100%" }}>

            <button
              onClick={closeCorrectAssignmentModal}
              style={{
                padding: "10px 18px",
                background: "#013469",
                color: "#fff",
                border: "3px solid #E43522",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Cancel
            </button>

            <button
              onClick={saveanswerkeys}
              style={{
                padding: "10px 18px",
                background: "#013469",
                color: "#fff",
                border: "3px solid #E43522",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Save Answer Keys
            </button>
            <button
              onClick={() => {
                if (typeof window !== "undefined") {
                  window.__lastCallNodeButtonClickAt = new Date().toISOString();
                }
                callnodefinal();
              }}
              style={{
                padding: "10px 18px",
                background: "#013469",
                color: "#fff",
                border: "3px solid #E43522",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Correct
            </button>

          </div>
          {renderCorrectAssignmentTooltip()}
        </div>
      </div>
    );
  }

  const Homewithparentimports =
    "/studentid/" + studentid + "/" + classid + "/id/" + id + "/language/" + language;

  return (
    <div className="App22">
      {renderEmailReportModal()}
      {renderSyllabusModal()}
      {renderCurriculumMapModal()}
      {renderStudentCodeHelperModal()}
      {renderCorrectAssignmentModal()}
      <NavBar
        donotshow={donotshow}
        role={role}
        temparray={temparray}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activeid={activeid}
        activename={activename}
        parentlanguagecode={parentlanguagecode}
        setCurrentstudent={setCurrentstudent}
        setShowcurrentroster={setShowcurrentroster}
        setStudentidd={setStudentidd}
        setActiveid={setActiveid}
        setActivestudentlist={setActivestudentlist}
        setActivename={setActivename}
        setActiveperiod={setActiveperiod}
      />

      <div className="App">

        <header className="App-header" style={{ fontSize: "20px" }}>

          {selectedclass != "" ? (
            <div className="centerme295">
              <br />
              {selectedclass.classname} {selectedclass.period}
            </div>
          ) : (
            <>
              {createaclass == false ? <div className="centerme2951">
                <br />
                Set-Up
              </div> : <div className="centerme295">
                <br />
                Create Class
              </div>}
              <br />

              {createaclass == false ? <div className="passstart222" onClick={() => {
                setCreateaclass(true)
              }}>
                <div className="innertext">Create A New Class
                </div>
              </div> :
                <>
                  <input
                    className="Newrow29981"
                    placeholder={"Enter Course Name"}
                    value={coursename2}
                    onChange={(e) => setCoursename2(e.target.value)} />
                  <input
                    className="Newrow29981"
                    placeholder={"Enter Period"}
                    value={period2}
                    onChange={(e) => setPeriod2(e.target.value)}

                  />
                  <input
                    className="Newrow29981"
                    placeholder={"Enter Location"}
                    value={location5}
                    onChange={(e) => setLocation5(e.target.value)}
                  />

                  <br></br>
                  {processingtrue == false ? <div
                    className="passstart222"
                    onClick={() => createclassthengogetstudents()}
                    style={{ position: "relative" }}
                    onMouseEnter={e => {
                      const tooltip = document.createElement("div");
                      tooltip.className = "custom-tooltip";
                      tooltip.innerHTML = `This will create a course in FastClassPass. You will then be redirected to a page which will show Google Classroom classes associated with ${localemailaddress}. When one of those courses is selected, the students from that class will be imported into this class.`;
                      tooltip.style.position = "absolute";
                      tooltip.style.top = "50%";
                      tooltip.style.left = "105%";
                      tooltip.style.transform = "translateY(-50%)";
                      tooltip.style.background = "#013469";
                      tooltip.style.color = "#fff";
                      tooltip.style.padding = "10px 16px";
                      tooltip.style.borderRadius = "8px";
                      tooltip.style.fontSize = "16px";
                      tooltip.style.zIndex = "1000";
                      tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                      tooltip.style.borderColor = "#E43522";
                      tooltip.style.borderWidth = "3px";
                      tooltip.style.borderStyle = "solid";
                      tooltip.style.pointerEvents = "none";
                      tooltip.style.width = "300px";
                      e.currentTarget.appendChild(tooltip);
                      e.currentTarget._tooltip = tooltip;
                    }}
                    onMouseLeave={e => {
                      if (e.currentTarget._tooltip) {
                        e.currentTarget.removeChild(e.currentTarget._tooltip);
                        e.currentTarget._tooltip = null;
                      }
                    }}
                  >
                    <div className="innertext">Create Class & Import Students From Google Classroom</div>
                  </div> : <div className="passstart222active">
                    <div className="innertext">Create Class & Import Students From Google Classroom</div>
                  </div>}
                </>
              }
            </>

          )}
          <br />
          <>


            {editparentcontactinfo != true && selectedclass != "" ? (
              <div
                className="passstart222"
                onClick={() => gogetclassesfromadifferentaccount()}

                style={{ position: "relative" }}
                onMouseEnter={e => {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerHTML = `Pressing this button will show Google Classroom classes associated with ${localemailaddress}. When one of those courses is selected, the students from that class will be imported into this class.`;
                  tooltip.style.position = "absolute";
                  tooltip.style.top = "50%";
                  tooltip.style.left = "105%";
                  tooltip.style.transform = "translateY(-50%)";
                  tooltip.style.background = "#013469";
                  tooltip.style.color = "#fff";
                  tooltip.style.padding = "10px 16px";
                  tooltip.style.borderRadius = "8px";
                  tooltip.style.fontSize = "16px";
                  tooltip.style.zIndex = "1000";
                  tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                  tooltip.style.borderColor = "#E43522";
                  tooltip.style.borderWidth = "3px";
                  tooltip.style.borderStyle = "solid";
                  tooltip.style.width = "300px";



                  tooltip.style.pointerEvents = "none";
                  e.currentTarget.appendChild(tooltip);
                  e.currentTarget._tooltip = tooltip;
                }}
                onMouseLeave={e => {
                  if (e.currentTarget._tooltip) {
                    e.currentTarget.removeChild(e.currentTarget._tooltip);
                    e.currentTarget._tooltip = null;
                  }
                }}
              >
                <div className="innertext">Sync Roster With Google Classroom Class</div>
              </div>
            ) : null}


            {editparentcontactinfo != true && selectedclass != "" && showpdfgetter == true ? (
              <div className="passstart222" ref={pdfPickerRef}>
                <input type="file" accept=".pdf" onChange={handleFileChange} className="innertext221" />
              </div>
            ) : editparentcontactinfo != true && selectedclass != "" && typeof gclassroomid != "undefined" && gclassroomid.length > 0 ? (
              showCourseDocsButtons == true ? (
                <div className="passstart222divide" style={{ padding: 0, marginBottom: 10 }} ref={courseDocsButtonsRef}>
                  <div style={{ display: "flex", gap: 8, width: "100%" }}>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => { getsyllabus() }}
                      onMouseEnter={e => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "custom-tooltip";
                        tooltip.innerHTML = `These course documents are created based on the Google Classroom course (and assignments) linked to this class. The \"Get Syllabus\" button creates or retrieves the course syllabus, the \"Get Curriculum Map\" button creates or retrieves the curriculum map.`;
                        tooltip.style.position = "absolute";
                        tooltip.style.top = "50%";
                        tooltip.style.right = "105%";
                        tooltip.style.transform = "translateY(-50%)";
                        tooltip.style.background = "#013469";
                        tooltip.style.color = "#fff";
                        tooltip.style.padding = "10px 16px";
                        tooltip.style.borderRadius = "8px";
                        tooltip.style.fontSize = "16px";
                        tooltip.style.zIndex = "1000";
                        tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                        tooltip.style.borderColor = "#E43522";
                        tooltip.style.borderWidth = "3px";
                        tooltip.style.borderStyle = "solid";
                        tooltip.style.pointerEvents = "none";
                        tooltip.style.width = "300px";
                        e.currentTarget.appendChild(tooltip);
                        e.currentTarget._tooltip = tooltip;
                      }}
                      onMouseLeave={e => {
                        if (e.currentTarget._tooltip) {
                          e.currentTarget.removeChild(e.currentTarget._tooltip);
                          e.currentTarget._tooltip = null;
                        }
                      }}
                    >
                      <div className="innertext">Get Syllabus</div>
                    </button>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => { getcurriculummap(); }}
                    >
                      <div className="innertext">Get Curriculum Map</div>
                    </button>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => { openCorrectAssignmentModal(); }}
                      onMouseEnter={e => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "custom-tooltip";
                        tooltip.innerHTML = `This button opens the correcting workflow first. Upload student work, optionally upload teacher answer-key files, and let the backend reuse the active stored answer key for the class when possible.`;
                        tooltip.style.position = "absolute";
                        tooltip.style.top = "50%";
                        tooltip.style.left = "105%";
                        tooltip.style.transform = "translateY(-50%)";
                        tooltip.style.background = "#013469";
                        tooltip.style.color = "#fff";
                        tooltip.style.padding = "10px 16px";
                        tooltip.style.borderRadius = "8px";
                        tooltip.style.fontSize = "16px";
                        tooltip.style.zIndex = "1000";
                        tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                        tooltip.style.borderColor = "#E43522";
                        tooltip.style.borderWidth = "3px";
                        tooltip.style.borderStyle = "solid";
                        tooltip.style.pointerEvents = "none";
                        tooltip.style.width = "300px";
                        e.currentTarget.appendChild(tooltip);
                        e.currentTarget._tooltip = tooltip;
                      }}
                      onMouseLeave={e => {
                        if (e.currentTarget._tooltip) {
                          e.currentTarget.removeChild(e.currentTarget._tooltip);
                          e.currentTarget._tooltip = null;
                        }
                      }}
                    >
                      <div className="innertext">Create/Correct Assignment</div>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="passstart222divide" style={{ padding: 0, marginBottom: 10 }}>
                  <div style={{ display: "flex", gap: 8, width: "100%" }}>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => setShowpdfgetter(!showpdfgetter)}
                      onMouseEnter={e => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "custom-tooltip";
                        tooltip.innerHTML = `This button opens up an 'Input Selector' which requests a pdf that shows contact information of the students in your class. These pdfs can be created on 'Student Information System (SIS)' (like PowerSchool or Aspen) when you visit a listing of your students which contains sections of contact information for each student. Download that on to your computer then upload it here so that the information can be attributed to the students in this class.`;
                        tooltip.style.position = "absolute";
                        tooltip.style.top = "50%";
                        tooltip.style.right = "105%";
                        tooltip.style.transform = "translateY(-50%)";
                        tooltip.style.background = "#013469";
                        tooltip.style.color = "#fff";
                        tooltip.style.padding = "10px 16px";
                        tooltip.style.borderRadius = "8px";
                        tooltip.style.fontSize = "16px";
                        tooltip.style.zIndex = "1000";
                        tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                        tooltip.style.borderColor = "#E43522";
                        tooltip.style.borderWidth = "3px";
                        tooltip.style.borderStyle = "solid";
                        tooltip.style.pointerEvents = "none";
                        tooltip.style.width = "300px";
                        e.currentTarget.appendChild(tooltip);
                        e.currentTarget._tooltip = tooltip;
                      }}
                      onMouseLeave={e => {
                        if (e.currentTarget._tooltip) {
                          e.currentTarget.removeChild(e.currentTarget._tooltip);
                          e.currentTarget._tooltip = null;
                        }
                      }}
                    >
                      <div className="innertext">Update Contact Info.</div>
                    </button>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => setShowCourseDocsButtons(true)}

                    >
                      <div className="innertext">Get Course Docs.</div>
                    </button>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => setShowStudentCodeHelperModal(true)}
                      onMouseEnter={e => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "custom-tooltip";
                        tooltip.innerHTML = `This opens a board-friendly student code list. Tell students to write their code at the top of each page, circle the code, and circle their answers clearly.`;
                        tooltip.style.position = "absolute";
                        tooltip.style.top = "50%";
                        tooltip.style.left = "105%";
                        tooltip.style.transform = "translateY(-50%)";
                        tooltip.style.background = "#013469";
                        tooltip.style.color = "#fff";
                        tooltip.style.padding = "10px 16px";
                        tooltip.style.borderRadius = "8px";
                        tooltip.style.fontSize = "16px";
                        tooltip.style.zIndex = "1000";
                        tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                        tooltip.style.borderColor = "#E43522";
                        tooltip.style.borderWidth = "3px";
                        tooltip.style.borderStyle = "solid";
                        tooltip.style.pointerEvents = "none";
                        tooltip.style.width = "300px";
                        e.currentTarget.appendChild(tooltip);
                        e.currentTarget._tooltip = tooltip;
                      }}
                      onMouseLeave={e => {
                        if (e.currentTarget._tooltip) {
                          e.currentTarget.removeChild(e.currentTarget._tooltip);
                          e.currentTarget._tooltip = null;
                        }
                      }}
                    >
                      <div className="innertext">Show Student Codes</div>
                    </button>
                    <button
                      className="passstart222"
                      style={{ flex: 1, fontSize: "inherit", margin: 0, position: "relative" }}
                      onClick={() => openCorrectAssignmentModal()}
                      onMouseEnter={e => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "custom-tooltip";
                        tooltip.innerHTML = `This button opens a modal where you upload student work for an assignment. Teacher answer-key files are optional here because the backend can reuse the active stored answer key already saved for the class.`;
                        tooltip.style.position = "absolute";
                        tooltip.style.top = "50%";
                        tooltip.style.left = "105%";
                        tooltip.style.transform = "translateY(-50%)";
                        tooltip.style.background = "#013469";
                        tooltip.style.color = "#fff";
                        tooltip.style.padding = "10px 16px";
                        tooltip.style.borderRadius = "8px";
                        tooltip.style.fontSize = "16px";
                        tooltip.style.zIndex = "1000";
                        tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                        tooltip.style.borderColor = "#E43522";
                        tooltip.style.borderWidth = "3px";
                        tooltip.style.borderStyle = "solid";
                        tooltip.style.pointerEvents = "none";
                        tooltip.style.width = "300px";
                        e.currentTarget.appendChild(tooltip);
                        e.currentTarget._tooltip = tooltip;
                      }}
                      onMouseLeave={e => {
                        if (e.currentTarget._tooltip) {
                          e.currentTarget.removeChild(e.currentTarget._tooltip);
                          e.currentTarget._tooltip = null;
                        }
                      }}
                    >
                      <div className="innertext">Create/Correct Assignment</div>
                    </button>
                  </div>
                </div>
              )
            ) : null}


            {editparentcontactinfo != true && typeof gclassroomid != "undefined" && gclassroomid.length > 0 && selectedStudents.length > 0 && needtoslect == true ? <div className="passstart222divide" style={{ padding: 0, marginBottom: 10 }}>
              <div style={{ display: "flex", gap: 8, width: "100%" }}>



                <button
                  className="passstart222"
                  style={{ flex: 3, fontSize: "inherit", margin: 0 }}
                  onClick={() => {
                    let filteredStudentIds = [];
                    if (selectedclass && Array.isArray(selectedclass.studentIds)) {
                      filteredStudentIds = selectedclass.studentIds.filter(
                        studentObj =>
                          selectedStudents.includes(studentObj.firebasestudentid)
                      );

                      console.log('[DEBUG] About to save infoforsending2:', filteredStudentIds);
                      localStorage.setItem("infoforsending2", JSON.stringify(filteredStudentIds));
                      console.log('[DEBUG] infoforsending2 after set:', localStorage.getItem("infoforsending2"));
                      localStorage.setItem("infoforsending2timesent", Date.now().toString());
                      localStorage.setItem("parentorstudentnote", "parents");
                      localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());

                      // 🟢 DEBUG: Log what was saved
                      console.log('✅ MainMenu: Saved filtered students to localStorage', {
                        count: filteredStudentIds.length,
                        firstFew: filteredStudentIds.slice(0, 2).map(s => s.email || s.firebasestudentid),
                        timesent: Date.now()
                      });
                    }
                    setNeedtoslect(false);
                  }}
                >
                  <div className="innertext">Email <span className="innertext26">✅</span> Parents</div>
                </button>


                <button
                  className="passstart222"
                  style={{ flex: 3, fontSize: "inherit", margin: 0 }}
                  onClick={() => {
                    let filteredStudentIds = [];
                    if (selectedclass && Array.isArray(selectedclass.studentIds)) {
                      filteredStudentIds = selectedclass.studentIds.filter(
                        studentObj =>
                          selectedStudents.includes(studentObj.firebasestudentid)
                      );
                      console.log('[DEBUG] About to save infoforsending2:', filteredStudentIds);
                      localStorage.setItem("infoforsending2", JSON.stringify(filteredStudentIds));
                      console.log('[DEBUG] infoforsending2 after set:', localStorage.getItem("infoforsending2"));
                      localStorage.setItem("infoforsending2timesent", Date.now().toString());
                      localStorage.setItem("parentorstudentnote", "students");
                      localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());

                      // 🟢 DEBUG: Log what was saved
                      console.log('✅ MainMenu: Saved filtered students to localStorage', {
                        count: filteredStudentIds.length,
                        firstFew: filteredStudentIds.slice(0, 2).map(s => s.email || s.firebasestudentid),
                        timesent: Date.now()
                      });
                    }

                    setNeedtoslect(false);

                  }}
                >
                  <div className="innertext">Email <span className="innertext26">✅</span> Students</div>
                </button>

                <button
                  className="passstart222"
                  style={{ flex: 3, fontSize: "inherit", margin: 0 }}
                  onClick={() => {
                    let filteredStudentIds = [];
                    if (selectedclass && Array.isArray(selectedclass.studentIds)) {
                      filteredStudentIds = selectedclass.studentIds.filter(
                        studentObj =>
                          selectedStudents.includes(studentObj.firebasestudentid)
                      );
                      console.log('[DEBUG] About to save infoforsending2:', filteredStudentIds);
                      localStorage.setItem("infoforsending2", JSON.stringify(filteredStudentIds));
                      console.log('[DEBUG] infoforsending2 after set:', localStorage.getItem("infoforsending2"));
                      localStorage.setItem("infoforsending2timesent", Date.now().toString());
                      localStorage.setItem("parentorstudentnote", "both");
                      localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());

                      // 🟢 DEBUG: Log what was saved
                      console.log('✅ MainMenu: Saved filtered students to localStorage', {
                        count: filteredStudentIds.length,
                        firstFew: filteredStudentIds.slice(0, 2).map(s => s.email || s.firebasestudentid),
                        timesent: Date.now()
                      });
                    }
                    setNeedtoslect(false);

                  }}
                >
                  <div className="innertext">Email <span className="innertext26">✅</span> Both</div>
                </button>

              </div></div> : editparentcontactinfo != true && typeof gclassroomid != "undefined" && gclassroomid.length > 0 && needtoslect == true ? <div className="passstart222divide" style={{ padding: 0, marginBottom: 10 }}>
                <div style={{ display: "flex", gap: 8, width: "100%" }}>
                  <button
                    className="passstart222"
                    style={{ flex: 3, fontSize: "inherit", margin: 0 }}
                    onClick={() => {
                      // Save the current roster to localStorage before navigating
                      if (selectedclass && Array.isArray(selectedclass.studentIds)) {
                        localStorage.setItem("infoforsending2timesent", "0");
                        localStorage.setItem("parentorstudentnote", "parents");
                        localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());
                      }
                      setNeedtoslect(false);
                    }}
                  >
                    <div className="innertext">Email All (Parents)</div>
                  </button>

                  <button
                    className="passstart222"
                    style={{ flex: 3, fontSize: "inherit", margin: 0 }}
                    onClick={() => {
                      // Save the current roster to localStorage before navigating
                      if (selectedclass && Array.isArray(selectedclass.studentIds)) {
                        localStorage.setItem("infoforsending2timesent", "0");
                        localStorage.setItem("parentorstudentnote", "students");
                        localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());
                      }
                      setNeedtoslect(false);

                    }}
                  >
                    <div className="innertext">Email All (Students)</div>
                  </button>


                  <button
                    className="passstart222"
                    style={{ flex: 3, fontSize: "inherit", margin: 0 }}
                    onClick={() => {
                      // Save the current roster to localStorage before navigating
                      if (selectedclass && Array.isArray(selectedclass.studentIds)) {
                        localStorage.setItem("infoforsending2timesent", "0");
                        localStorage.setItem("parentorstudentnote", "both");
                        localStorage.setItem("parentorstudentnotetimesent", Date.now().toString());
                      }
                      setNeedtoslect(false);
                    }}
                  >
                    <div className="innertext">Email All (Both)</div>
                  </button>
                </div>
              </div> : editparentcontactinfo != true && typeof gclassroomid != "undefined" && gclassroomid.length > 0 ? <div className="passstart222divide" style={{ padding: 0, marginBottom: 10 }}>
                <div style={{ display: "flex", gap: 8, width: "100%" }}>
                  <button
                    className="passstart222"
                    style={{ flex: 7, fontSize: "inherit", margin: 0 }}
                    onClick={() => gogetlastttengcassiignments999(activeid, gclassroomid)}
                  >
                    {assignmentname1 && assignmentname1.length > 0 ? <div
                      className="innertext"
                      title={assignmentname1}
                    >
                      Switch: "{assignmentname1 && assignmentname1.length > 20
                        ? assignmentname1.slice(0, 20) + " ..."
                        : assignmentname1}" - ({last10updated})
                    </div> : <div
                      className="innertext"
                      title={assignmentname1}
                    >
                      No Assignment Selected
                    </div>}
                  </button>
                  <button
                    className="passstart222"
                    style={{ flex: 1, fontSize: "inherit", margin: 0 }}
                    onClick={() => {
                      const assignmentPayload = getSelectedAssignmentPayloadForSend();

                      navigate(Creatingmessage, {
                        state: {
                          ...assignmentPayload,
                        },
                      });
                    }}
                  >
                    <div className="innertext">Send</div>
                  </button>
                </div>
              </div> : null}

            {editparentcontactinfo != true && showcurrentroster && selectedclass ? <div className="passstart222" onClick={() => {
              setShowcurrentroster(false);
              setShowcurrentpasses(true);
            }}>
              <div className="innertext">Show Today's Passes
              </div>
            </div> : null}
          </> <>
            {editparentcontactinfo != true && showcurrentpasses && selectedclass != "" ? <div className="passstart222" onClick={() => {
              setShowcurrentroster(true);
              setShowcurrentpasses(false);
              setCurrentpass("");
            }}>
              <div className="innertext">Show Current Roster
              </div>
            </div> : null}
          </>  <>
            {editparentcontactinfo != true && showcurrentpasses != true && showcurrentroster != true && selectedclass != "" ? <div className="passstart222" onClick={() => {
              setShowcurrentroster(true);
              setShowcurrentpasses(false);
              setCurrentpass("");
            }}>
              <div className="innertext">Show Current Roster
              </div>
            </div> : null}
          </>

          <br />

          <ErrorBoundary componentName="Main View Rendering">
            {(() => {
              try {
                console.log('RENDER ATTEMPT:', {
                  currentclass: currentclass ? `${currentclass.length} items` : 'undefined',
                  firstStudent: currentclass && currentclass[0] ? 'exists' : 'missing',
                  activeid: activeid,
                  showcurrentroster
                });
                if (showcurrentroster === true && selectedclass != "") {
                  return (
                    <ErrorBoundary componentName="Students Component">
                      <Students
                        editparentcontactinfo={editparentcontactinfo}
                        setEditparentcontactinfo={setEditparentcontactinfo}
                        additionallinklevel={additionallinklevel}
                        setCurrentclass={setCurrentclass}
                        currentclass={currentclass}
                        activename={activename}
                        setSelectedclass={setSelectedclass}
                        activeid={activeid}
                        selectedclass={selectedclass}
                        setCurrentstudent={setCurrentstudent}
                        currentstudent={currentstudent}
                        studentidd={studentidd}
                        parentlanguagecode={parentlanguagecode}
                        id2={id}
                        classidd={activeid}
                        setShowcurrentroster={setShowcurrentroster}
                        setShowcurrentpasses={setShowcurrentpasses}
                        getschoolid={getschoolid}
                        school={school}
                        town={town}
                        state={state}
                        userdata2={userdata2}
                        showcurrentroster={showcurrentroster}
                        drinkwater={drinkwater}
                        broom={broom}
                        otherpass={otherpass}
                        location2={location2}
                        teacherid={teacherid}
                        teacheridforreturn={teacheridforreturn}
                        teacher={teacher}
                        coursename={coursename}
                        activeid2={activeid2}
                        linkedclass={linkedclass}
                        setPasslist={setPasslist}
                        currentlocation={currentlocation}
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        activestudentlist2={activestudentlist2}

                      />
                    </ErrorBoundary>
                  );
                } else if (selectedclass != "") {
                  return (
                    <ErrorBoundary componentName="Passes Component">
                      <Passes

                        setMinutespromptingemail={setMinutespromptingemail}
                        setWhowillemailed={setWhowillemailed}
                        setNewgreeting={setNewgreeting}
                        setNewgreetinga={setNewgreetinga}
                        setBathroompasslimit={setBathroompasslimit}
                        minutespromptingemail={minutespromptingemail}
                        whowillbeemailed={whowillbeemailed}
                        newgreeting={newgreeting}
                        newgreetinga={newgreetinga}
                        bathroompasslimit={bathroompasslimit}
                        setSendEmail={setSendEmail}
                        additionallinklevel={additionallinklevel}
                        currentclass={currentclass}
                        activename={activename}
                        activeid={activeid}
                        selectedclass={selectedclass}
                        setCurrentstudent={setCurrentstudent}
                        currentstudent={currentstudent}
                        studentidd={studentidd}
                        parentlanguagecode={parentlanguagecode}
                        id2={id}
                        classidd={activeid}
                        setShowcurrentroster={setShowcurrentroster}
                        setShowcurrentpasses={setShowcurrentpasses}
                        showcurrentpasses={showcurrentpasses}
                        getschoolid={getschoolid}
                        school={school}
                        town={town}
                        state={state}
                        userdata2={userdata2}
                        setUserdata2={setUserdata2}
                        setCurrentpass={setCurrentpass}
                        currentpassid={currentpassid}
                        drinkwater={drinkwater}
                        broom={broom}
                        otherpass={otherpass}
                        teacherid={teacherid}
                        teacheridforreturn={teacheridforreturn}
                        teacher={teacher}
                        coursename={coursename}
                        activeid2={activeid2}
                        linkedclass={linkedclass}
                        location2={location2}
                      />
                    </ErrorBoundary>
                  );
                } else if (selectedclass != "") {
                  return (
                    <ErrorBoundary componentName="Passes Component">
                      <Passes

                        setMinutespromptingemail={setMinutespromptingemail}
                        setWhowillemailed={setWhowillemailed}
                        setNewgreeting={setNewgreeting}
                        setNewgreetinga={setNewgreetinga}
                        setBathroompasslimit={setBathroompasslimit}
                        minutespromptingemail={minutespromptingemail}
                        whowillbeemailed={whowillbeemailed}
                        newgreeting={newgreeting}
                        newgreetinga={newgreetinga}
                        bathroompasslimit={bathroompasslimit}
                        setSendEmail={setSendEmail}
                        additionallinklevel={additionallinklevel}
                        currentclass={currentclass}
                        activename={activename}
                        activeid={activeid}
                        selectedclass={selectedclass}
                        setCurrentstudent={setCurrentstudent}
                        currentstudent={currentstudent}
                        studentidd={studentidd}
                        parentlanguagecode={parentlanguagecode}
                        id2={id}
                        classidd={activeid}
                        setShowcurrentroster={setShowcurrentroster}
                        setShowcurrentpasses={setShowcurrentpasses}
                        showcurrentpasses={showcurrentpasses}
                        getschoolid={getschoolid}
                        school={school}
                        town={town}
                        state={state}
                        userdata2={userdata2}
                        setCurrentpass={setCurrentpass}
                        currentpassid={currentpassid}
                        drinkwater={drinkwater}
                        broom={broom}
                        otherpass={otherpass}
                        teacherid={teacherid}
                        teacheridforreturn={teacheridforreturn}
                        teacher={teacher}
                        coursename={coursename}
                        activeid2={activeid2}
                        linkedclass={linkedclass}
                        location2={location2}
                      />
                    </ErrorBoundary>
                  );
                } else {
                  return (
                    null
                  );
                }


              } catch (error) {
                console.error('Error in conditional rendering logic:', error);
                return (
                  <div className="error-message">
                    Rendering Error: {error.message}
                    <button onClick={() => setShowcurrentroster(!showcurrentroster)}>
                      Toggle View
                    </button>
                  </div>
                );
              }
            })()}
          </ErrorBoundary>
        </header>
      </div>

      {
        showUpdateModal && (
          <div style={{
            position: "fixed",
            top: 0, left: 0, width: "100vw", height: "100vh",
            background: "rgba(0,0,0,0.5)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 9999
          }}>
            <div style={{
              background: "#000",
              padding: "32px 24px",
              borderRadius: "12px",
              boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
              textAlign: "center",
              minWidth: "260px",
              maxWidth: "90vw",
              color: "#fff"
            }}>
              <div style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px" }}>
                {updateSummary}
              </div>
              <div style={{ marginBottom: "16px" }}>
                {notFoundStudents.length > 0 ? (
                  <>
                    <div style={{ marginBottom: "10px" }}>Students not found:</div>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                      {notFoundStudents.map((student, idx) => (
                        <li key={student.id || idx} style={{ marginBottom: "8px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <span>{student.localfirstname} {student.locallastname}</span>
                          <button
                            style={{
                              margin: "8px",
                              padding: "10px 18px",
                              fontSize: "18px",
                              minWidth: "100px",
                              borderRadius: "6px",
                              display: "inline-block",
                              marginLeft: "auto",
                              border: "4px solid #e43522",
                              background: "#013469",
                              color: "#fff",
                              cursor: "pointer",
                              transition: "background 0.2s"
                            }}
                            onMouseOver={e => e.currentTarget.style.background = "#0256a6"}
                            onMouseOut={e => e.currentTarget.style.background = "#013469"}
                            onClick={() => { handleRemoveStudent(student) }}
                          >
                            Remove
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <div style={{ fontSize: "20px" }}>All students were found and updated.</div>
                )}
              </div>
              <button
                style={{
                  padding: "10px 18px",
                  fontSize: "18px",
                  minWidth: "100px",
                  borderRadius: "6px",
                  display: "inline-block",
                  border: "4px solid #e43522",
                  background: "#013469",
                  color: "#fff",
                  cursor: "pointer",
                  transition: "background 0.2s",
                  marginBottom: "12px"
                }}
                onMouseOver={e => e.currentTarget.style.background = "#0256a6"}
                onMouseOut={e => e.currentTarget.style.background = "#013469"}
                onClick={handleRemoveAllStudents}
              >
                Remove All
              </button>
              <button
                style={{
                  marginTop: "16px",
                  padding: "10px 18px",
                  borderRadius: "6px",
                  border: "none",
                  background: "#ccc",
                  color: "#333",
                  cursor: "pointer",
                  marginLeft: "8px",
                  fontSize: "18px",
                }}
                onClick={() => setShowUpdateModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )
      }
    </div >

  );
}

export default App;